import { motion } from 'framer-motion'
import React from 'react'
interface IconProps {
  className?: string
  fill?: string
  stroke?: string
  onClick?: () => void
  opacity?: string
}

export const SearchIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-[1.125rem] h-[1.125rem] fill-none text-black'
  return (
    <svg className={combinedClasses} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.755 11.2549H11.965L11.685 10.9849C12.665 9.84488 13.255 8.36488 13.255 6.75488C13.255 3.16488 10.345 0.254883 6.755 0.254883C3.165 0.254883 0.255005 3.16488 0.255005 6.75488C0.255005 10.3449 3.165 13.2549 6.755 13.2549C8.365 13.2549 9.845 12.6649 10.985 11.6849L11.255 11.9649V12.7549L16.255 17.7449L17.745 16.2549L12.755 11.2549ZM6.755 11.2549C4.26501 11.2549 2.255 9.24488 2.255 6.75488C2.255 4.26488 4.26501 2.25488 6.755 2.25488C9.245 2.25488 11.255 4.26488 11.255 6.75488C11.255 9.24488 9.245 11.2549 6.755 11.2549Z"
        // fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const SignOutIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-none'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z"
        fill="black"
        fillOpacity={0.54}
      />
    </svg>
  )
}

export const SignOutIconNew = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-none'
  return (
    <svg viewBox="0 0 24 22" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 5.16667L8.86667 6.8L11.9 9.83333H0L0 12.1667H11.9L8.86667 15.2L10.5 16.8333L16.3333 11L10.5 5.16667ZM21 19.1667H11.6667V21.5H21C22.2833 21.5 23.3333 20.45 23.3333 19.1667V2.83333C23.3333 1.55 22.2833 0.5 21 0.5L11.6667 0.5V2.83333L21 2.83333V19.1667Z" />
    </svg>
  )
}

export const NotifyIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-12 h-12 black'
  return (
    <svg viewBox="0 0 24 24" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21.75C13.1 21.75 14 20.85 14 19.75H10C10 20.85 10.89 21.75 12 21.75ZM18 15.75V10.75C18 7.68 16.36 5.11 13.5 4.43V3.75C13.5 2.92 12.83 2.25 12 2.25C11.17 2.25 10.5 2.92 10.5 3.75V4.43C7.63 5.11 6 7.67 6 10.75V15.75L4 17.75V18.75H20V17.75L18 15.75Z" />
    </svg>
  )
}

export const Avatar = ({ className }: IconProps) => (
  <svg
    className={className || 'w-8 h-8 fill-none'}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#5C6BC0" />
    <path
      d="M11.8597 17.6797V9.625H13.3597V17.6797C13.3597 18.4297 13.206 19.0625 12.8988 19.5781C12.5915 20.0938 12.167 20.487 11.6253 20.7578C11.0889 21.0234 10.4717 21.1562 9.77375 21.1562C9.07583 21.1562 8.45604 21.0365 7.91438 20.7969C7.37271 20.5573 6.94823 20.1927 6.64094 19.7031C6.33365 19.2135 6.18 18.5964 6.18 17.8516H7.68781C7.68781 18.3307 7.77635 18.724 7.95344 19.0312C8.13052 19.3385 8.37531 19.5651 8.68781 19.7109C9.00552 19.8568 9.3675 19.9297 9.77375 19.9297C10.1696 19.9297 10.5238 19.8464 10.8363 19.6797C11.154 19.5078 11.404 19.2552 11.5863 18.9219C11.7685 18.5833 11.8597 18.1693 11.8597 17.6797ZM19.1325 21H16.7575L16.7731 19.7734H19.1325C19.945 19.7734 20.6221 19.6042 21.1638 19.2656C21.7054 18.9219 22.1117 18.4427 22.3825 17.8281C22.6585 17.2083 22.7966 16.4844 22.7966 15.6562V14.9609C22.7966 14.3099 22.7184 13.7318 22.5622 13.2266C22.4059 12.7161 22.1768 12.2865 21.8747 11.9375C21.5726 11.5833 21.2028 11.3151 20.7653 11.1328C20.333 10.9505 19.8356 10.8594 19.2731 10.8594H16.7106V9.625H19.2731C20.0179 9.625 20.6976 9.75 21.3122 10C21.9268 10.2448 22.4554 10.6016 22.8981 11.0703C23.346 11.5339 23.6898 12.0964 23.9294 12.7578C24.169 13.4141 24.2888 14.1536 24.2888 14.9766V15.6562C24.2888 16.4792 24.169 17.2214 23.9294 17.8828C23.6898 18.5391 23.3434 19.099 22.8903 19.5625C22.4424 20.026 21.9007 20.3828 21.2653 20.6328C20.6351 20.8776 19.9242 21 19.1325 21ZM17.5622 9.625V21H16.0544V9.625H17.5622Z"
      fill="white"
    />
  </svg>
)

export const ArrowIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'fill-none'}
    viewBox="0 0 8 12"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth="2"
  >
    <path d="M0.785889 10.7426L1.81839 11.7751L7.59339 6.0001L1.81839 0.225098L0.785889 1.2576L5.52839 6.0001L0.785889 10.7426Z" />
  </svg>
)

export const LogoIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="548"
      height="182"
      fill="none"
      className={combinedClasses}
      viewBox="0 0 548 182"
    >
      <path
        fill="#07004D"
        fillRule="evenodd"
        d="m51.965 58.09 1.555-6.046 30.152 6.814 31.725-25.844 4.765 4.63-34.466 27.947z"
        clipRule="evenodd"
      ></path>
      <circle cx="53.179" cy="55.996" r="9.291" fill="#07004D"></circle>
      <path
        fill="url(#paint0_linear_641_7115)"
        d="M38.671 82.39c0-5.398 4.376-9.773 9.773-9.773h9.47c5.398 0 9.773 4.375 9.773 9.772v39.3c0 5.398-4.375 9.773-9.773 9.773h-9.47c-5.397 0-9.773-4.375-9.773-9.773z"
      ></path>
      <circle cx="85.292" cy="62.19" r="9.291" fill="#07004D"></circle>
      <path
        fill="url(#paint1_linear_641_7115)"
        d="M70.784 88.584c0-5.398 4.376-9.773 9.773-9.773h9.47c5.397 0 9.773 4.375 9.773 9.773v33.105c0 5.398-4.376 9.773-9.773 9.773h-9.47c-5.397 0-9.773-4.375-9.773-9.773z"
      ></path>
      <circle cx="117.405" cy="36.193" r="9.291" fill="#07004D"></circle>
      <path
        fill="url(#paint2_linear_641_7115)"
        d="M102.897 63.807c0-5.398 4.375-9.773 9.773-9.773h9.47c5.397 0 9.773 4.375 9.773 9.773v57.882c0 5.398-4.376 9.773-9.773 9.773h-9.47a9.77 9.77 0 0 1-9.773-9.773z"
      ></path>
      <path
        fill="#07004D"
        d="M452.926 61.013h12.693V38.316h21.614v22.697h16.639v18.096h-16.639v25.473q0 5.06 1.629 7.891 1.63 2.745 5.146 2.744 2.66 0 4.374-1.029 1.716-1.115 2.059-1.544l7.719 15.61q-.515.514-3.345 1.801-2.745 1.287-7.119 2.316-4.288 1.115-9.691 1.115-9.693 0-16.039-5.575-6.347-5.66-6.347-17.497V79.109h-12.693z"
      ></path>
      <path fill="url(#paint3_linear_641_7115)" d="M428.266 131.427V61.013h21.699v70.414z"></path>
      <path
        fill="url(#paint4_linear_641_7115)"
        d="M402.371 131.427v-12.264q-.772 1.887-3.945 5.317t-8.577 6.261q-5.318 2.745-12.522 2.745-10.12 0-17.925-4.803-7.806-4.889-12.265-13.294-4.374-8.491-4.374-19.126t4.374-19.04q4.46-8.492 12.265-13.38 7.804-4.89 17.925-4.889 7.032 0 12.179 2.402 5.231 2.315 8.405 5.489 3.26 3.087 4.203 5.575V61.013h21.613v70.414zm-38.252-35.164q0 5.918 2.659 10.463 2.658 4.46 7.032 6.948 4.375 2.487 9.521 2.487 5.403 0 9.606-2.487 4.202-2.574 6.604-7.033 2.487-4.546 2.487-10.378t-2.487-10.292q-2.402-4.546-6.604-7.119-4.203-2.573-9.606-2.573-5.146 0-9.521 2.573-4.374 2.487-7.032 7.033-2.66 4.46-2.659 10.378"
      ></path>
      <path
        fill="url(#paint5_linear_641_7115)"
        d="M430.239 52.129q3.774 3.774 9.177 3.774 5.317 0 9.091-3.774 3.86-3.774 3.86-9.006 0-3.602-1.801-6.518a13.55 13.55 0 0 0-4.717-4.632q-2.917-1.8-6.433-1.8-5.317 0-9.091 3.859t-3.774 9.091 3.688 9.006"
      ></path>
      <path
        fill="#07004D"
        d="M339.801 131.428H317.93V38.202h21.871zM262.146 101.065q.257 4.803 2.573 8.577t6.69 5.918q4.46 2.144 10.635 2.144 5.574 0 9.777-1.372 4.289-1.373 7.205-3.345 3.001-2.058 4.459-3.945l9.006 13.379q-2.401 3.003-6.433 5.575-3.945 2.487-10.12 3.946-6.09 1.543-15.267 1.543-11.578 0-20.326-4.545-8.749-4.546-13.637-13.123-4.89-8.576-4.889-20.412 0-10.293 4.374-18.526 4.374-8.319 12.694-13.122 8.404-4.803 20.155-4.803 11.064 0 19.126 4.288 8.148 4.203 12.608 12.35 4.46 8.148 4.46 19.899 0 .685-.086 2.83 0 2.058-.172 2.744zM294.823 87.6q-.086-2.745-1.715-5.918-1.544-3.174-4.889-5.403-3.345-2.23-8.92-2.23t-9.177 2.144q-3.516 2.145-5.318 5.317-1.8 3.088-2.058 6.09z"
      ></path>
      <path
        fill="#07004D"
        d="M167.426 38.258h43.57c20.047 0 30.72 14.677 30.774 30.775.045 13.165-7.624 24.9-20.568 28.545l21.582 33.841h-24.186l-18.924-32.212h-10.892v32.212h-21.356zm21.356 45.854h11.228c12.202 0 19.852-4.361 19.804-14.478-.049-10.168-7.391-14.222-19.804-14.222h-11.228z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_641_7115"
          x1="52.173"
          x2="87.477"
          y1="86.486"
          y2="112.476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07004D"></stop>
          <stop offset="1" stopColor="#ADA0FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_641_7115"
          x1="84.286"
          x2="116.747"
          y1="91.22"
          y2="117.929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07004D"></stop>
          <stop offset="1" stopColor="#ADA0FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_641_7115"
          x1="116.399"
          x2="157.857"
          y1="72.282"
          y2="95.479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07004D"></stop>
          <stop offset="1" stopColor="#ADA0FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_641_7115"
          x1="393.764"
          x2="452.367"
          y1="54.522"
          y2="147.346"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07004D"></stop>
          <stop offset="1" stopColor="#ADA0FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_641_7115"
          x1="393.764"
          x2="452.367"
          y1="54.522"
          y2="147.346"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07004D"></stop>
          <stop offset="1" stopColor="#ADA0FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_641_7115"
          x1="393.764"
          x2="452.367"
          y1="54.522"
          y2="147.346"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07004D"></stop>
          <stop offset="1" stopColor="#ADA0FF"></stop>
        </linearGradient>
      </defs>
    </svg>
  )
}

export const HomeIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 16 16"
      // fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_20815_14103)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2792 4.66581L9.39731 1.79081C8.57312 1.18041 7.42696 1.18041 6.60277 1.79081L2.72084 4.66582C2.71678 4.66876 2.71275 4.67175 2.70876 4.67477L0.269934 6.481C-0.0259451 6.70014 -0.0881607 7.11764 0.130972 7.41351C0.350104 7.70939 0.767604 7.77161 1.06348 7.55248L2.44449 6.52969V12.4479C2.44449 13.7035 3.50371 14.6663 4.74078 14.6663H11.2593C12.4964 14.6663 13.5556 13.7035 13.5556 12.4479V6.52969L14.9366 7.55248C15.2325 7.77161 15.65 7.70939 15.8691 7.41351C16.0882 7.11764 16.026 6.70014 15.7302 6.481L13.2913 4.67479C13.2873 4.67175 13.2833 4.66876 13.2792 4.66581Z"
          // fill="black"
          // fillOpacity="0.56"
        />
      </g>
      <defs>
        <clipPath id="clip0_20815_14103">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const AnnouncementSingleIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_24700_8461)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2792 8.6663L13.3973 5.7913C12.5731 5.18089 11.4269 5.18089 10.6027 5.7913L6.72078 8.66631C6.71672 8.66925 6.71269 8.67223 6.7087 8.67526L4.26987 10.4815C3.97399 10.7006 3.91178 11.1181 4.13091 11.414C4.35004 11.7099 4.76754 11.7721 5.06342 11.553L6.44443 10.5302V16.4484C6.44443 17.704 7.50365 18.6668 8.74072 18.6668H15.2592C16.4963 18.6668 17.5555 17.704 17.5555 16.4484V10.5302L18.9365 11.553C19.2324 11.7721 19.6499 11.7099 19.8691 11.414C20.0882 11.1181 20.026 10.7006 19.7301 10.4815L17.2913 8.67527C17.2873 8.67224 17.2832 8.66925 17.2792 8.6663Z"
          fill="#07004D"
        />
      </g>
      <defs>
        <clipPath id="clip0_24700_8461">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const CategoryIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#07004D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3787 1.25759C14.5503 0.0860132 16.4497 0.086013 17.6213 1.25759L19.7426 3.37891C20.9142 4.55048 20.9142 6.44997 19.7426 7.62155L17.6213 9.74287C16.4497 10.9144 14.5503 10.9144 13.3787 9.74287L11.2574 7.62155C10.0858 6.44997 10.0858 4.55048 11.2574 3.37891L13.3787 1.25759ZM16.2071 2.6718C15.8166 2.28128 15.1834 2.28128 14.7929 2.6718L12.6716 4.79312C12.281 5.18364 12.281 5.81681 12.6716 6.20733L14.7929 8.32865C15.1834 8.71918 15.8166 8.71918 16.2071 8.32865L18.3284 6.20733C18.719 5.81681 18.719 5.18364 18.3284 4.79312L16.2071 2.6718ZM0 4.00023C0 2.34337 1.34315 1.00023 3 1.00023H6C7.65685 1.00023 9 2.34337 9 4.00023V7.00023C9 8.65708 7.65685 10.0002 6 10.0002H3C1.34315 10.0002 0 8.65708 0 7.00023V4.00023ZM3 3.00023C2.44772 3.00023 2 3.44794 2 4.00023V7.00023C2 7.55251 2.44772 8.00023 3 8.00023H6C6.55228 8.00023 7 7.55251 7 7.00023V4.00023C7 3.44794 6.55228 3.00023 6 3.00023H3ZM0 15.0002C0 13.3434 1.34315 12.0002 3 12.0002H6C7.65685 12.0002 9 13.3434 9 15.0002V18.0002C9 19.6571 7.65685 21.0002 6 21.0002H3C1.34315 21.0002 0 19.6571 0 18.0002V15.0002ZM3 14.0002C2.44772 14.0002 2 14.4479 2 15.0002V18.0002C2 18.5525 2.44772 19.0002 3 19.0002H6C6.55228 19.0002 7 18.5525 7 18.0002V15.0002C7 14.4479 6.55229 14.0002 6 14.0002H3ZM11 15.0002C11 13.3434 12.3431 12.0002 14 12.0002H17C18.6569 12.0002 20 13.3434 20 15.0002V18.0002C20 19.6571 18.6569 21.0002 17 21.0002H14C12.3431 21.0002 11 19.6571 11 18.0002V15.0002ZM14 14.0002C13.4477 14.0002 13 14.4479 13 15.0002V18.0002C13 18.5525 13.4477 19.0002 14 19.0002H17C17.5523 19.0002 18 18.5525 18 18.0002V15.0002C18 14.4479 17.5523 14.0002 17 14.0002H14Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const NewDateIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#07004D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0889 2.39453C5.67059 2.39453 2.08887 5.97625 2.08887 10.3945C2.08887 14.8128 5.67059 18.3945 10.0889 18.3945C14.5071 18.3945 18.0889 14.8128 18.0889 10.3945C18.0889 5.97625 14.5071 2.39453 10.0889 2.39453ZM0.0888672 10.3945C0.0888672 4.87168 4.56602 0.394531 10.0889 0.394531C15.6117 0.394531 20.0889 4.87168 20.0889 10.3945C20.0889 15.9174 15.6117 20.3945 10.0889 20.3945C4.56602 20.3945 0.0888672 15.9174 0.0888672 10.3945ZM10.0001 5.9999C10.5524 5.9999 11.0001 6.44762 11.0001 6.9999V10.4226L12.2321 11.1339C12.7104 11.41 12.8742 12.0216 12.5981 12.4999C12.3219 12.9782 11.7103 13.1421 11.2321 12.8659L9.00014 11.5772V6.9999C9.00014 6.44762 9.44786 5.9999 10.0001 5.9999Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const CalanderIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#07004D]'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 20 22"
      // fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C6.55229 0 7 0.447715 7 1V2.00008C7.11646 2 7.23551 2 7.35719 2H12.6428C12.7645 2 12.8835 2 13 2.00008V1C13 0.447715 13.4477 0 14 0C14.5523 0 15 0.447715 15 1V2.03669C15.1062 2.0427 15.2091 2.04968 15.3086 2.05782C16.0375 2.11737 16.6777 2.24318 17.27 2.54497C18.2108 3.02433 18.9757 3.78924 19.455 4.73005C19.7568 5.32234 19.8826 5.96253 19.9422 6.69138C19.9933 7.31672 19.9992 8.07182 19.9999 8.98657C20 8.99104 20 8.99552 20 9C20 9.00401 20 9.00801 19.9999 9.01201C20 9.12463 20 9.23967 20 9.35717V14.6428C20 15.7266 20 16.6007 19.9422 17.3086C19.8826 18.0375 19.7568 18.6777 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.6777 21.7568 16.0375 21.8826 15.3086 21.9422C14.6008 22 13.7266 22 12.6428 22H7.35717C6.27339 22 5.39925 22 4.69138 21.9422C3.96253 21.8826 3.32234 21.7568 2.73005 21.455C1.78924 20.9757 1.02433 20.2108 0.544968 19.27C0.24318 18.6777 0.117368 18.0375 0.0578183 17.3086C-1.77398e-05 16.6007 -9.75112e-06 15.7266 2.62457e-07 14.6428V9.35719C-8.10426e-07 9.23968 -1.88331e-06 9.12463 7.08344e-05 9.01198C2.39851e-05 9.00799 5.00876e-07 9.004 5.00876e-07 9C5.00876e-07 8.99553 2.99456e-05 8.99106 8.85369e-05 8.9866C0.000774706 8.07183 0.00672539 7.31672 0.0578183 6.69138C0.117368 5.96253 0.24318 5.32234 0.544968 4.73005C1.02433 3.78924 1.78924 3.02433 2.73005 2.54497C3.32234 2.24318 3.96253 2.11737 4.69138 2.05782C4.79092 2.04968 4.89376 2.0427 5 2.03669V1C5 0.447715 5.44772 0 6 0ZM5 4.04039C4.95032 4.0437 4.90176 4.04729 4.85424 4.05118C4.24907 4.10062 3.90138 4.19279 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2.19279 5.90138 2.10062 6.24907 2.05118 6.85424C2.02462 7.17922 2.01184 7.55291 2.0057 8H17.9943C17.9882 7.55292 17.9754 7.17922 17.9488 6.85424C17.8994 6.24907 17.8072 5.90138 17.673 5.63803C17.3854 5.07354 16.9265 4.6146 16.362 4.32698C16.0986 4.19279 15.7509 4.10062 15.1458 4.05118C15.0982 4.04729 15.0497 4.0437 15 4.04039V5C15 5.55228 14.5523 6 14 6C13.4477 6 13 5.55228 13 5V4.00012C12.8716 4.00001 12.7383 4 12.6 4H7.4C7.26167 4 7.12844 4.00001 7 4.00012V5C7 5.55228 6.55229 6 6 6C5.44772 6 5 5.55228 5 5V4.04039ZM18 10H2V14.6C2 15.7366 2.00078 16.5289 2.05118 17.1458C2.10062 17.7509 2.19279 18.0986 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C3.90138 19.8072 4.24907 19.8994 4.85424 19.9488C5.47108 19.9992 6.26339 20 7.4 20H12.6C13.7366 20 14.5289 19.9992 15.1458 19.9488C15.7509 19.8994 16.0986 19.8072 16.362 19.673C16.9265 19.3854 17.3854 18.9265 17.673 18.362C17.8072 18.0986 17.8994 17.7509 17.9488 17.1458C17.9992 16.5289 18 15.7366 18 14.6V10Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const PinIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 40 40"
      // fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8157 10.6141C21.0985 9.48295 22.5071 9.09277 23.3315 9.91722L30.0827 16.6683C30.9071 17.4928 30.5169 18.9014 29.3858 19.1842L26.78 19.8357C26.6041 19.8796 26.4436 19.9705 26.3154 20.0987L24.1785 22.2356C24.0255 22.3886 23.9263 22.5871 23.8957 22.8013L23.0465 28.7453C22.9067 29.7243 21.7093 30.1234 21.0101 29.4241L16.5 24.9141L11.7071 29.707C11.3166 30.0975 10.6834 30.0975 10.2929 29.707C9.90237 29.3165 9.90237 28.6833 10.2929 28.2928L15.0858 23.4999L10.5757 18.9898C9.87651 18.2906 10.2756 17.0932 11.2546 16.9534L17.1986 16.1042C17.4128 16.0736 17.6113 15.9744 17.7643 15.8214L19.9012 13.6845C20.0293 13.5563 20.1203 13.3958 20.1642 13.2199L20.8157 10.6141Z"
        // fill="black"
        // fillOpacity="0.56"
      />
    </svg>
  )
}

export const OutlinedPinIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7766 2.09743C12.0896 1.41039 10.9157 1.73554 10.6801 2.67814L10.1372 4.84968C10.1005 4.9962 10.0248 5.13002 9.91797 5.23682L8.13724 7.01755C8.00974 7.14505 7.84433 7.22776 7.66584 7.25326L2.71246 7.96088C1.89669 8.07742 1.56408 9.07525 2.14677 9.65794L5.90515 13.4163L1.91107 17.4104C1.58563 17.7358 1.58563 18.2635 1.91107 18.5889C2.23651 18.9143 2.76414 18.9143 3.08958 18.5889L7.08366 14.5948L10.842 18.3532C11.4247 18.9359 12.4226 18.6033 12.5391 17.7875L13.2467 12.8341C13.2722 12.6556 13.3549 12.4902 13.4824 12.3627L15.2632 10.582C15.37 10.4752 15.5038 10.3994 15.6503 10.3628L17.8218 9.81992C18.7644 9.58426 19.0896 8.41039 18.4025 7.72336L12.7766 2.09743ZM12.1185 3.79631L11.7541 5.2539C11.6442 5.69348 11.4169 6.09493 11.0965 6.41533L9.31575 8.19606C8.93326 8.57856 8.43703 8.82667 7.90154 8.90317L4.26809 9.42223L11.0777 16.2319L11.5968 12.5984C11.6733 12.0629 11.9214 11.5667 12.3039 11.1842L14.0846 9.40349C14.405 9.08309 14.8065 8.85579 15.2461 8.7459L16.7037 8.3815L12.1185 3.79631Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const FilledPinIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg className={combinedClasses} viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6801 2.67814C10.9157 1.73554 12.0896 1.41039 12.7766 2.09743L18.4025 7.72336C19.0896 8.41039 18.7644 9.58426 17.8218 9.81992L15.6503 10.3628C15.5038 10.3994 15.37 10.4752 15.2632 10.582L13.4824 12.3627C13.3549 12.4902 13.2722 12.6556 13.2467 12.8341L12.5391 17.7875C12.4226 18.6033 11.4247 18.9359 10.842 18.3532L7.08366 14.5948L3.08958 18.5889C2.76414 18.9143 2.23651 18.9143 1.91107 18.5889C1.58563 18.2635 1.58563 17.7358 1.91107 17.4104L5.90515 13.4163L2.14677 9.65794C1.56408 9.07525 1.89669 8.07742 2.71246 7.96088L7.66584 7.25326C7.84433 7.22776 8.00974 7.14505 8.13724 7.01755L9.91797 5.23682C10.0248 5.13002 10.1005 4.9962 10.1372 4.84968L10.6801 2.67814Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const DoubleDashIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 18C11 17.4477 11.4477 17 12 17H28C28.5523 17 29 17.4477 29 18C29 18.5523 28.5523 19 28 19H12C11.4477 19 11 18.5523 11 18ZM11 22C11 21.4477 11.4477 21 12 21L28 21C28.5523 21 29 21.4477 29 22C29 22.5523 28.5523 23 28 23L12 23C11.4477 23 11 22.5523 11 22Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const BoardDoubleDashIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 10C3 9.44772 3.44772 9 4 9H20C20.5523 9 21 9.44772 21 10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10ZM3 14C3 13.4477 3.44772 13 4 13L20 13C20.5523 13 21 13.4477 21 14C21 14.5523 20.5523 15 20 15L4 15C3.44772 15 3 14.5523 3 14Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const DocIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#6D6E6E]'
  return (
    <svg viewBox="0 0 18 18" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM11 14H4V12H11V14ZM14 10H4V8H14V10ZM14 6H4V4H14V6Z" />
    </svg>
  )
}
export const DocIconNew = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#6D6E6E]'
  return (
    <svg className={combinedClasses} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.33333 4.99967H0L0 21.333C0 22.6163 1.05 23.6663 2.33333 23.6663H18.6667V21.333H2.33333L2.33333 4.99967ZM21 0.333008L7 0.333008C5.71667 0.333008 4.66667 1.38301 4.66667 2.66634L4.66667 16.6663C4.66667 17.9497 5.71667 18.9997 7 18.9997H21C22.2833 18.9997 23.3333 17.9497 23.3333 16.6663V2.66634C23.3333 1.38301 22.2833 0.333008 21 0.333008ZM19.8333 10.833L8.16667 10.833V8.49967L19.8333 8.49967V10.833ZM15.1667 15.4997H8.16667V13.1663H15.1667V15.4997ZM19.8333 6.16634H8.16667V3.83301L19.8333 3.83301V6.16634Z" />
    </svg>
  )
}

export const LikeIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-3 h-3 fill-none'
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.75 15.75H13.5C14.1225 15.75 14.655 15.375 14.88 14.835L17.145 9.5475C17.2125 9.375 17.25 9.195 17.25 9V7.5C17.25 6.675 16.575 6 15.75 6H11.0175L11.73 2.5725L11.7525 2.3325C11.7525 2.025 11.625 1.74 11.4225 1.5375L10.6275 0.75L5.685 5.6925C5.415 5.9625 5.25 6.3375 5.25 6.75V14.25C5.25 15.075 5.925 15.75 6.75 15.75ZM6.75 6.75L10.005 3.495L9 7.5H15.75V9L13.5 14.25H6.75V6.75ZM0.75 6.75H3.75V15.75H0.75V6.75Z"
        fill="#424242"
      />
    </svg>
  )
}

export const NewLikeIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-3 h-3 fill-none'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.3252 8.33602V6.82625C12.3252 5.95973 11.9658 5.11992 11.3125 4.49422C11.2768 4.46009 11.2228 4.43875 11.1572 4.44539C11.0917 4.45214 11.0494 4.48285 11.0273 4.51571L7.00684 10.5059C6.8735 10.7046 6.8047 10.9317 6.80469 11.1602V18.3165C6.80469 18.9627 7.36448 19.5557 8.14062 19.5557H17.1328C17.79 19.5557 18.3143 19.1206 18.4395 18.5733L20.0244 11.6339C20.0316 11.6025 20.0264 11.5703 19.9961 11.5343C19.9646 11.4968 19.9103 11.4641 19.832 11.4639H15.5488C13.8072 11.4639 12.3254 10.1013 12.3252 8.33602ZM2.08301 19.5557V11.0557C2.08301 10.5341 2.50574 10.1114 3.02734 10.1114C3.54895 10.1114 3.97168 10.5341 3.97168 11.0557V19.5557C3.97162 20.0773 3.54891 20.5001 3.02734 20.5001C2.50578 20.5001 2.08307 20.0773 2.08301 19.5557ZM14.2139 8.33602C14.214 8.98217 14.7728 9.5743 15.5488 9.5743H19.832C21.1134 9.57458 22.1682 10.7327 21.8662 12.0548L20.2812 18.9932C19.9484 20.4505 18.618 21.4444 17.1328 21.4444H8.14062C6.39886 21.4444 4.91602 20.0819 4.91602 18.3165V11.1602C4.91603 10.5516 5.09911 9.95884 5.43848 9.45321L9.45898 3.46297C10.1755 2.39567 11.7014 2.25103 12.6191 3.12997C13.635 4.103 14.2139 5.43184 14.2139 6.82625V8.33602Z"
        fill="#07004D"
      />
    </svg>
  )
}

export const LikeFullIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-3 h-3 fill-none'
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 15.75H3.75V6.75H0.75V15.75ZM17.25 7.5C17.25 6.675 16.575 6 15.75 6H11.0175L11.73 2.5725L11.7525 2.3325C11.7525 2.025 11.625 1.74 11.4225 1.5375L10.6275 0.75L5.6925 5.6925C5.415 5.9625 5.25 6.3375 5.25 6.75V14.25C5.25 15.075 5.925 15.75 6.75 15.75H13.5C14.1225 15.75 14.655 15.375 14.88 14.835L17.145 9.5475C17.2125 9.375 17.25 9.195 17.25 9V7.5Z"
        fill="#46586B"
      />
    </svg>
  )
}

export const EyeIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-3 h-2 fill-none'
  return (
    <svg className={combinedClasses} viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 0.25C3.5 0.25 1.365 1.805 0.5 4C1.365 6.195 3.5 7.75 6 7.75C8.5 7.75 10.635 6.195 11.5 4C10.635 1.805 8.5 0.25 6 0.25ZM6 6.5C4.62 6.5 3.5 5.38 3.5 4C3.5 2.62 4.62 1.5 6 1.5C7.38 1.5 8.5 2.62 8.5 4C8.5 5.38 7.38 6.5 6 6.5ZM6 2.5C5.17 2.5 4.5 3.17 4.5 4C4.5 4.83 5.17 5.5 6 5.5C6.83 5.5 7.5 4.83 7.5 4C7.5 3.17 6.83 2.5 6 2.5Z"
        // fill="black"
        // fillOpacity="0.56"
      />
    </svg>
  )
}

export const CommentIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-2.5 h-2.5 fill-none'
  return (
    <svg className={combinedClasses} viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.5 1V4.5H1.585L1 5.085V1H6.5ZM7 0H0.5C0.225 0 0 0.225 0 0.5V7.5L2 5.5H7C7.275 5.5 7.5 5.275 7.5 5V0.5C7.5 0.225 7.275 0 7 0ZM9.5 2H8.5V6.5H2V7.5C2 7.775 2.225 8 2.5 8H8L10 10V2.5C10 2.225 9.775 2 9.5 2Z" />
    </svg>
  )
}

export const NewCommentIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-2.5 h-2.5 fill-none'
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 7C12 9.76142 9.76142 12 7 12H2.48275C2.24954 12 2.08841 11.7667 2.17104 11.5486L2.59841 10.4206C2.75123 10.0173 2.68847 9.57003 2.50001 9.18207C2.17967 8.52269 2 7.78233 2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7Z"
        fill="black"
        fillOpacity="0.56"
      />
      <path
        d="M7 13.3333C10.4978 13.3333 13.3333 10.4978 13.3333 7C13.3333 6.82008 13.3258 6.64192 13.3111 6.4658C13.7489 7.20891 14 8.07513 14 9C14 9.78233 13.8203 10.5227 13.5 11.1821C13.3115 11.57 13.2488 12.0173 13.4016 12.4206L13.829 13.5486C13.9116 13.7667 13.7505 14 13.5172 14H9C8.09088 14 7.23844 13.7574 6.50388 13.3333H7Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const DashboardIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-white'
  return (
    <svg className={combinedClasses} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0H8V18ZM10 18H16C17.1 18 18 17.1 18 16V9H10V18ZM18 7V2C18 0.9 17.1 0 16 0H10V7H18Z" />
    </svg>
  )
}

export const QuestionIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-5 w-5 fill-[#6D6E6E]'
  return (
    <svg viewBox="0 0 20 20" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 17H9V15H11V17ZM13.07 9.25L12.17 10.17C11.45 10.9 11 11.5 11 13H9V12.5C9 11.4 9.45 10.4 10.17 9.67L11.41 8.41C11.78 8.05 12 7.55 12 7C12 5.9 11.1 5 10 5C8.9 5 8 5.9 8 7H6C6 4.79 7.79 3 10 3C12.21 3 14 4.79 14 7C14 7.88 13.64 8.68 13.07 9.25Z" />
    </svg>
  )
}

export const NewQuestionIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-primary-main'
  return (
    <svg className={combinedClasses} viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3333 2.66667C6.54687 2.66667 2.66667 6.54687 2.66667 11.3333C2.66667 12.6918 2.97826 13.9737 3.53264 15.1149C4.02497 16.1283 4.24514 17.4114 3.77699 18.647L3.26434 20H11.3333C16.1198 20 20 16.1198 20 11.3333C20 6.54687 16.1198 2.66667 11.3333 2.66667ZM0 11.3333C0 5.07411 5.07411 0 11.3333 0C17.5926 0 22.6667 5.07411 22.6667 11.3333C22.6667 17.5926 17.5926 22.6667 11.3333 22.6667H2.29884C0.899533 22.6667 -0.0672034 21.2666 0.428582 19.958L1.28332 17.7021C1.42644 17.3244 1.39559 16.8185 1.13404 16.2801C0.407095 14.7837 0 13.1042 0 11.3333ZM25.3333 13.3332C26.0697 13.3332 26.6667 13.9302 26.6667 14.6666C26.6667 15.7559 26.3103 16.8359 25.8952 17.7431C25.4728 18.6663 24.9422 19.5115 24.493 20.1567C24.1438 20.6582 24.0711 21.2345 24.2413 21.6838L24.9048 23.4348C25.4005 24.7434 24.4338 26.1434 23.0345 26.1434H14.6667C13.9303 26.1434 13.3333 25.5465 13.3333 24.8101C13.3333 24.0737 13.9303 23.4768 14.6667 23.4768H22.069L21.7476 22.6287C21.2208 21.2382 21.5295 19.7461 22.3046 18.633C22.6999 18.0651 23.1367 17.3628 23.4703 16.6336C23.8114 15.8882 24 15.2106 24 14.6666C24 13.9302 24.597 13.3332 25.3333 13.3332Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const EmailFooterIcon = () => {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 14H2V4L10 9L18 4V14ZM10 7L2 2H18L10 7Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const EmailIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg viewBox="0 0 20 16" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 4L10 9L2 4V2L10 7L18 2V4Z" />
    </svg>
  )
}

export const AIPromptIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#4729FF]'
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={combinedClasses}>
      <path d="M13.5134 8.06095C13.6345 7.54739 14.3655 7.54739 14.4866 8.06095L15.3144 11.5689C15.4449 12.122 15.8767 12.5538 16.4298 12.6843L19.9377 13.5121C20.4513 13.6332 20.4513 14.3642 19.9377 14.4853L16.4298 15.3131C15.8767 15.4436 15.4449 15.8754 15.3144 16.4285L14.4866 19.9364C14.3655 20.45 13.6345 20.45 13.5134 19.9364L12.6856 16.4285C12.5551 15.8754 12.1233 15.4436 11.5702 15.3131L8.06229 14.4853C7.54873 14.3642 7.54873 13.6332 8.06229 13.5121L11.5702 12.6843C12.1233 12.5538 12.5551 12.122 12.6856 11.5689L13.5134 8.06095Z" />
      <path d="M6.30534 3.82594C6.35381 3.62052 6.64617 3.62052 6.69464 3.82594L7.21716 6.04026C7.30416 6.40897 7.59205 6.69686 7.96076 6.78386L10.1751 7.30638C10.3805 7.35485 10.3805 7.64721 10.1751 7.69568L7.96076 8.2182C7.59205 8.3052 7.30416 8.59309 7.21716 8.9618L6.69464 11.1761C6.64617 11.3815 6.35381 11.3815 6.30534 11.1761L5.78282 8.9618C5.69582 8.59309 5.40793 8.3052 5.03922 8.2182L2.8249 7.69568C2.61948 7.64721 2.61948 7.35485 2.8249 7.30638L5.03922 6.78386C5.40793 6.69686 5.69582 6.40897 5.78282 6.04026L6.30534 3.82594Z" />
      <path d="M13 4C13.5523 4 14 3.55228 14 3C14 2.44772 13.5523 2 13 2C12.4477 2 12 2.44772 12 3C12 3.55228 12.4477 4 13 4Z" />
    </svg>
  )
}

export const ListIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#0000008A]'
  return (
    <svg viewBox="0 0 18 14" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path d="M0 9H4V5H0V9ZM0 14H4V10H0V14ZM0 4H4V0H0V4ZM5 9H18V5H5V9ZM5 14H18V10H5V14ZM5 0V4H18V0H5Z" />
    </svg>
  )
}

export const SocialSharingIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-3 w-3 fill-[#0000008A]'
  return (
    <svg viewBox="0 0 56 57" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.6667 20.3333C32.6667 18.4003 34.2337 16.8333 36.1667 16.8333C38.0997 16.8333 39.6667 18.4003 39.6667 20.3333C39.6667 22.2663 38.0997 23.8333 36.1667 23.8333C34.2337 23.8333 32.6667 22.2663 32.6667 20.3333Z"
        // fill="#07004D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3333 20.3333C16.3333 18.4003 17.9003 16.8333 19.8333 16.8333C21.7663 16.8333 23.3333 18.4003 23.3333 20.3333C23.3333 22.2663 21.7663 23.8333 19.8333 23.8333C17.9003 23.8333 16.3333 22.2663 16.3333 20.3333Z"
        // fill="#07004D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7777 35.5289C20.3454 36.6779 21.1175 37.7827 22.2842 38.6189C23.468 39.4673 25.235 40.1667 28 40.1667C30.765 40.1667 32.532 39.4673 33.7158 38.6189C34.8825 37.7827 35.6546 36.6779 36.2223 35.5289C36.2133 35.5214 36.2038 35.5148 36.1944 35.5096C36.1766 35.4999 36.1687 35.5 36.1669 35.5L19.8333 35.5C19.8333 35.5 19.8334 35.5 19.8333 35.5C19.8315 35.5 19.8234 35.4999 19.8056 35.5096C19.7962 35.5148 19.7867 35.5214 19.7777 35.5289ZM15.5136 37.4315C13.9292 34.136 16.7306 30.8333 19.8333 30.8333H36.1667C39.2694 30.8333 42.0708 34.136 40.4864 37.4315C39.7065 39.0537 38.487 40.9408 36.4343 42.4119C34.3582 43.8999 31.6099 44.8333 28 44.8333C24.3901 44.8333 21.6418 43.8999 19.5657 42.4119C17.513 40.9408 16.2935 39.0537 15.5136 37.4315Z"
        // fill="#07004D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 5.16667C15.1134 5.16667 4.66667 15.6134 4.66667 28.5C4.66667 41.3866 15.1134 51.8333 28 51.8333C40.8866 51.8333 51.3333 41.3866 51.3333 28.5C51.3333 15.6134 40.8866 5.16667 28 5.16667ZM0 28.5C0 13.036 12.536 0.5 28 0.5C43.464 0.5 56 13.036 56 28.5C56 43.964 43.464 56.5 28 56.5C12.536 56.5 0 43.964 0 28.5Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const WidgetsIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-3 w-3 fill-[#0000008A]'
  return (
    <svg className={combinedClasses} viewBox="0 0 57 57" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3979 0.5H35.6021C38.7825 0.499981 41.3119 0.499966 43.3526 0.666699C45.4424 0.837437 47.2243 1.19458 48.8559 2.02591C51.4901 3.36814 53.6319 5.50987 54.9741 8.14413C55.8054 9.77571 56.1626 11.5576 56.3333 13.6473C56.4567 15.1582 56.4888 16.9368 56.4971 19.0492C56.499 19.0881 56.5 19.1273 56.5 19.1667C56.5 19.2004 56.4993 19.234 56.4979 19.2673C56.5 19.9432 56.5 20.6526 56.5 21.3978V28.5C56.5 29.7887 55.4553 30.8333 54.1667 30.8333C52.878 30.8333 51.8333 29.7887 51.8333 28.5V21.5H5.16667V35.5C5.16667 38.8055 5.16848 41.1442 5.31787 42.9726C5.46503 44.7738 5.74368 45.8732 6.18394 46.7372C7.07876 48.4934 8.50658 49.9212 10.2628 50.8161C11.1268 51.2563 12.2262 51.535 14.0274 51.6821C15.8557 51.8315 18.1945 51.8333 21.5 51.8333H28.5C29.7887 51.8333 30.8333 52.878 30.8333 54.1667C30.8333 55.4553 29.7887 56.5 28.5 56.5H21.3978C18.2174 56.5 15.688 56.5 13.6473 56.3333C11.5576 56.1626 9.77571 55.8054 8.14413 54.9741C5.50987 53.6319 3.36814 51.4901 2.02591 48.8559C1.19458 47.2243 0.837437 45.4424 0.666699 43.3526C0.499966 41.3119 0.499981 38.7825 0.5 35.6021V21.3979C0.499996 20.6527 0.499992 19.9432 0.502133 19.2673C0.500716 19.2339 0.500001 19.2004 0.500001 19.1667C0.500001 19.1273 0.500977 19.0881 0.502906 19.0492C0.511217 16.9368 0.543261 15.1582 0.666699 13.6474C0.837437 11.5576 1.19458 9.77571 2.02591 8.14413C3.36814 5.50986 5.50986 3.36814 8.14413 2.02591C9.77571 1.19458 11.5576 0.837437 13.6474 0.666699C15.6881 0.499966 18.2175 0.499981 21.3979 0.5ZM5.19284 16.8333H51.8072C51.7864 15.7682 51.7491 14.8466 51.6821 14.0274C51.535 12.2262 51.2563 11.1268 50.8161 10.2628C49.9212 8.50658 48.4934 7.07876 46.7372 6.18394C45.8732 5.74368 44.7738 5.46503 42.9726 5.31787C41.1442 5.16848 38.8055 5.16667 35.5 5.16667H21.5C18.1945 5.16667 15.8557 5.16848 14.0274 5.31787C12.2262 5.46503 11.1268 5.74368 10.2628 6.18394C8.50658 7.07876 7.07876 8.50658 6.18394 10.2628C5.74368 11.1268 5.46503 12.2262 5.31787 14.0274C5.25094 14.8466 5.21363 15.7682 5.19284 16.8333ZM12.1667 9.83333C13.4553 9.83333 14.5 10.878 14.5 12.1667V12.19C14.5 13.4787 13.4553 14.5233 12.1667 14.5233C10.878 14.5233 9.83333 13.4787 9.83333 12.19V12.1667C9.83333 10.878 10.878 9.83333 12.1667 9.83333ZM19.1667 9.83333C20.4553 9.83333 21.5 10.878 21.5 12.1667V12.19C21.5 13.4787 20.4553 14.5233 19.1667 14.5233C17.878 14.5233 16.8333 13.4787 16.8333 12.19V12.1667C16.8333 10.878 17.878 9.83333 19.1667 9.83333ZM26.1667 9.83333C27.4553 9.83333 28.5 10.878 28.5 12.1667V12.19C28.5 13.4787 27.4553 14.5233 26.1667 14.5233C24.878 14.5233 23.8333 13.4787 23.8333 12.19V12.1667C23.8333 10.878 24.878 9.83333 26.1667 9.83333ZM37.8326 23.8333C39.1213 23.8333 40.166 24.878 40.166 26.1667V28.4949C40.166 29.7836 39.1213 30.8282 37.8326 30.8282C36.544 30.8282 35.4993 29.7836 35.4993 28.4949V26.1667C35.4993 24.878 36.544 23.8333 37.8326 23.8333ZM26.0303 26.0851C26.9363 25.1687 28.4137 25.1604 29.3301 26.0664L32.4732 29.1741C33.3895 30.0802 33.3979 31.5575 32.4919 32.4739C31.5858 33.3903 30.1085 33.3986 29.1921 32.4926L26.049 29.3849C25.1326 28.4788 25.1242 27.0015 26.0303 26.0851ZM39.8531 39.9972L43.2971 48.8508L44.2363 46.0651C44.6074 44.9641 45.5563 44.1734 46.6842 43.9876L48.0897 43.7559L39.8531 39.9972ZM34.1163 38.1221C33.0748 35.4447 35.8497 33.0407 38.3223 34.1691L54.6785 41.6331C57.5041 42.9224 56.8971 47.0342 53.8891 47.5299L48.36 48.441L46.3575 54.3808C45.4264 57.1427 41.5467 57.2234 40.493 54.5145L34.1163 38.1221ZM21.4993 37.8333C21.4993 36.5446 22.544 35.5 23.8326 35.5H28.5473C29.836 35.5 30.8806 36.5446 30.8806 37.8333C30.8806 39.122 29.836 40.1666 28.5473 40.1666H23.8326C22.544 40.1666 21.4993 39.122 21.4993 37.8333Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const NewShareIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-3 w-3 fill-[#0000008A]'
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99974 3.38338L17.9632 10.2092L9.99974 17.0349V13.2797C9.99974 13.0027 9.88487 12.7381 9.6825 12.549C9.48013 12.3599 9.2084 12.2632 8.93206 12.282C7.36402 12.3883 5.82846 12.792 4.40797 13.4735C3.63243 13.8455 2.9 14.2961 2.22158 14.8168C2.54748 13.4045 3.22505 12.0857 4.20498 10.9895C5.50665 9.53342 7.25826 8.56364 9.17207 8.22883C9.6506 8.14511 9.99974 7.72959 9.99974 7.24379V3.38338ZM9.53694 0.796727C9.07313 0.785222 8.63011 0.988986 8.337 1.34862C8.08004 1.6639 8.03492 2.02966 8.01785 2.21869C7.99965 2.4202 7.99969 2.66738 7.99974 2.91251L7.99974 6.43768C5.96914 6.96186 4.12634 8.07659 2.71392 9.65655C0.967278 11.6104 0.00110245 14.1389 -0.000259399 16.7596V17.3721C-0.000259399 17.7935 0.263872 18.1696 0.66021 18.3127C1.05655 18.4558 1.50004 18.3351 1.76918 18.0108C2.72647 16.8576 3.92171 15.925 5.27303 15.2767C6.13975 14.8609 7.05754 14.5684 7.99974 14.4055L7.99974 17.5058C7.99969 17.7509 7.99965 17.9981 8.01785 18.1996C8.03492 18.3887 8.08004 18.7544 8.337 19.0697C8.63011 19.4293 9.07313 19.6331 9.53694 19.6216C9.94354 19.6115 10.2506 19.4077 10.4052 19.2977C10.5701 19.1803 10.7577 19.0194 10.9438 18.8599L19.4419 11.5758C19.4484 11.5703 19.4549 11.5647 19.4615 11.559C19.566 11.4695 19.6873 11.3656 19.785 11.2661C19.8956 11.1534 20.0504 10.9744 20.1431 10.7163C20.2609 10.3884 20.2609 10.0299 20.1431 9.70205C20.0504 9.44394 19.8956 9.26493 19.785 9.15223C19.6873 9.05268 19.566 8.94878 19.4615 8.85933C19.4549 8.85365 19.4484 8.84804 19.4419 8.84249L10.9712 1.58187C10.962 1.57406 10.9529 1.56624 10.9438 1.55841C10.7577 1.39886 10.5701 1.23797 10.4052 1.12064C10.2506 1.01058 9.94354 0.806813 9.53694 0.796727Z"
        fill="#07004D"
      />
    </svg>
  )
}

export const DropDownIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-primary-main h-6 w-6'
  return (
    <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.56307 0.083252C0.493988 0.083252 -0.0414144 1.37582 0.714543 2.13178L3.65082 5.06806C4.11945 5.53669 4.87925 5.53669 5.34788 5.06806L8.28415 2.13178C9.04011 1.37582 8.50471 0.083252 7.43563 0.083252H1.56307Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const EditIcon = ({ className }: IconProps) => {
  const combinedClasses = className || '!w-[1.125rem] !h-[1.125rem] fill-none'
  return (
    <svg className={combinedClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <path d="M-0.0012207 14.2515V18.0015H3.74878L14.8088 6.94152L11.0588 3.19152L-0.0012207 14.2515ZM17.7088 4.04152C18.0988 3.65152 18.0988 3.02152 17.7088 2.63152L15.3688 0.291523C14.9788 -0.0984766 14.3488 -0.0984766 13.9588 0.291523L12.1288 2.12152L15.8788 5.87152L17.7088 4.04152Z" />
    </svg>
  )
}

export const DeleteIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-4 h-4 fill-secondary-main stroke-[#171A1F]'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 16 16">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
        d="M3.6 6v6.8A1.2 1.2 0 004.8 14h6.4a1.2 1.2 0 001.2-1.2V6M2 4.398h12M6 4.4V2h4v2.4M8 7.602v4M10 7.602v4M6 7.602v4"
      ></path>
    </svg>
  )
}
export const EyeHideIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-[1.313rem] h-[1.188rem] fill-none'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 21 19"
      // fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3532 6.00245L13.324 9.10108C13.324 8.99905 13.324 8.99905 13.324 8.90623C13.324 7.20851 12.0788 5.90967 10.451 5.90967C10.451 6.00245 10.451 6.00245 10.3532 6.00245ZM6.23507 6.8003L7.67598 8.30327C7.67598 8.60015 7.67598 8.8042 7.67598 8.99905C7.67598 10.6968 8.92119 11.9956 10.549 11.9956C10.7446 11.9956 10.9314 11.9956 11.216 11.8936L12.6569 13.3965C11.9898 13.7955 11.3138 13.9995 10.549 13.9995C7.86276 13.9995 5.75476 11.8008 5.75476 8.99905C5.75476 8.20115 5.94154 7.49611 6.23507 6.8003ZM0.960609 1.29883L3.16645 3.59962L3.54892 3.99854C1.92122 5.29737 0.675984 6.99513 0 8.99905C1.6277 13.3965 5.75476 16.4952 10.54 16.4952C11.9809 16.4952 13.4129 16.1983 14.756 15.6973L15.1385 16.0963L17.9224 19L19.1677 17.7012L2.20584 0L0.960609 1.29883ZM10.54 3.99854C13.2261 3.99854 15.3342 6.19728 15.3342 8.99905C15.3342 9.6021 15.2363 10.2979 14.9517 10.7988L17.7357 13.7027C19.1766 12.4038 20.324 10.8081 21 9.00835C19.3723 4.61085 15.2453 1.51221 10.46 1.51221C9.11691 1.51221 7.87166 1.80908 6.62643 2.20801L8.72555 4.39747C9.2948 4.10059 9.97079 3.99854 10.54 3.99854Z"
        // fill="black"
        // fillOpacity="0.56"
      />
    </svg>
  )
}

export const EyeOpenIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-[1.375rem] h-4 fill-none'
  return (
    <svg className={combinedClasses} viewBox="0 0 22 16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const ViewEyeIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-[1.375rem] h-4 fill-[#07004D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 23 18" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.869497 7.31022C2.71736 3.29005 6.78117 0.495117 11.5 0.495117C16.2188 0.495117 20.2826 3.29005 22.1305 7.31023C22.6232 8.38205 22.6232 9.61778 22.1305 10.6896C20.2826 14.7098 16.2188 17.5047 11.5 17.5047C6.78117 17.5047 2.71736 14.7098 0.869497 10.6896C0.376834 9.61778 0.376834 8.38205 0.869497 7.31022ZM7.07042 8.82639C7.07042 11.2715 9.05487 13.256 11.5 13.256C13.9451 13.256 15.9296 11.2715 15.9296 8.82639C15.9296 6.38126 13.9451 4.39681 11.5 4.39681C9.05487 4.39681 7.07042 6.38126 7.07042 8.82639ZM11.5 6.16864C10.0294 6.16864 8.84225 7.35577 8.84225 8.82639C8.84225 10.297 10.0294 11.4841 11.5 11.4841C12.9706 11.4841 14.1578 10.297 14.1578 8.82639C14.1578 7.35577 12.9706 6.16864 11.5 6.16864Z"
        // fill=""
      />
    </svg>
  )
}

export const NoAccessIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-[1.375rem] h-4 fill-[#07004D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 23 22" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.72297 3.22068C5.71349 1.23075 8.46302 0 11.5 0C17.5751 0 22.5 4.92487 22.5 11C22.5 14.037 21.2692 16.7866 19.2792 18.7771C19.2789 18.7775 19.2785 18.7778 19.2782 18.7782C19.2774 18.7789 19.2767 18.7797 19.2759 18.7805C17.2855 20.7697 14.5364 22 11.5 22C5.42487 22 0.5 17.0751 0.5 11C0.5 7.96263 1.73106 5.21278 3.72145 3.2222C3.72158 3.22208 3.7217 3.22195 3.72183 3.22183C3.72221 3.22144 3.72259 3.22106 3.72297 3.22068ZM4.4681 5.38231C3.23647 6.92199 2.5 8.87499 2.5 11C2.5 15.9706 6.52944 20 11.5 20C13.625 20 15.578 19.2635 17.1177 18.0319L4.4681 5.38231ZM18.5319 16.6177L5.88231 3.9681C7.42199 2.73647 9.37499 2 11.5 2C16.4706 2 20.5 6.02944 20.5 11C20.5 13.125 19.7635 15.078 18.5319 16.6177Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const PermissionIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-[1.563rem] fill-none'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 24 25">
      <path
        fill="#000"
        d="M16.857 10.737h-3.999a5.056 5.056 0 00-4.152 2.174 3.619 3.619 0 00-2.962-1.517h-.078a3.623 3.623 0 00-2.55 1.112 3.565 3.565 0 00-1.01 2.574 3.568 3.568 0 001.121 2.529 3.655 3.655 0 003.756.788l1.409 1.338c.06.057.144.086.228.074l1.056-.138-.096 1.052a.278.278 0 00.084.224l.578.547c.06.058.147.086.228.074l1.056-.138-.096 1.053a.278.278 0 00.084.223l.653.622a.28.28 0 00.185.076l1.992.057h.007a.279.279 0 00.279-.297l-.144-1.972a.279.279 0 00-.084-.178l-1.745-1.66h8.966a.277.277 0 00.279-.276v-3.34c-.005-2.758-2.266-5-5.045-5zM14.05 22.904l-1.577-.048-.48-.454.113-1.262a.276.276 0 00-.312-.298l-1.267.167-.384-.364.113-1.262a.275.275 0 00-.312-.298l-1.267.167-1.44-1.37a.278.278 0 00-.3-.054 3.097 3.097 0 01-3.33-.612 3.03 3.03 0 01-.95-2.143 3.023 3.023 0 01.857-2.18 3.077 3.077 0 012.16-.944c.821-.019 1.603.284 2.199.85a3.042 3.042 0 01.758 3.274.273.273 0 00.07.295l5.236 4.979.113 1.557zm7.289-4.098h-9.269l-2.858-2.719a3.585 3.585 0 00-.192-2.645 4.506 4.506 0 013.837-2.152h4.001c2.472 0 4.483 1.995 4.483 4.447v3.07h-.002zm-6.482-8.46c2.515 0 4.562-2.03 4.562-4.525 0-2.496-2.047-4.524-4.562-4.524-2.516 0-4.563 2.03-4.563 4.526 0 2.495 2.047 4.524 4.563 4.524zm0-8.497c2.208 0 4.005 1.784 4.005 3.974 0 2.19-1.797 3.974-4.005 3.974s-4.006-1.783-4.006-3.974c0-2.19 1.798-3.974 4.006-3.974zM3.986 13.337a1.412 1.412 0 00.043 2.01c.269.255.619.395.989.395h.03A1.425 1.425 0 006.45 14.29a1.404 1.404 0 00-.441-.995 1.438 1.438 0 00-2.023.042zm1.668 1.584a.873.873 0 01-.615.266.878.878 0 01-.624-.24.863.863 0 01-.026-1.229.873.873 0 01.633-.266c.219 0 .437.08.605.24a.863.863 0 01.026 1.229z"
      ></path>
    </svg>
  )
}

export const SupportIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-none'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z"
        fill="black"
        fillOpacity={0.54}
      />
    </svg>
  )
}

export const SidebarIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-4 h-3.5 fill-none'
  return (
    <svg className={combinedClasses} viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 2H15C15.6 2 16 1.6 16 1C16 0.4 15.6 0 15 0H1C0.4 0 0 0.4 0 1C0 1.6 0.4 2 1 2ZM1 8H15C15.6 8 16 7.6 16 7C16 6.4 15.6 6 15 6H1C0.4 6 0 6.4 0 7C0 7.6 0.4 8 1 8ZM1 14H15C15.6 14 16 13.6 16 13C16 12.4 15.6 12 15 12H1C0.4 12 0 12.4 0 13C0 13.6 0.4 14 1 14Z"
        // fill="black"
      />
    </svg>
  )
}

export const LineArrowIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-[1.063rem] h-4 fill-none'
  return (
    <svg className={combinedClasses} viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.25 0L6.84 1.41L12.42 7H0.25V9H12.42L6.84 14.59L8.25 16L16.25 8L8.25 0Z"
        // fill="#4729FF"
      />
    </svg>
  )
}

export const SortArrowIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-3 h-2'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.06356 5.64673C0.994476 5.64673 0.459074 4.35416 1.21503 3.5982L4.15131 0.661923C4.61994 0.193294 5.37974 0.193294 5.84837 0.661923L8.78464 3.5982C9.5406 4.35416 9.0052 5.64673 7.93611 5.64673H2.06356Z"
        fill="white"
      />
    </svg>
  )
}

export const NewLineArrowIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'w-[1.063rem] h-4 fill-none'}
    viewBox="0 0 12 7"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.89706 6.5C0.827971 6.5 0.29257 5.20743 1.04853 4.45147L5.15147 0.348527C5.6201 -0.120102 6.3799 -0.120101 6.84853 0.348528L10.9515 4.45147C11.7074 5.20743 11.172 6.5 10.1029 6.5H1.89706Z"
      // fill="#4CAF50"
    />
  </svg>
)

export const CircleTickFilled = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={combinedClasses}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path d="M10.0003 1.66602C5.40033 1.66602 1.66699 5.39935 1.66699 9.99935C1.66699 14.5993 5.40033 18.3327 10.0003 18.3327C14.6003 18.3327 18.3337 14.5993 18.3337 9.99935C18.3337 5.39935 14.6003 1.66602 10.0003 1.66602ZM8.33366 14.166L4.16699 9.99935L5.34199 8.82435L8.33366 11.8077L14.6587 5.48268L15.8337 6.66602L8.33366 14.166Z" />
    </svg>
  )
}

export const BellIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-primary-main'
  return (
    <svg className={combinedClasses} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5663 4C8.2526 4 5.56631 6.68629 5.56631 10V12.5778C5.56631 14.1747 5.12704 15.6629 4.3895 17H18.7431C18.0056 15.6629 17.5663 14.1747 17.5663 12.5778V10C17.5663 6.68629 14.88 4 11.5663 4ZM3.56631 10C3.56631 5.58172 7.14803 2 11.5663 2C15.9846 2 19.5663 5.58172 19.5663 10V12.5778C19.5663 14.0357 20.0439 15.4135 20.8801 16.668C21.5447 17.6648 20.8301 19 19.6321 19H3.50057C2.30253 19 1.58794 17.6648 2.25249 16.668C3.08877 15.4135 3.56631 14.0357 3.56631 12.5778V10ZM7.41488 20.4461C7.72079 19.9863 8.34154 19.8615 8.80136 20.1674C10.47 21.2775 12.6624 21.2775 14.331 20.1674C14.7909 19.8615 15.4116 19.9863 15.7175 20.4461C16.0234 20.9059 15.8987 21.5267 15.4388 21.8326C13.0991 23.3891 10.0333 23.3891 7.69357 21.8326C7.23374 21.5267 7.10897 20.9059 7.41488 20.4461Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const BellIconFilled = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-none'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5683 2C7.14999 2 3.56826 5.58172 3.56826 10V12.5778C3.56826 13.9598 3.1592 15.3108 2.39262 16.4607L2.25445 16.668C1.58989 17.6648 2.30448 19 3.50252 19H19.634C20.832 19 21.5466 17.6648 20.8821 16.668L20.7439 16.4607C19.9773 15.3108 19.5683 13.9598 19.5683 12.5778V10C19.5683 5.58172 15.9865 2 11.5683 2Z"
        fill="#07004D"
      />
      <path
        d="M15.4408 21.8326C15.7453 21.63 15.9029 21.2893 15.8857 20.9487C15.8689 20.6145 15.5184 20.4461 15.1837 20.4461H7.95264C7.61794 20.4461 7.26741 20.6145 7.25058 20.9487C7.23342 21.2893 7.391 21.63 7.69552 21.8326C10.0352 23.3891 13.1011 23.3891 15.4408 21.8326Z"
        fill="#07004D"
      />
    </svg>
  )
}

export const ShareIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-3.5 h-5 fill-[#424242]'
  return (
    <svg className={combinedClasses} viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3333 4.16683L9.15 5.35016L7.825 4.02516V13.3335H6.175V4.02516L4.85 5.35016L3.66667 4.16683L7 0.833496L10.3333 4.16683ZM13.6667 8.3335V17.5002C13.6667 18.4168 12.9167 19.1668 12 19.1668H2C1.075 19.1668 0.333336 18.4168 0.333336 17.5002V8.3335C0.333336 7.4085 1.075 6.66683 2 6.66683H4.5V8.3335H2V17.5002H12V8.3335H9.5V6.66683H12C12.9167 6.66683 13.6667 7.4085 13.6667 8.3335Z"
        // fill="#424242"
      />
    </svg>
  )
}
export const AddFieldIcon = ({ className, fill = 'fill-white' }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-white'
  return (
    <svg className={combinedClasses} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" className={fill} />
    </svg>
  )
}

export const UploadIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-10 h-10 fill-primary-main'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className={combinedClasses}>
      <g>
        <path d="M23.333 3.333H10c-1.834 0-3.317 1.5-3.317 3.334l-.016 26.666c0 1.834 1.483 3.334 3.316 3.334H30c1.833 0 3.333-1.5 3.333-3.334v-20l-10-10zm6.667 30H10V6.668h11.666V15H30v18.334zm-16.667-8.316l2.35 2.35 2.65-2.634v6.934h3.334v-6.934l2.65 2.65 2.35-2.366-6.65-6.683-6.684 6.683z"></path>
      </g>
    </svg>
  )
}

export const CheckIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" className={combinedClasses}>
      <g>
        <path d="M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.334 14.6 18.334 10 14.6 1.667 10 1.667zm-1.666 12.5L4.167 10l1.175-1.175 2.992 2.983 6.325-6.325 1.175 1.184-7.5 7.5z"></path>
      </g>
    </svg>
  )
}

export const CancelIcon = ({ className, onClick }: IconProps) => {
  const combinedClasses = className || 'w-9 h-9 fill-none cursor-pointer'
  return (
    <svg
      className={combinedClasses}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      onClick={onClick}
    >
      <path
        fill="#000"
        fillOpacity="0.56"
        d="M23.834 13.341l-1.175-1.175L18 16.825l-4.658-4.659-1.175 1.175L16.825 18l-4.658 4.658 1.175 1.175L18 19.175l4.659 4.658 1.175-1.175L19.175 18l4.659-4.659z"
      ></path>
    </svg>
  )
}

export const ManageInvestorsIcon = ({
  color = 'fill-secondary-darkGray',
  stroke = 'secondary-darkGray'
}) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className={`${color}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12.75C13.63 12.75 15.07 13.14 16.24 13.65C17.32 14.13 18 15.21 18 16.38V18H6V16.39C6 15.21 6.68 14.13 7.76 13.66C8.93 13.14 10.37 12.75 12 12.75ZM4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM12 6C13.66 6 15 7.34 15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6Z"
        className={stroke}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  )
}

export const ManageAdminIcon = ({
  color = 'fill-secondary-darkGray',
  stroke = 'secondary-darkGray'
}) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className={`${color}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.75 16C20.75 15.78 20.72 15.58 20.69 15.37L21.83 14.36L20.83 12.63L19.38 13.12C19.06 12.85 18.7 12.64 18.3 12.49L18 11H16L15.7 12.49C15.3 12.64 14.94 12.85 14.62 13.12L13.17 12.63L12.17 14.36L13.31 15.37C13.28 15.58 13.25 15.78 13.25 16C13.25 16.22 13.28 16.42 13.31 16.63L12.17 17.64L13.17 19.37L14.62 18.88C14.94 19.15 15.3 19.36 15.7 19.51L16 21H18L18.3 19.51C18.7 19.36 19.06 19.15 19.38 18.88L20.83 19.37L21.83 17.64L20.69 16.63C20.72 16.42 20.75 16.22 20.75 16ZM17 18C15.9 18 15 17.1 15 16C15 14.9 15.9 14 17 14C18.1 14 19 14.9 19 16C19 17.1 18.1 18 17 18Z"
        className={stroke}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M10.67 13.02C10.45 13.01 10.23 13 10 13C7.58 13 5.32 13.67 3.39 14.82C2.51 15.34 2 16.32 2 17.35V20H11.26C10.47 18.87 10 17.49 10 16C10 14.93 10.25 13.93 10.67 13.02Z"
        className={stroke}
        // fillOpacity="0.54"
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12Z"
        className={stroke}
        // fillOpacity="0.54"
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  )
}

export const DollorIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main cursor-pointer'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 20 20">
      <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1.41 16.09V18H8.74v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V2h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H12.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"></path>
    </svg>
  )
}

export const NewDollorIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main cursor-pointer'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.68334 9.59999C9.68334 8.92344 10.2374 8.26481 11.0751 8.14443V11.0556C10.2374 10.9352 9.68334 10.2765 9.68334 9.59999Z"
        fill="#07004D"
      />
      <path
        d="M14.3167 14.4C14.3167 15.0765 13.7627 15.7352 12.925 15.8556V12.9444C13.7627 13.0648 14.3167 13.7234 14.3167 14.4Z"
        fill="#07004D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12.925 5.99999C12.925 5.48917 12.5109 5.07507 12 5.07507C11.4892 5.07507 11.0751 5.48917 11.0751 5.99999V6.28542C9.31863 6.41714 7.8335 7.79175 7.8335 9.59999C7.8335 11.4082 9.31863 12.7828 11.0751 12.9146V15.8556C10.2374 15.7352 9.68334 15.0765 9.68334 14.4C9.68334 13.8892 9.26924 13.4751 8.75842 13.4751C8.2476 13.4751 7.8335 13.8892 7.8335 14.4C7.8335 16.2082 9.31863 17.5828 11.0751 17.7146V18C11.0751 18.5108 11.4892 18.9249 12 18.9249C12.5109 18.9249 12.925 18.5108 12.925 18V17.7146C14.6814 17.5828 16.1666 16.2082 16.1666 14.4C16.1666 12.5917 14.6814 11.2171 12.925 11.0854V8.14443C13.7627 8.26481 14.3167 8.92344 14.3167 9.59999C14.3167 10.1108 14.7308 10.5249 15.2417 10.5249C15.7525 10.5249 16.1666 10.1108 16.1666 9.59999C16.1666 7.79175 14.6814 6.41714 12.925 6.28542V5.99999Z"
        fill="#07004D"
      />
    </svg>
  )
}

export const AIIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main cursor-pointer'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0001 3C14.0001 3.55228 13.5523 4 13.0001 4C12.4478 4 12.0001 3.55228 12.0001 3C12.0001 2.44772 12.4478 2 13.0001 2C13.5523 2 14.0001 2.44772 14.0001 3ZM6.3054 3.8249C6.35387 3.61948 6.64623 3.61948 6.6947 3.8249L7.21722 6.03922C7.30422 6.40793 7.59211 6.69582 7.96082 6.78282L10.1752 7.30534C10.3806 7.35381 10.3806 7.64617 10.1752 7.69464L7.96082 8.21716C7.59211 8.30416 7.30422 8.59205 7.21722 8.96076L6.6947 11.1751C6.64623 11.3805 6.35387 11.3805 6.3054 11.1751L5.78288 8.96076C5.69588 8.59205 5.40799 8.30416 5.03928 8.21716L2.82496 7.69464C2.61954 7.64617 2.61954 7.35381 2.82496 7.30534L5.03928 6.78282C5.40799 6.69582 5.69588 6.40793 5.78288 6.03922L6.3054 3.8249ZM13.5135 8.06229C13.6346 7.54873 14.3656 7.54873 14.4867 8.06229L15.3145 11.5702C15.445 12.1233 15.8768 12.5551 16.4299 12.6856L19.9378 13.5134C20.4514 13.6345 20.4514 14.3655 19.9378 14.4866L16.4299 15.3144C15.8768 15.4449 15.445 15.8767 15.3145 16.4298L14.4867 19.9377C14.3656 20.4513 13.6346 20.4513 13.5135 19.9377L12.6857 16.4298C12.5552 15.8767 12.1234 15.4449 11.5703 15.3144L8.06233 14.4866C7.54877 14.3655 7.54877 13.6345 8.06233 13.5134L11.5703 12.6856C12.1234 12.5551 12.5552 12.1233 12.6857 11.5702L13.5135 8.06229Z"
        fill="#07004D"
      />
    </svg>
  )
}

export const ReportIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-[1.125rem] h-[1.125rem] fill-primary-main cursor-pointer'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 18 18">
      <path d="M17.41 5.41L12.58.58C12.21.21 11.7 0 11.17 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.83c0-.53-.21-1.04-.59-1.42zM4 4h7v2H4V4zm10 10H4v-2h10v2zm0-4H4V8h10v2z"></path>
    </svg>
  )
}

export const InvestorCenterIcon = ({
  className,
  fill = 'fill-[#07004D]',
  stroke = 'stroke-[#07004D]'
}: IconProps) => {
  const combinedClasses = className || 'fill-white cursor-pointer'
  return (
    <svg className={combinedClasses} viewBox="0 0 44 49" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.80067 15.0539L7.51028 12.2961L21.2618 15.4037L35.7307 3.61718L37.9039 5.72865L22.1849 18.4748L6.80067 15.0539Z"
        className={fill}
      />
      <path
        d="M11.5917 14.0984C11.5917 16.4388 9.69447 18.336 7.35411 18.336C5.01376 18.336 3.11653 16.4388 3.11653 14.0984C3.11653 11.7581 5.01376 9.86084 7.35411 9.86084C9.69447 9.86084 11.5917 11.7581 11.5917 14.0984Z"
        className={fill}
      />
      <path
        d="M0.737427 26.136C0.737427 23.6744 2.73295 21.6789 5.19455 21.6789H9.51368C11.9753 21.6789 13.9708 23.6744 13.9708 26.136V44.0598C13.9708 46.5214 11.9753 48.5169 9.51368 48.5169H5.19455C2.73295 48.5169 0.737427 46.5214 0.737427 44.0598V26.136Z"
        fill="white"
      />
      <path
        d="M5.19446 23.9077H9.51379C10.7445 23.9078 11.7423 24.9055 11.7423 26.1362V44.0601C11.7422 45.2907 10.7444 46.2885 9.51379 46.2886H5.19446C3.9638 46.2885 2.9661 45.2907 2.96594 44.0601V26.1362C2.96594 24.9055 3.9637 23.9078 5.19446 23.9077ZM7.35364 12.0894C8.4631 12.0894 9.36325 12.9887 9.3634 14.0981C9.3634 15.2077 8.46319 16.1079 7.35364 16.1079C6.2443 16.1077 5.34485 15.2075 5.34485 14.0981C5.345 12.9889 6.2444 12.0896 7.35364 12.0894Z"
        className={stroke}
        strokeWidth="4.45712"
      />
      <path
        d="M26.2376 16.9231C26.2376 19.2635 24.3403 21.1607 22 21.1607C19.6596 21.1607 17.7624 19.2635 17.7624 16.9231C17.7624 14.5828 19.6596 12.6855 22 12.6855C24.3403 12.6855 26.2376 14.5828 26.2376 16.9231Z"
        className={fill}
      />
      <path
        d="M15.3833 28.9607C15.3833 26.4991 17.3788 24.5036 19.8404 24.5036H24.1596C26.6212 24.5036 28.6167 26.4991 28.6167 28.9607V44.0594C28.6167 46.521 26.6212 48.5165 24.1596 48.5165H19.8404C17.3788 48.5165 15.3833 46.521 15.3833 44.0594V28.9607Z"
        fill="white"
      />
      <path
        d="M19.8403 26.7324H24.1597C25.3904 26.7325 26.3882 27.7302 26.3882 28.9609V44.0596C26.3881 45.2903 25.3904 46.288 24.1597 46.2881H19.8403C18.6096 46.288 17.6119 45.2903 17.6118 44.0596V28.9609C17.6118 27.7302 18.6096 26.7325 19.8403 26.7324ZM21.9995 14.9141C23.109 14.9141 24.0091 15.8134 24.0093 16.9229C24.0093 18.0324 23.1091 18.9326 21.9995 18.9326C20.8902 18.9324 19.9907 18.0322 19.9907 16.9229C19.9909 15.8136 20.8903 14.9143 21.9995 14.9141Z"
        className={stroke}
        strokeWidth="4.45712"
      />
      <path
        d="M40.8834 5.06669C40.8834 7.40704 38.9862 9.30427 36.6459 9.30427C34.3055 9.30427 32.4083 7.40704 32.4083 5.06669C32.4083 2.72633 34.3055 0.829102 36.6459 0.829102C38.9862 0.829102 40.8834 2.72633 40.8834 5.06669Z"
        className={fill}
      />
      <path
        d="M30.0292 17.6609C30.0292 15.1993 32.0247 13.2038 34.4863 13.2038H38.8054C41.267 13.2038 43.2625 15.1993 43.2625 17.6609V44.0599C43.2625 46.5215 41.267 48.517 38.8054 48.517H34.4863C32.0247 48.517 30.0292 46.5215 30.0292 44.0599V17.6609Z"
        fill="white"
      />
      <path
        d="M34.4862 15.4326H38.8055C40.0363 15.4327 41.0341 16.4304 41.0341 17.6611V44.0596C41.0341 45.2903 40.0363 46.288 38.8055 46.2881H34.4862C33.2554 46.288 32.2577 45.2903 32.2577 44.0596V17.6611C32.2577 16.4304 33.2554 15.4327 34.4862 15.4326ZM36.6454 3.05762C37.7548 3.05762 38.655 3.95698 38.6552 5.06641C38.6552 6.17596 37.7549 7.07617 36.6454 7.07617C35.5361 7.07591 34.6366 6.1758 34.6366 5.06641C34.6367 3.95714 35.5361 3.05788 36.6454 3.05762Z"
        className={stroke}
        strokeWidth="4.45712"
      />
    </svg>
  )
}

export const AdminPermissionIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-black cursor-pointer'
  return (
    <svg viewBox="0 0 57 37" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.2582 4.7465C24.7796 4.7465 21.9596 7.56646 21.9596 11.0451C21.9596 14.5237 24.7796 17.3436 28.2582 17.3436C31.7368 17.3436 34.5567 14.5237 34.5567 11.0451C34.5567 7.56646 31.7368 4.7465 28.2582 4.7465ZM17.293 11.0451C17.293 4.98913 22.2022 0.079834 28.2582 0.079834C34.3141 0.079834 39.2234 4.98913 39.2234 11.0451C39.2234 14.6791 37.4556 17.9002 34.7331 19.8954C36.9023 20.8976 38.6306 22.355 39.9885 23.9885C40.3437 23.501 40.7475 23.0317 41.2038 22.6025C39.6987 21.1313 38.7645 19.0786 38.7645 16.8076C38.7645 12.3326 42.3922 8.7048 46.8673 8.7048C51.3424 8.7048 54.9702 12.3326 54.9702 16.8076C54.9702 19.1245 53.9978 21.2143 52.4388 22.691C53.1245 23.3414 53.6925 24.0783 54.1523 24.8289C55.504 27.0356 56.0946 29.5893 56.2485 31.2983C56.3642 32.5818 55.4174 33.716 54.134 33.8316C52.8505 33.9472 51.7163 33.0005 51.6007 31.717C51.4927 30.5184 51.0549 28.7065 50.1729 27.2665C49.323 25.8792 48.2478 25.0872 46.7696 25.0779C45.0979 25.0675 43.9063 26.1127 43.0404 27.9705C42.9568 28.1497 42.8534 28.3133 42.734 28.46C43.2173 29.5488 43.5779 30.6114 43.8335 31.5781C44.6 34.4778 42.2194 36.7714 39.7038 36.7714H16.6665C14.1724 36.7714 11.8076 34.5203 12.5188 31.64C12.7702 30.6217 13.1363 29.4946 13.6387 28.3411C13.6175 28.2994 13.5974 28.2568 13.5784 28.2134C12.6922 26.1805 11.4166 24.9747 9.62664 24.9634C8.17177 24.9543 7.12579 25.7211 6.2968 27.101C5.43315 28.5385 5.01291 30.3621 4.91685 31.5771C4.81529 32.8617 3.69153 33.8208 2.40688 33.7192C1.12222 33.6177 0.163136 32.4939 0.264701 31.2093C0.400633 29.4899 0.963822 26.9161 2.29651 24.6977C2.76446 23.9188 3.34904 23.155 4.06106 22.488C2.55598 21.0168 1.62177 18.9641 1.62177 16.6931C1.62177 12.2181 5.24953 8.59029 9.72461 8.59029C14.1997 8.59029 17.8274 12.2181 17.8274 16.6931C17.8274 19.0098 16.8552 21.0995 15.2964 22.5762C15.7031 22.964 16.0684 23.3828 16.3952 23.8173C17.7477 22.1953 19.4721 20.7595 21.6412 19.7895C18.9994 17.7873 17.293 14.6155 17.293 11.0451ZM9.72461 13.257C7.82686 13.257 6.28844 14.7954 6.28844 16.6931C6.28844 18.5909 7.82686 20.1293 9.72461 20.1293C11.6224 20.1293 13.1608 18.5909 13.1608 16.6931C13.1608 14.7954 11.6224 13.257 9.72461 13.257ZM46.8673 13.3715C44.9696 13.3715 43.4312 14.9099 43.4312 16.8076C43.4312 18.7054 44.9696 20.2438 46.8673 20.2438C48.7651 20.2438 50.3035 18.7054 50.3035 16.8076C50.3035 14.9099 48.7651 13.3715 46.8673 13.3715ZM17.2247 32.1047H39.1311C37.8429 27.9309 34.6116 23.196 28.1018 23.1635C21.6038 23.131 18.447 27.8852 17.2247 32.1047Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const CompanyReportsIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-black cursor-pointer'
  return (
    <svg viewBox="0 0 42 53" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75519 0.833498H32.2448C33.4955 0.833455 34.5745 0.833418 35.4627 0.90718C36.4004 0.985055 37.3325 1.15706 38.2268 1.62161C39.5053 2.28573 40.5478 3.32818 41.2119 4.60668C41.6764 5.50097 41.8484 6.43307 41.9263 7.3708C42.0001 8.25904 42 9.33801 42 10.5888V42.4116C42 43.6623 42.0001 44.7413 41.9263 45.6295C41.8484 46.5673 41.6764 47.4994 41.2119 48.3937C40.5478 49.6722 39.5053 50.7146 38.2268 51.3787C37.3325 51.8433 36.4004 52.0153 35.4627 52.0932C34.5745 52.1669 33.4955 52.1669 32.2447 52.1668H9.75526C8.50451 52.1669 7.42554 52.1669 6.5373 52.0932C5.59957 52.0153 4.66747 51.8433 3.77318 51.3787C2.49468 50.7146 1.45224 49.6722 0.78811 48.3937C0.323564 47.4994 0.151559 46.5673 0.0736844 45.6295C-7.83093e-05 44.7413 -4.104e-05 43.6624 2.07403e-06 42.4116V10.5887C-4.104e-05 9.33797 -7.83093e-05 8.25902 0.0736844 7.3708C0.151559 6.43307 0.323564 5.50097 0.78811 4.60668C1.45224 3.32818 2.49468 2.28574 3.77318 1.62161C4.66747 1.15706 5.59957 0.985055 6.53731 0.90718C7.42553 0.833418 8.50448 0.833455 9.75519 0.833498ZM6.92352 5.55784C6.27958 5.61131 6.04155 5.70201 5.9244 5.76287C5.49823 5.98425 5.15075 6.33173 4.92937 6.75789C4.86851 6.87505 4.77782 7.11308 4.72434 7.75702C4.66855 8.42889 4.66667 9.31219 4.66667 10.6802V42.3202C4.66667 43.6881 4.66855 44.5715 4.72434 45.2433C4.77782 45.8873 4.86851 46.1253 4.92937 46.2424C5.15075 46.6686 5.49823 47.0161 5.9244 47.2375C6.04156 47.2983 6.27958 47.389 6.92352 47.4425C7.59539 47.4983 8.4787 47.5002 9.84667 47.5002H32.1533C33.5213 47.5002 34.4046 47.4983 35.0765 47.4425C35.7204 47.389 35.9585 47.2983 36.0756 47.2375C36.5018 47.0161 36.8493 46.6686 37.0706 46.2424C37.1315 46.1253 37.2222 45.8873 37.2757 45.2433C37.3315 44.5715 37.3333 43.6881 37.3333 42.3202V10.6802C37.3333 9.31219 37.3315 8.42889 37.2757 7.75702C37.2222 7.11308 37.1315 6.87505 37.0706 6.75789C36.8493 6.33173 36.5018 5.98425 36.0756 5.76287C35.9585 5.70201 35.7204 5.61131 35.0765 5.55784C34.4046 5.50204 33.5213 5.50017 32.1533 5.50017H9.84667C8.47869 5.50017 7.59539 5.50204 6.92352 5.55784ZM9.33334 12.5002C9.33334 11.2115 10.378 10.1668 11.6667 10.1668H30.3333C31.622 10.1668 32.6667 11.2115 32.6667 12.5002C32.6667 13.7888 31.622 14.8335 30.3333 14.8335H11.6667C10.378 14.8335 9.33334 13.7888 9.33334 12.5002ZM9.33334 21.8335C9.33334 20.5448 10.378 19.5002 11.6667 19.5002H30.3333C31.622 19.5002 32.6667 20.5448 32.6667 21.8335C32.6667 23.1222 31.622 24.1668 30.3333 24.1668H11.6667C10.378 24.1668 9.33334 23.1222 9.33334 21.8335ZM9.33334 31.1668C9.33334 29.8782 10.378 28.8335 11.6667 28.8335H30.3333C31.622 28.8335 32.6667 29.8782 32.6667 31.1668C32.6667 32.4555 31.622 33.5002 30.3333 33.5002H11.6667C10.378 33.5002 9.33334 32.4555 9.33334 31.1668ZM9.33334 40.5002C9.33334 39.2115 10.378 38.1668 11.6667 38.1668H21C22.2887 38.1668 23.3333 39.2115 23.3333 40.5002C23.3333 41.7888 22.2887 42.8335 21 42.8335H11.6667C10.378 42.8335 9.33334 41.7888 9.33334 40.5002Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const SidebarResearchIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'cursor-pointer'
  return (
    <svg viewBox="0 0 42 53" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75519 0.833498H32.2448C33.4955 0.833455 34.5745 0.833418 35.4627 0.90718C36.4004 0.985055 37.3325 1.15706 38.2268 1.62161C39.5053 2.28573 40.5478 3.32818 41.2119 4.60668C41.6764 5.50097 41.8484 6.43307 41.9263 7.3708C42.0001 8.25904 42 9.33801 42 10.5888V42.4116C42 43.6623 42.0001 44.7413 41.9263 45.6295C41.8484 46.5673 41.6764 47.4994 41.2119 48.3937C40.5478 49.6722 39.5053 50.7146 38.2268 51.3787C37.3325 51.8433 36.4004 52.0153 35.4627 52.0932C34.5745 52.1669 33.4955 52.1669 32.2447 52.1668H9.75526C8.50451 52.1669 7.42554 52.1669 6.5373 52.0932C5.59957 52.0153 4.66747 51.8433 3.77318 51.3787C2.49468 50.7146 1.45224 49.6722 0.78811 48.3937C0.323564 47.4994 0.151559 46.5673 0.0736844 45.6295C-7.83093e-05 44.7413 -4.104e-05 43.6624 2.07403e-06 42.4116V10.5887C-4.104e-05 9.33797 -7.83093e-05 8.25902 0.0736844 7.3708C0.151559 6.43307 0.323564 5.50097 0.78811 4.60668C1.45224 3.32818 2.49468 2.28574 3.77318 1.62161C4.66747 1.15706 5.59957 0.985055 6.53731 0.90718C7.42553 0.833418 8.50448 0.833455 9.75519 0.833498ZM6.92352 5.55784C6.27958 5.61131 6.04155 5.70201 5.9244 5.76287C5.49823 5.98425 5.15075 6.33173 4.92937 6.75789C4.86851 6.87505 4.77782 7.11308 4.72434 7.75702C4.66855 8.42889 4.66667 9.31219 4.66667 10.6802V42.3202C4.66667 43.6881 4.66855 44.5715 4.72434 45.2433C4.77782 45.8873 4.86851 46.1253 4.92937 46.2424C5.15075 46.6686 5.49823 47.0161 5.9244 47.2375C6.04156 47.2983 6.27958 47.389 6.92352 47.4425C7.59539 47.4983 8.4787 47.5002 9.84667 47.5002H32.1533C33.5213 47.5002 34.4046 47.4983 35.0765 47.4425C35.7204 47.389 35.9585 47.2983 36.0756 47.2375C36.5018 47.0161 36.8493 46.6686 37.0706 46.2424C37.1315 46.1253 37.2222 45.8873 37.2757 45.2433C37.3315 44.5715 37.3333 43.6881 37.3333 42.3202V10.6802C37.3333 9.31219 37.3315 8.42889 37.2757 7.75702C37.2222 7.11308 37.1315 6.87505 37.0706 6.75789C36.8493 6.33173 36.5018 5.98425 36.0756 5.76287C35.9585 5.70201 35.7204 5.61131 35.0765 5.55784C34.4046 5.50204 33.5213 5.50017 32.1533 5.50017H9.84667C8.47869 5.50017 7.59539 5.50204 6.92352 5.55784ZM9.33334 12.5002C9.33334 11.2115 10.378 10.1668 11.6667 10.1668H30.3333C31.622 10.1668 32.6667 11.2115 32.6667 12.5002C32.6667 13.7888 31.622 14.8335 30.3333 14.8335H11.6667C10.378 14.8335 9.33334 13.7888 9.33334 12.5002ZM9.33334 21.8335C9.33334 20.5448 10.378 19.5002 11.6667 19.5002H30.3333C31.622 19.5002 32.6667 20.5448 32.6667 21.8335C32.6667 23.1222 31.622 24.1668 30.3333 24.1668H11.6667C10.378 24.1668 9.33334 23.1222 9.33334 21.8335ZM9.33334 31.1668C9.33334 29.8782 10.378 28.8335 11.6667 28.8335H30.3333C31.622 28.8335 32.6667 29.8782 32.6667 31.1668C32.6667 32.4555 31.622 33.5002 30.3333 33.5002H11.6667C10.378 33.5002 9.33334 32.4555 9.33334 31.1668ZM9.33334 40.5002C9.33334 39.2115 10.378 38.1668 11.6667 38.1668H21C22.2887 38.1668 23.3333 39.2115 23.3333 40.5002C23.3333 41.7888 22.2887 42.8335 21 42.8335H11.6667C10.378 42.8335 9.33334 41.7888 9.33334 40.5002Z"
      />
    </svg>
  )
}

export const ManageAiIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-black cursor-pointer'
  return (
    <svg viewBox="0 0 57 57" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.7608 18.7762C30.6088 15.1814 35.7254 15.1814 36.5735 18.7762L38.505 26.9615C38.6065 27.3917 38.9424 27.7274 39.3726 27.8289L47.5577 29.7605C51.1526 30.6085 51.1522 35.7252 47.5572 36.5733L39.3725 38.5047C38.9423 38.6062 38.6065 38.9421 38.505 39.3723L36.5735 47.5574C35.7254 51.1523 30.6087 51.1519 29.7607 47.5569L27.8292 39.3722C27.7277 38.942 27.3919 38.6062 26.9617 38.5047L18.7765 36.5732C15.1817 35.7251 15.182 30.6084 18.7769 29.7604L26.9618 27.8289C27.392 27.7274 27.7277 27.3916 27.8292 26.9614L29.7608 18.7762ZM33.1671 24.6601L32.3712 28.0331C32.2313 28.6258 32.0025 29.1828 31.6993 29.6892C30.9023 31.0206 29.5916 32.0032 28.0335 32.3708L24.6604 33.1668L28.0334 33.9628C30.1843 34.4703 31.8636 36.1496 32.3711 38.3005L33.1671 41.6735L33.9631 38.3005C34.4706 36.1497 36.1499 34.4703 38.3007 33.9628L41.6738 33.1668L38.3008 32.3709C36.15 31.8634 34.4706 30.1841 33.9631 28.0332L33.1671 24.6601Z"
        // fill="#07004D"
      />
      <path
        d="M15.2124 9.42467C15.3255 8.94536 16.0077 8.94536 16.1208 9.42467L17.34 14.5914C17.543 15.4517 18.2148 16.1235 19.0751 16.3265L24.2419 17.5457C24.7211 17.6588 24.7211 18.341 24.2419 18.4541L19.0751 19.6733C18.2148 19.8763 17.543 20.548 17.34 21.4083L16.1208 26.5751C16.0077 27.0544 15.3255 27.0544 15.2124 26.5751L13.9932 21.4083C13.7902 20.548 13.1185 19.8763 12.2582 19.6733L7.09142 18.4541C6.61211 18.341 6.61211 17.6588 7.09142 17.5457L12.2582 16.3265C13.1185 16.1235 13.7902 15.4517 13.9932 14.5914L15.2124 9.42467Z"
        // stroke="#07004D"
        strokeWidth="3.33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.8334 6.06803C30.0426 6.06803 29.4015 6.70909 29.4015 7.49988C29.4015 8.29066 30.0426 8.93172 30.8334 8.93172C31.6242 8.93172 32.2652 8.29066 32.2652 7.49988C32.2652 6.70909 31.6242 6.06803 30.8334 6.06803ZM24.7349 7.49988C24.7349 4.13176 27.4653 1.40137 30.8334 1.40137C34.2015 1.40137 36.9319 4.13176 36.9319 7.49988C36.9319 10.868 34.2015 13.5984 30.8334 13.5984C27.4653 13.5984 24.7349 10.868 24.7349 7.49988Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const DraftCompanyReportsIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-primary-main cursor-pointer'
  return (
    <svg viewBox="0 0 28 33" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7969 3.16006C22.3837 3.1263 21.8408 3.12517 21 3.12517L12.5417 3.12517V8.9585C12.5417 10.5693 11.2358 11.8752 9.625 11.8752L3.79167 11.8752L3.79167 26.1668C3.79167 27.0076 3.7928 27.5505 3.82656 27.9637C3.85893 28.3599 3.91388 28.5068 3.95062 28.5789C4.09043 28.8533 4.31353 29.0764 4.58793 29.2162C4.66004 29.253 4.80692 29.3079 5.20309 29.3403C5.6163 29.374 6.15919 29.3752 7 29.3752H21C21.8408 29.3752 22.3837 29.374 22.7969 29.3403C23.1931 29.3079 23.34 29.253 23.4121 29.2162C23.6865 29.0764 23.9096 28.8533 24.0494 28.5789C24.0861 28.5068 24.1411 28.3599 24.1734 27.9637C24.2072 27.5505 24.2083 27.0076 24.2083 26.1668V6.3335C24.2083 5.49269 24.2072 4.94979 24.1734 4.53659C24.1411 4.14042 24.0861 3.99353 24.0494 3.92143C23.9096 3.64703 23.6865 3.42393 23.4121 3.28411C23.34 3.24737 23.1931 3.19243 22.7969 3.16006ZM1.42826 9.27327C1.0912 9.54039 0.875001 9.95336 0.875001 10.4168L0.875001 26.223C0.874975 26.9918 0.874953 27.655 0.919583 28.2013C0.966689 28.7778 1.07069 29.3512 1.35185 29.903C1.77129 30.7263 2.44058 31.3955 3.26379 31.815C3.8156 32.0961 4.38904 32.2001 4.96559 32.2473C5.51183 32.2919 6.17502 32.2919 6.94376 32.2918H21.0562C21.825 32.2919 22.4882 32.2919 23.0344 32.2473C23.611 32.2001 24.1844 32.0961 24.7362 31.815C25.5594 31.3955 26.2287 30.7262 26.6482 29.903C26.9293 29.3512 27.0333 28.7778 27.0804 28.2012C27.1251 27.655 27.125 26.9918 27.125 26.2231V6.27726C27.125 5.50851 27.1251 4.84533 27.0804 4.29908C27.0333 3.72254 26.9293 3.14909 26.6482 2.59729C26.2287 1.77408 25.5594 1.10479 24.7362 0.685347C24.1844 0.404188 23.611 0.300185 23.0344 0.253079C22.4882 0.208449 21.825 0.208471 21.0562 0.208497L11.0833 0.2085C10.6199 0.2085 10.2069 0.424702 9.93977 0.761753C9.89301 0.799449 9.84741 0.840367 9.80318 0.88459L1.55109 9.13669C1.50687 9.18091 1.46595 9.2265 1.42826 9.27327ZM5.85406 8.9585L9.625 8.9585V5.18756L5.85406 8.9585ZM15.4583 10.4168C15.4583 9.61142 16.1113 8.9585 16.9167 8.9585H19.8333C20.6388 8.9585 21.2917 9.61142 21.2917 10.4168C21.2917 11.2222 20.6388 11.8752 19.8333 11.8752H16.9167C16.1113 11.8752 15.4583 11.2222 15.4583 10.4168ZM6.70834 16.2502C6.70834 15.4448 7.36126 14.7918 8.16667 14.7918H19.8333C20.6388 14.7918 21.2917 15.4448 21.2917 16.2502C21.2917 17.0556 20.6388 17.7085 19.8333 17.7085H8.16667C7.36126 17.7085 6.70834 17.0556 6.70834 16.2502ZM6.70834 22.0835C6.70834 21.2781 7.36126 20.6252 8.16667 20.6252H19.8333C20.6388 20.6252 21.2917 21.2781 21.2917 22.0835C21.2917 22.8889 20.6388 23.5418 19.8333 23.5418H8.16667C7.36126 23.5418 6.70834 22.8889 6.70834 22.0835Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const LinkIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-primary-main'
  return (
    <svg className={combinedClasses} viewBox="0 0 31 31" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7012 2.97577C21.3622 0.314719 25.6767 0.314719 28.3377 2.97577C30.9988 5.63681 30.9988 9.95123 28.3377 12.6123L20.8225 20.1275C18.1615 22.7885 13.8471 22.7885 11.186 20.1275C10.6002 19.5417 10.6002 18.5919 11.186 18.0061C11.7718 17.4204 12.7215 17.4204 13.3073 18.0061C14.7968 19.4956 17.2117 19.4956 18.7012 18.0061L26.2164 10.491C27.7059 9.00148 27.7059 6.58656 26.2164 5.09709C24.7278 3.60847 22.3148 3.60761 20.8251 5.0945C20.8242 5.09536 20.8234 5.09622 20.8225 5.09709L18.4121 7.53346C17.8295 8.12237 16.8797 8.12745 16.2908 7.5448C15.7019 6.96215 15.6968 6.01242 16.2795 5.42351L18.6955 2.98145L18.7012 2.97577ZM9.84447 11.8325C12.5055 9.17145 16.8199 9.17145 19.481 11.8325C20.0668 12.4183 20.0668 13.368 19.481 13.9538C18.8952 14.5396 17.9454 14.5396 17.3597 13.9538C15.8702 12.4643 13.4553 12.4643 11.9658 13.9538L4.4506 21.469C2.96113 22.9585 2.96113 25.3734 4.4506 26.8629C5.94008 28.3523 8.35499 28.3523 9.84447 26.8629L9.85408 26.8533L9.85413 26.8533L12.7521 24.0074C13.3432 23.4269 14.2929 23.4355 14.8733 24.0266C15.4538 24.6177 15.4452 25.5674 14.8541 26.1479L11.9606 28.9893C9.29919 31.6452 4.98862 31.6435 2.32928 28.9842C-0.331766 26.3231 -0.331766 22.0087 2.32928 19.3477L9.84447 11.8325Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const ExportIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-primary-main'
  return (
    <svg className={combinedClasses} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C10.5523 0 11 0.447715 11 1L11 11.5858L13.2929 9.29289C13.6834 8.90237 14.3166 8.90237 14.7071 9.29289C15.0976 9.68342 15.0976 10.3166 14.7071 10.7071L11.4142 14C10.6332 14.781 9.36684 14.781 8.58579 14L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L9 11.5858L9 1C9 0.447715 9.44772 5.96046e-08 10 0ZM1 13C1.55229 13 2 13.4477 2 14V14.2C2 15.0566 2.00078 15.6389 2.03755 16.089C2.07337 16.5274 2.1383 16.7516 2.21799 16.908C2.40973 17.2843 2.71569 17.5903 3.09202 17.782C3.24842 17.8617 3.47262 17.9266 3.91104 17.9624C4.36113 17.9992 4.94342 18 5.8 18H14.2C15.0566 18 15.6389 17.9992 16.089 17.9624C16.5274 17.9266 16.7516 17.8617 16.908 17.782C17.2843 17.5903 17.5903 17.2843 17.782 16.908C17.8617 16.7516 17.9266 16.5274 17.9624 16.089C17.9992 15.6389 18 15.0566 18 14.2V14C18 13.4477 18.4477 13 19 13C19.5523 13 20 13.4477 20 14V14.2413C20 15.0463 20 15.7106 19.9558 16.2518C19.9099 16.8139 19.8113 17.3306 19.564 17.816C19.1805 18.5686 18.5686 19.1805 17.816 19.564C17.3306 19.8113 16.8139 19.9099 16.2518 19.9558C15.7106 20 15.0463 20 14.2413 20H5.75868C4.95372 20 4.28936 20 3.74817 19.9558C3.18608 19.9099 2.66937 19.8113 2.18404 19.564C1.43139 19.1805 0.819469 18.5686 0.435975 17.816C0.188684 17.3306 0.0901197 16.8139 0.0441945 16.2518C-2.28137e-05 15.7106 -1.23241e-05 15.0463 4.31292e-07 14.2413L9.08129e-07 14C9.08129e-07 13.4477 0.447716 13 1 13Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const EmailBroadcastIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'text-[#07004D] cursor-pointer'
  return (
    <svg className={combinedClasses} viewBox="0 0 52 43" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0434 0.500002H41.9566C43.1867 0.49996 44.2478 0.499924 45.1218 0.571333C46.0443 0.646702 46.9618 0.813106 47.8447 1.26296C49.1618 1.93407 50.2327 3.00494 50.9038 4.32207C51.3536 5.20496 51.52 6.12247 51.5954 7.04494C51.6668 7.91893 51.6668 8.98002 51.6667 10.21V32.79C51.6668 34.02 51.6668 35.0811 51.5954 35.9551C51.52 36.8775 51.3536 37.795 50.9038 38.6779C50.2327 39.9951 49.1618 41.0659 47.8447 41.737C46.9618 42.1869 46.0443 42.3533 45.1218 42.4287C44.2478 42.5001 43.1867 42.5 41.9567 42.5H10.0434C8.8134 42.5 7.7523 42.5001 6.87831 42.4287C5.95584 42.3533 5.03833 42.1869 4.15544 41.737C2.83831 41.0659 1.76745 39.9951 1.09633 38.6779C0.64648 37.795 0.480076 36.8775 0.404707 35.9551C0.333298 35.0811 0.333334 34.02 0.333376 32.7899V10.2101C0.333334 8.98005 0.333298 7.91894 0.404707 7.04494C0.480076 6.12247 0.64648 5.20496 1.09633 4.32207C1.76745 3.00494 2.83831 1.93407 4.15544 1.26296C5.03833 0.813106 5.95584 0.646702 6.87831 0.571333C7.75232 0.499924 8.81343 0.49996 10.0434 0.500002ZM8.80505 5.17011L24.5675 17.4298C25.4101 18.0852 26.59 18.0852 27.4326 17.4298L43.195 5.17011C42.81 5.16693 42.372 5.16667 41.8667 5.16667H10.1334C9.62812 5.16667 9.1901 5.16693 8.80505 5.17011ZM46.9818 8.13685L30.2976 21.1134C27.7699 23.0795 24.2302 23.0795 21.7025 21.1135L5.01826 8.13685C5.00088 8.69466 5.00005 9.38774 5.00005 10.3V32.7C5.00005 34.0453 5.00186 34.9139 5.05588 35.5751C5.10767 36.2089 5.19558 36.4439 5.25436 36.5593C5.47807 36.9984 5.83502 37.3553 6.27407 37.579C6.38944 37.6378 6.62445 37.7257 7.25833 37.7775C7.91945 37.8315 8.78809 37.8333 10.1334 37.8333H41.8667C43.212 37.8333 44.0806 37.8315 44.7418 37.7775C45.3756 37.7257 45.6107 37.6378 45.726 37.579C46.1651 37.3553 46.522 36.9984 46.7457 36.5593C46.8045 36.4439 46.8924 36.2089 46.9442 35.5751C46.9982 34.9139 47 34.0453 47 32.7V10.3C47 9.38774 46.9992 8.69467 46.9818 8.13685Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const SettingsIconOutlined = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-black cursor-pointer'
  return (
    <svg viewBox="0 0 51 53" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1675 7.26929C16.1675 3.71476 19.049 0.833252 22.6035 0.833252H28.3981C31.9526 0.833252 34.8342 3.71477 34.8342 7.26931C34.8342 8.63131 36.3087 9.48268 37.4883 8.80161C40.5666 7.02434 44.503 8.07899 46.2803 11.1574L49.1775 16.1755C50.9548 19.2538 49.9 23.1901 46.8217 24.9674C45.6421 25.6484 45.6421 27.3511 46.8217 28.0321C49.9 29.8094 50.9548 33.7457 49.1775 36.824L46.2803 41.8421C44.503 44.9205 40.5667 45.9752 37.4884 44.1979C36.3088 43.5169 34.8342 44.3682 34.8342 45.7304C34.8342 49.285 31.9526 52.1666 28.398 52.1666H22.6036C19.049 52.1666 16.1675 49.285 16.1675 45.7304C16.1675 44.3682 14.6929 43.5169 13.5134 44.198C10.435 45.9752 6.4988 44.9205 4.72153 41.8422L1.82429 36.824C0.0470046 33.7457 1.10172 29.8094 4.18007 28.0321C5.35969 27.3511 5.35969 25.6484 4.18007 24.9674C1.10172 23.1901 0.0470071 19.2538 1.82429 16.1755L4.72153 11.1573C6.49882 8.07898 10.4351 7.02431 13.5134 8.80157C14.693 9.48263 16.1675 8.63129 16.1675 7.26929ZM22.6035 5.49992C21.6263 5.49992 20.8342 6.29209 20.8342 7.26929C20.8342 12.2238 15.4707 15.3202 11.1801 12.843C10.3338 12.3544 9.25158 12.6444 8.76298 13.4907L5.86574 18.5088C5.37712 19.3551 5.66709 20.4373 6.5134 20.9259C10.8041 23.4032 10.8041 29.5963 6.5134 32.0736C5.66709 32.5622 5.37712 33.6444 5.86574 34.4907L8.76298 39.5089C9.25159 40.3552 10.3337 40.6451 11.18 40.1565C15.4708 37.6792 20.8342 40.776 20.8342 45.7304C20.8342 46.7077 21.6264 47.4999 22.6036 47.4999H28.398C29.3752 47.4999 30.1675 46.7077 30.1675 45.7304C30.1675 40.7759 35.5309 37.6792 39.8217 40.1565C40.668 40.6451 41.7502 40.3551 42.2388 39.5088L45.136 34.4907C45.6247 33.6444 45.3347 32.5622 44.4884 32.0736C40.1976 29.5963 40.1976 23.4032 44.4884 20.9259C45.3347 20.4373 45.6247 19.3551 45.136 18.5088L42.2388 13.4907C41.7502 12.6444 40.668 12.3544 39.8216 12.8431C35.531 15.3203 30.1675 12.2239 30.1675 7.26931C30.1675 6.2921 29.3753 5.49992 28.3981 5.49992H22.6035ZM25.5008 19.4999C21.6348 19.4999 18.5008 22.6339 18.5008 26.4999C18.5008 30.3659 21.6348 33.4999 25.5008 33.4999C29.3668 33.4999 32.5008 30.3659 32.5008 26.4999C32.5008 22.6339 29.3668 19.4999 25.5008 19.4999ZM13.8342 26.4999C13.8342 20.0566 19.0575 14.8333 25.5008 14.8333C31.9442 14.8333 37.1675 20.0566 37.1675 26.4999C37.1675 32.9432 31.9442 38.1666 25.5008 38.1666C19.0575 38.1666 13.8342 32.9432 13.8342 26.4999Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const NewEditIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-[#07004D] cursor-pointer'
  return (
    <svg viewBox="0 0 15 15" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.37902 3.37305L2.36594 8.38612C2.21216 8.53986 2.10561 8.64637 2.01438 8.76729C1.93362 8.87435 1.86297 8.98867 1.80333 9.10878C1.73597 9.24445 1.68835 9.38738 1.61963 9.59366L0.954265 11.5898C0.818915 11.9958 0.707839 12.329 0.645248 12.5954C0.58311 12.8598 0.546728 13.1402 0.640934 13.4044C0.772059 13.7721 1.06143 14.0614 1.42914 14.1926C1.69332 14.2868 1.97369 14.2504 2.23813 14.1882C2.50449 14.1257 2.83768 14.0146 3.24372 13.8792L5.23982 13.2139C5.44611 13.1451 5.58904 13.0975 5.72471 13.0302C5.84483 12.9705 5.95915 12.8999 6.0662 12.8191C6.18713 12.7279 6.29364 12.6213 6.44738 12.4676L11.4604 7.45448L7.37902 3.37305Z"
        // fill="#07004D"
      />
      <path
        d="M12.6867 6.22825L12.9995 5.91542C13.4154 5.49991 13.6996 5.21598 13.8581 4.89603C14.1586 4.28956 14.1586 3.57752 13.8581 2.97105C13.6995 2.6511 13.4154 2.36717 12.9995 1.95165L12.8818 1.83396C12.4663 1.41811 12.1824 1.13395 11.8624 0.975399C11.256 0.674867 10.5439 0.674867 9.93747 0.975399C9.61752 1.13395 9.33358 1.41811 8.91807 1.83397L8.60525 2.14682L12.6867 6.22825Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const CrossIcon = ({ className, onClick }: IconProps) => {
  const combinedClasses = className || 'w-3.5 h-3.5 fill-black cursor-pointer'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
        // fill="black"
        // fillOpacity="0.56"
      />
    </svg>
  )
}

export const DeliveredIcon = () => {
  return (
    <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7555 23.7516L27.4946 0.0384862L0.845558 6.43423L5.85648 13.176L21.7221 4.34181L8.72536 17.0243L13.7555 23.7516Z"
        fill="#2E7D32"
      />
    </svg>
  )
}
export const RefreshFilled = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main cursor-pointer'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      className={combinedClasses}
    >
      <path d="M13.2374 4.7625C12.1499 3.675 10.6574 3 8.99995 3C5.68495 3 3.00745 5.685 3.00745 9C3.00745 12.315 5.68495 15 8.99995 15C11.7974 15 14.1299 13.0875 14.7974 10.5H13.2374C12.6224 12.2475 10.9574 13.5 8.99995 13.5C6.51745 13.5 4.49995 11.4825 4.49995 9C4.49995 6.5175 6.51745 4.5 8.99995 4.5C10.2449 4.5 11.3549 5.0175 12.1649 5.835L9.74995 8.25H14.9999V3L13.2374 4.7625Z" />
    </svg>
  )
}
export const DownloadFilled = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main cursor-pointer'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={combinedClasses}>
      <path d="M5 20H19V18H5V20ZM19 9H15V3H9V9H5L12 16L19 9Z" />
    </svg>
  )
}

export const NewDownloadIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main'
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" className={combinedClasses}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C10.5523 0 11 0.447715 11 1L11 11.5858L13.2929 9.29289C13.6834 8.90237 14.3166 8.90237 14.7071 9.29289C15.0976 9.68342 15.0976 10.3166 14.7071 10.7071L11.4142 14C10.6332 14.781 9.36684 14.781 8.58579 14L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L9 11.5858L9 1C9 0.447715 9.44772 5.96046e-08 10 0ZM1 13C1.55229 13 2 13.4477 2 14V14.2C2 15.0566 2.00078 15.6389 2.03755 16.089C2.07337 16.5274 2.1383 16.7516 2.21799 16.908C2.40973 17.2843 2.71569 17.5903 3.09202 17.782C3.24842 17.8617 3.47262 17.9266 3.91104 17.9624C4.36113 17.9992 4.94342 18 5.8 18H14.2C15.0566 18 15.6389 17.9992 16.089 17.9624C16.5274 17.9266 16.7516 17.8617 16.908 17.782C17.2843 17.5903 17.5903 17.2843 17.782 16.908C17.8617 16.7516 17.9266 16.5274 17.9624 16.089C17.9992 15.6389 18 15.0566 18 14.2V14C18 13.4477 18.4477 13 19 13C19.5523 13 20 13.4477 20 14V14.2413C20 15.0463 20 15.7106 19.9558 16.2518C19.9099 16.8139 19.8113 17.3306 19.564 17.816C19.1805 18.5686 18.5686 19.1805 17.816 19.564C17.3306 19.8113 16.8139 19.9099 16.2518 19.9558C15.7106 20 15.0463 20 14.2413 20H5.75868C4.95372 20 4.28936 20 3.74817 19.9558C3.18608 19.9099 2.66937 19.8113 2.18404 19.564C1.43139 19.1805 0.819469 18.5686 0.435975 17.816C0.188684 17.3306 0.0901197 16.8139 0.0441945 16.2518C-2.28137e-05 15.7106 -1.23241e-05 15.0463 4.31292e-07 14.2413L9.08129e-07 14C9.08129e-07 13.4477 0.447716 13 1 13Z"
      />
    </svg>
  )
}

export const AddListIcon = ({
  className,
  disabled
}: IconProps & { disabled?: boolean | number }) => {
  const combinedClasses = `${
    disabled ? 'fill-gray-400' : 'fill-primary-main'
  } cursor-pointer ${className || ''}`
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={combinedClasses}
    >
      <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" />
    </svg>
  )
}

export const OpeninNewFilled = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-4 h-5 fill-primary-main cursor-pointer'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="18"
      // height="18"
      viewBox="0 0 18 18"
      // fill="none"
      className={combinedClasses}
    >
      <path d="M14.25 14.25H3.75V3.75H9V2.25H3.75C2.9175 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.9175 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V9H14.25V14.25ZM10.5 2.25V3.75H13.1925L5.82 11.1225L6.8775 12.18L14.25 4.8075V7.5H15.75V2.25H10.5Z" />
    </svg>
  )
}

export const ContactIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
      <path
        d="M18.6665 13.334C20.6032 13.334 22.1548 11.7707 22.1548 9.83398C22.1548 7.89732 20.6032 6.33398 18.6665 6.33398C16.7298 6.33398 15.1665 7.89732 15.1665 9.83398C15.1665 11.7707 16.7298 13.334 18.6665 13.334ZM9.33317 13.334C11.2698 13.334 12.8215 11.7707 12.8215 9.83398C12.8215 7.89732 11.2698 6.33398 9.33317 6.33398C7.3965 6.33398 5.83317 7.89732 5.83317 9.83398C5.83317 11.7707 7.3965 13.334 9.33317 13.334ZM9.33317 15.6673C6.61484 15.6673 1.1665 17.0323 1.1665 19.7507L1.1665 22.6673H17.4998V19.7507C17.4998 17.0323 12.0515 15.6673 9.33317 15.6673ZM18.6665 15.6673C18.3282 15.6673 17.9432 15.6907 17.5348 15.7257C18.8882 16.7057 19.8332 18.024 19.8332 19.7507V22.6673H26.8332V19.7507C26.8332 17.0323 21.3848 15.6673 18.6665 15.6673Z"
        fill="#0288D1"
      />
    </svg>
  )
}

export const UploadFilled = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main cursor-pointer'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      viewBox="0 0 20 21"
      className={combinedClasses}
    >
      <path d="M4.16666 17.1667H15.8333V15.5H4.16666V17.1667ZM4.16666 8.83333H7.49999V13.8333H12.5V8.83333H15.8333L9.99999 3L4.16666 8.83333Z" />
    </svg>
  )
}

export const CrossFilled = ({ className = '', onClick = () => {} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M9.00033 0.666016C4.39199 0.666016 0.666992 4.39102 0.666992 8.99935C0.666992 13.6077 4.39199 17.3327 9.00033 17.3327C13.6087 17.3327 17.3337 13.6077 17.3337 8.99935C17.3337 4.39102 13.6087 0.666016 9.00033 0.666016ZM13.167 11.991L11.992 13.166L9.00033 10.1743L6.00866 13.166L4.83366 11.991L7.82533 8.99935L4.83366 6.00768L6.00866 4.83268L9.00033 7.82435L11.992 4.83268L13.167 6.00768L10.1753 8.99935L13.167 11.991Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const EyeFilled = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
      <path
        d="M13.9998 5.75C8.1665 5.75 3.18484 9.37833 1.1665 14.5C3.18484 19.6217 8.1665 23.25 13.9998 23.25C19.8332 23.25 24.8148 19.6217 26.8332 14.5C24.8148 9.37833 19.8332 5.75 13.9998 5.75ZM13.9998 20.3333C10.7798 20.3333 8.1665 17.72 8.1665 14.5C8.1665 11.28 10.7798 8.66667 13.9998 8.66667C17.2198 8.66667 19.8332 11.28 19.8332 14.5C19.8332 17.72 17.2198 20.3333 13.9998 20.3333ZM13.9998 11C12.0632 11 10.4998 12.5633 10.4998 14.5C10.4998 16.4367 12.0632 18 13.9998 18C15.9365 18 17.4998 16.4367 17.4998 14.5C17.4998 12.5633 15.9365 11 13.9998 11Z"
        fill="#2E7D32"
      />
    </svg>
  )
}

export const UnsubscribedIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path
        d="M11.9997 0.832031C5.55967 0.832031 0.333008 6.0587 0.333008 12.4987C0.333008 18.9387 5.55967 24.1654 11.9997 24.1654C18.4397 24.1654 23.6663 18.9387 23.6663 12.4987C23.6663 6.0587 18.4397 0.832031 11.9997 0.832031ZM11.9997 21.832C6.84301 21.832 2.66634 17.6554 2.66634 12.4987C2.66634 10.3404 3.40134 8.35703 4.63801 6.78203L17.7163 19.8604C16.1413 21.097 14.158 21.832 11.9997 21.832ZM19.3613 18.2154L6.28301 5.13703C7.85801 3.90036 9.84134 3.16536 11.9997 3.16536C17.1563 3.16536 21.333 7.34203 21.333 12.4987C21.333 14.657 20.598 16.6404 19.3613 18.2154Z"
        fill="#D32F2F"
      />
    </svg>
  )
}

export const ErrorFilled = ({ className }: IconProps) => {
  const classes = className ?? 'h-5 w-5'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={classes} viewBox="0 0 28 29" fill="none">
      <path
        d="M13.9997 2.83203C7.55967 2.83203 2.33301 8.0587 2.33301 14.4987C2.33301 20.9387 7.55967 26.1654 13.9997 26.1654C20.4397 26.1654 25.6663 20.9387 25.6663 14.4987C25.6663 8.0587 20.4397 2.83203 13.9997 2.83203ZM15.1663 20.332H12.833L12.833 17.9987H15.1663L15.1663 20.332ZM15.1663 15.6654H12.833V8.66536H15.1663V15.6654Z"
        fill="#D32F2F"
      />
    </svg>
  )
}

export const MarkasUnreadFilled = () => {
  return (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.196 6.10938H17.076L10.2 2.50938L2.4 6.58938L2.4 18.1094C1.08 18.1094 0 17.0294 0 15.7094L0 6.31338C0 5.67738 0.384 5.00538 0.96 4.70538L10.2 0.109375L19.248 4.70538C19.764 4.98138 20.124 5.54538 20.196 6.10938ZM21.6 7.30938L6 7.30938C4.68 7.30938 3.6 8.38938 3.6 9.70938L3.6 20.5094C3.6 21.8294 4.68 22.9094 6 22.9094H21.6C22.92 22.9094 24 21.8294 24 20.5094V9.70938C24 8.38938 22.92 7.30938 21.6 7.30938ZM21.6 11.7134L13.8 15.7094L6 11.7134V9.70938L13.8 13.7054L21.6 9.70938V11.7134Z"
        fill="#2E7D32"
      />
    </svg>
  )
}

export const MaskedIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-primary-main cursor-pointer'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={combinedClasses}
    >
      <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" />
    </svg>
  )
}

export const ArrowFilled = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M8.08711 5L6.91211 6.175L10.7288 10L6.91211 13.825L8.08711 15L13.0871 10L8.08711 5Z"
        fill="white"
      />
    </svg>
  )
}

export const ClickedIcon = () => {
  return (
    <svg width="20" height="27" viewBox="0 0 20 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1994 -0.00585938V9.51014L19.5994 9.51014C19.5994 4.61414 15.9394 0.582141 11.1994 -0.00585938ZM0.399414 16.7101C0.399414 22.0141 4.69541 26.3101 9.99941 26.3101C15.3034 26.3101 19.5994 22.0141 19.5994 16.7101V11.9101L0.399414 11.9101L0.399414 16.7101ZM8.79941 -0.00585938C4.05941 0.582141 0.399414 4.61414 0.399414 9.51014H8.79941V-0.00585938Z"
        fill="#2E7D32"
      />
    </svg>
  )
}

export const RemoveCircleFilled = ({
  className = 'w-[1.5rem] h-[1.563rem] fill-[#D32F2F]'
}: IconProps) => {
  return (
    <svg className={className} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0.109375C5.376 0.109375 0 5.48538 0 12.1094C0 18.7334 5.376 24.1094 12 24.1094C18.624 24.1094 24 18.7334 24 12.1094C24 5.48538 18.624 0.109375 12 0.109375ZM18 13.3094L6 13.3094V10.9094L18 10.9094V13.3094Z" />
    </svg>
  )
}
export const NewDeleteIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-3 h-4 fill-[#D32F2F] cursor-pointer'
  return (
    <svg viewBox="0 0 16 20" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.86319 4.16732H1.33333C0.873096 4.16732 0.5 4.54041 0.5 5.00065C0.5 5.46089 0.873096 5.83398 1.33333 5.83398V15.0006C1.33333 17.3018 3.19881 19.1673 5.5 19.1673H10.4106C12.6973 19.1673 14.5567 17.3244 14.5771 15.0379L14.6593 5.83398H14.6667C15.1269 5.83398 15.5 5.46089 15.5 5.00065C15.5 4.54041 15.1269 4.16732 14.6667 4.16732H12.1368C11.883 2.22053 10.0473 0.833984 8 0.833984C5.95268 0.833984 4.11697 2.22053 3.86319 4.16732ZM5.56181 4.16732H10.4382C10.1962 3.26534 9.26355 2.50065 8 2.50065C6.73645 2.50065 5.80384 3.26534 5.56181 4.16732Z"
        // fill="#D32F2F"
      />
    </svg>
  )
}

export const NewDeleteIconOutlined = ({ className, fill = '#D32F2F' }: IconProps) => {
  const combinedClasses = className || ''
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.03583 4H1C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6V17C1 19.7614 3.23857 22 6 22H11.8927C14.6367 22 16.868 19.7885 16.8925 17.0446L16.9911 6H17C17.5523 6 18 5.55228 18 5C18 4.44772 17.5523 4 17 4H13.9642C13.6596 1.66386 11.4568 0 9 0C6.54321 0 4.34037 1.66386 4.03583 4ZM6.07417 4H11.9258C11.6354 2.91763 10.5163 2 9 2C7.48374 2 6.36461 2.91763 6.07417 4ZM3 6V17C3 18.6569 4.34314 20 6 20H11.8927C13.5391 20 14.8779 18.6731 14.8926 17.0268L14.991 6H3Z"
        fill={fill}
      />
    </svg>
  )
}

export const NewMinesIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-3 h-4 fill-[#D32F2F] cursor-pointer'
  return (
    <svg
      className={combinedClasses}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99967 1.33325C4.93706 1.33325 0.833008 5.43731 0.833008 10.4999C0.833008 15.5625 4.93706 19.6666 9.99967 19.6666C15.0623 19.6666 19.1663 15.5625 19.1663 10.4999C19.1663 5.43731 15.0623 1.33325 9.99967 1.33325ZM14.1663 11.3333C14.6266 11.3333 14.9997 10.9602 14.9997 10.4999C14.9997 10.0397 14.6266 9.66658 14.1663 9.66658H5.83301C5.37277 9.66658 4.99967 10.0397 4.99967 10.4999C4.99967 10.9602 5.37277 11.3333 5.83301 11.3333H14.1663Z"
        fill="#D32F2F"
      />
    </svg>
  )
}

export const FailedIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-[#D32F2F] cursor-pointer'
  return (
    <svg className={combinedClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        fill="#D32F2F"
        d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9v-2h2v2zm0-4H9V5h2v6z"
      ></path>
    </svg>
  )
}

export const DisableLinkIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-[1.125rem] h-[1.125rem] fill-[#D32F2F] cursor-pointer'
  return (
    <svg className={combinedClasses} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.75 5.25H9.75V6.675H12.75C14.0325 6.675 15.075 7.7175 15.075 9C15.075 10.0725 14.34 10.9725 13.3425 11.235L14.4375 12.33C15.66 11.7075 16.5 10.4625 16.5 9C16.5 6.93 14.82 5.25 12.75 5.25ZM12 8.25H10.3575L11.8575 9.75H12V8.25ZM1.5 3.2025L3.8325 5.535C2.4675 6.09 1.5 7.4325 1.5 9C1.5 11.07 3.18 12.75 5.25 12.75H8.25V11.325H5.25C3.9675 11.325 2.925 10.2825 2.925 9C2.925 7.8075 3.8325 6.825 4.995 6.6975L6.5475 8.25H6V9.75H8.0475L9.75 11.4525V12.75H11.0475L14.055 15.75L15 14.805L2.4525 2.25L1.5 3.2025Z"
        fill="#D32F2F"
      />
    </svg>
  )
}

export const RemoveIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-none cursor-pointer'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 20 20">
      <g>
        <path
          fill="#D32F2F"
          d="M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm4.167 9.166H5.833V9.166h8.334v1.667z"
        ></path>
      </g>
    </svg>
  )
}

export const SendIcon = ({ className, onClick }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-primary-main cursor-pointer'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 56 51"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.91938 13.8047C5.94189 13.8478 5.98784 13.9164 6.13425 13.9823L23.7631 21.9176C23.812 21.9397 23.8606 21.9624 23.9087 21.9858L32.2467 15.7699C33.3669 14.9348 34.9519 15.1659 35.7869 16.2861C36.622 17.4062 36.3909 18.9913 35.2707 19.8263L26.9327 26.0422C26.9414 26.095 26.9493 26.148 26.9564 26.2012L29.5275 45.362C29.5488 45.5211 29.6015 45.5848 29.6364 45.6186C29.6861 45.6669 29.7727 45.7176 29.8909 45.7375C30.0092 45.7574 30.1079 45.7377 30.1711 45.7082C30.2156 45.6873 30.2865 45.644 30.3589 45.5003L50.2663 5.98337C50.4298 5.65873 50.153 5.28746 49.7953 5.35149L6.23912 13.146C6.08072 13.1743 6.01897 13.2299 5.98628 13.2667C5.93988 13.3188 5.89289 13.4078 5.87815 13.5268C5.86342 13.6458 5.88731 13.7433 5.91938 13.8047ZM4.05747 18.5961C-0.876831 16.375 0.0268365 9.11774 5.34785 8.16552L48.904 0.371014C53.3665 -0.427561 56.8245 4.21107 54.7849 8.2597L34.8775 47.7766C32.4456 52.6042 25.2325 51.3979 24.5128 46.0349L21.9418 26.8741C21.9216 26.7234 21.825 26.5938 21.6863 26.5314L4.05747 18.5961Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const MoreHorizFilledIcon = ({ className, onClick }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-none cursor-pointer'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const ProfileIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-icon-darkGray h-9 w-9 cursor-pointer'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={combinedClasses}>
      <g>
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"></path>
      </g>
    </svg>
  )
}
export const MyQuestionIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-white h-6 w-6 cursor-pointer'

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={combinedClasses}>
      <g>
        <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"></path>
      </g>
    </svg>
  )
}
export const NotifictionIcon = ({ className }: IconProps) => {
  const combinedClasses = className || ' h-9 w-9 cursor-pointer'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 24 24">
      <g>
        <path d="M12 21.75c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32v-.68c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.11 6 7.67 6 10.75v5l-2 2v1h16v-1l-2-2z"></path>
      </g>
    </svg>
  )
}
export const LockIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'fill-icon-darkGray h-9 w-9 cursor-pointer'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={combinedClasses}>
      <g>
        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path>
      </g>
    </svg>
  )
}

export const WatingIcon = ({ classes = '', stroke = '#EF6C00' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={classes}
      // fill="none"
      viewBox="0 0 24 24"
    >
      <g>
        <g fill={stroke}>
          <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"></path>
          <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
        </g>
      </g>
    </svg>
  )
}

export const AnnouncementIcon = ({ classes = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      // fill="none"
      className={classes}
      viewBox="0 0 18 18"
    >
      <g>
        <path
          // fill="#4729FF"
          d="M14.25 14.25H3.75V3.75H9v-1.5H3.75a1.5 1.5 0 00-1.5 1.5v10.5a1.5 1.5 0 001.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5V9h-1.5v5.25zm-3.75-12v1.5h2.693L5.82 11.123l1.058 1.057 7.372-7.372V7.5h1.5V2.25H10.5z"
        ></path>
      </g>
    </svg>
  )
}

export const AnnouncementBoardIcon = ({ classes = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={classes}
      viewBox="0 0 18 18"
    >
      <g>
        <path
          // fill="#4729FF"
          d="M14.25 14.25H3.75V3.75H9v-1.5H3.75a1.5 1.5 0 00-1.5 1.5v10.5a1.5 1.5 0 001.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5V9h-1.5v5.25zm-3.75-12v1.5h2.693L5.82 11.123l1.058 1.057 7.372-7.372V7.5h1.5V2.25H10.5z"
        ></path>
      </g>
    </svg>
  )
}

export const RefreshIcon = ({ classes = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      // fill="none"
      viewBox="0 0 12 12"
      className={classes}
    >
      <path
        // fill="#4729FF"
        d="M10.238 1.762A5.968 5.968 0 006 0 5.992 5.992 0 00.008 6c0 3.315 2.677 6 5.992 6a5.987 5.987 0 005.798-4.5h-1.56A4.493 4.493 0 016 10.5 4.504 4.504 0 011.5 6c0-2.482 2.018-4.5 4.5-4.5 1.245 0 2.355.518 3.165 1.335L6.75 5.25H12V0l-1.762 1.762z"
      ></path>
    </svg>
  )
}
export const RegenrateAiIcon = ({ classes = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 19" className={classes}>
      <path
        fillRule="evenodd"
        d="M10.5 2.828a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-5.771.619c.036-.154.256-.154.292 0l.392 1.66a.75.75 0 00.558.558l1.66.392c.154.036.154.256 0 .292l-1.66.392a.75.75 0 00-.558.558l-.392 1.66c-.036.154-.256.154-.292 0L4.337 7.3a.75.75 0 00-.558-.558l-1.66-.392c-.154-.036-.154-.256 0-.292l1.66-.392a.75.75 0 00.558-.557l.392-1.661zm5.406 3.178c.09-.385.64-.385.73 0l.62 2.63c.099.416.423.74.837.837l2.631.621c.386.091.386.64 0 .73l-2.63.62a1.125 1.125 0 00-.837.837l-.621 2.631c-.09.386-.64.386-.73 0l-.62-2.63a1.125 1.125 0 00-.837-.837l-2.631-.62c-.385-.092-.385-.64 0-.73l2.63-.622c.416-.098.74-.421.837-.836l.621-2.631z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export const StarLoader = ({ primaryColor = '#5A59A7', secondaryColor = '#E63D83' }) => {
  return (
    <div className="w-[7.309rem] h-[7.587rem] relative bg-transparent">
      <div className="absolute right-0 bottom-0">
        <motion.svg
          animate={{
            rotate: -20, // Rotate 360 degrees
            scale: [1, 0.2, 1] // Zoom in (1.2) and then back to normal (1)
          }}
          transition={{
            rotate: {
              duration: 3,
              repeat: Infinity,
              repeatType: 'reverse',
              repeatDelay: 0,
              ease: 'linear'
            },
            scale: {
              duration: 3,
              repeat: Infinity,
              repeatType: 'reverse',
              repeatDelay: 0,
              ease: 'linear'
            }
          }}
          viewBox="0 0 85 85"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-[5.236rem] h-[5.236rem]"
        >
          <path
            d="M39.2641 2.91259C40.0663 -0.489744 44.9092 -0.489744 45.7115 2.91259L51.1957 26.1526C52.0602 29.8169 54.9209 32.6775 58.5852 33.5421L81.825 39.0263C85.2276 39.8286 85.2276 44.6714 81.825 45.4737L58.5852 50.9579C54.9209 51.8224 52.0602 54.6831 51.1957 58.3474L45.7115 81.5872C44.9092 84.9899 40.0663 84.9899 39.2641 81.5872L33.7799 58.3474C32.9153 54.6831 30.0546 51.8224 26.3904 50.9579L3.15038 45.4737C-0.251951 44.6714 -0.251951 39.8286 3.15038 39.0263L26.3904 33.5421C30.0546 32.6775 32.9153 29.8169 33.7799 26.1526L39.2641 2.91259Z"
            fill="url(#paint0_linear_15428_11524)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_15428_11524"
              x1="42.4878"
              y1="0.36084"
              x2="42.4878"
              y2="84.1392"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor={primaryColor} />
              <stop offset="1" stopColor={secondaryColor} />
            </linearGradient>
          </defs>
        </motion.svg>
      </div>
      <div className="absolute top-[0.75rem] left-0">
        <motion.svg
          animate={{
            rotate: -20, // Rotate 360 degrees
            scale: [1, 1.8, 1] // Zoom in (1.2) and then back to normal (1)
          }}
          transition={{
            rotate: {
              duration: 3,
              repeat: Infinity,
              repeatType: 'reverse',
              repeatDelay: 0,
              ease: 'linear'
            },
            scale: {
              duration: 3,
              repeat: Infinity,
              repeatType: 'reverse',
              repeatDelay: 0,
              ease: 'linear'
            }
          }}
          viewBox="0 0 85 85"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-[3.171rem] h-[3.171rem]"
        >
          <path
            d="M39.2641 2.91259C40.0663 -0.489744 44.9092 -0.489744 45.7115 2.91259L51.1957 26.1526C52.0602 29.8169 54.9209 32.6775 58.5852 33.5421L81.825 39.0263C85.2276 39.8286 85.2276 44.6714 81.825 45.4737L58.5852 50.9579C54.9209 51.8224 52.0602 54.6831 51.1957 58.3474L45.7115 81.5872C44.9092 84.9899 40.0663 84.9899 39.2641 81.5872L33.7799 58.3474C32.9153 54.6831 30.0546 51.8224 26.3904 50.9579L3.15038 45.4737C-0.251951 44.6714 -0.251951 39.8286 3.15038 39.0263L26.3904 33.5421C30.0546 32.6775 32.9153 29.8169 33.7799 26.1526L39.2641 2.91259Z"
            fill="url(#paint0_linear_15428_11524)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_15428_11524"
              x1="42.4878"
              y1="0.36084"
              x2="42.4878"
              y2="84.1392"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor={primaryColor} />
              <stop offset="1" stopColor={secondaryColor} />
            </linearGradient>
          </defs>
        </motion.svg>
      </div>
      <div className="absolute top-0 right-[2.665rem]">
        <motion.svg
          animate={{
            rotate: -20, // Rotate 360 degrees
            scale: [1, 1.7, 1] // Zoom in (1.2) and then back to normal (1)
          }}
          transition={{
            rotate: {
              duration: 3,
              repeat: Infinity,
              repeatType: 'reverse',
              repeatDelay: 0,
              ease: 'linear'
            },
            scale: {
              duration: 3,
              repeat: Infinity,
              repeatType: 'reverse',
              repeatDelay: 0,
              ease: 'linear'
            }
          }}
          viewBox="0 0 85 85"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-[0.75rem] h-[0.75rem]"
        >
          <path
            d="M39.2641 2.91259C40.0663 -0.489744 44.9092 -0.489744 45.7115 2.91259L51.1957 26.1526C52.0602 29.8169 54.9209 32.6775 58.5852 33.5421L81.825 39.0263C85.2276 39.8286 85.2276 44.6714 81.825 45.4737L58.5852 50.9579C54.9209 51.8224 52.0602 54.6831 51.1957 58.3474L45.7115 81.5872C44.9092 84.9899 40.0663 84.9899 39.2641 81.5872L33.7799 58.3474C32.9153 54.6831 30.0546 51.8224 26.3904 50.9579L3.15038 45.4737C-0.251951 44.6714 -0.251951 39.8286 3.15038 39.0263L26.3904 33.5421C30.0546 32.6775 32.9153 29.8169 33.7799 26.1526L39.2641 2.91259Z"
            fill="url(#paint0_linear_15428_11524)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_15428_11524"
              x1="42.4878"
              y1="0.36084"
              x2="42.4878"
              y2="84.1392"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor={primaryColor} />
              <stop offset="1" stopColor={secondaryColor} />
            </linearGradient>
          </defs>
        </motion.svg>
      </div>
    </div>
  )
}

export const StarLoaderIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6'

  return (
    <motion.svg
      className={combinedClasses}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      animate={{
        rotate: [-10, 10, -10],
        scale: [1, 1.2, 1]
      }}
      transition={{
        duration: 2,
        repeat: Infinity,
        repeatType: 'loop',
        ease: 'easeInOut'
      }}
    >
      <path
        d="M14.2679 10.0246C14.389 9.51101 15.12 9.51101 15.2411 10.0246L16.0689 13.5325C16.1994 14.0856 16.6312 14.5174 17.1843 14.6479L20.6922 15.4757C21.2058 15.5968 21.2058 16.3278 20.6922 16.4489L17.1843 17.2767C16.6312 17.4072 16.1994 17.839 16.0689 18.3921L15.2411 21.9C15.12 22.4136 14.389 22.4136 14.2679 21.9L13.4401 18.3921C13.3096 17.839 12.8778 17.4072 12.3247 17.2767L8.81681 16.4489C8.30325 16.3278 8.30325 15.5968 8.81681 15.4757L12.3247 14.6479C12.8778 14.5174 13.3096 14.0856 13.4401 13.5325L14.2679 10.0246Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M7.06029 5.78712C7.10876 5.5817 7.40112 5.5817 7.44959 5.78712L7.97211 8.00144C8.05911 8.37015 8.347 8.65804 8.71571 8.74504L10.93 9.26756C11.1354 9.31603 11.1354 9.60839 10.93 9.65686L8.71571 10.1794C8.347 10.2664 8.05911 10.5543 7.97211 10.923L7.44959 13.1373C7.40112 13.3427 7.10876 13.3427 7.06029 13.1373L6.53777 10.923C6.45077 10.5543 6.16288 10.2664 5.79417 10.1794L3.57985 9.65686C3.37443 9.60839 3.37443 9.31603 3.57985 9.26756L5.79417 8.74504C6.16288 8.65804 6.45077 8.37015 6.53777 8.00144L7.06029 5.78712Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M13.6751 4.2394C13.6959 4.18308 13.7756 4.18308 13.7964 4.2394L13.97 4.70859C13.9766 4.7263 13.9905 4.74026 14.0082 4.74681L14.4774 4.92043C14.5338 4.94127 14.5338 5.02093 14.4774 5.04177L14.0082 5.21539C13.9905 5.22194 13.9766 5.2359 13.97 5.25361L13.7964 5.7228C13.7756 5.77912 13.6959 5.77912 13.6751 5.7228L13.5015 5.25361C13.4949 5.2359 13.4809 5.22194 13.4632 5.21539L12.994 5.04177C12.9377 5.02093 12.9377 4.94127 12.994 4.92043L13.4632 4.74681C13.4809 4.74026 13.4949 4.7263 13.5015 4.70859L13.6751 4.2394Z"
        fill="url(#paint2_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="9.17886"
          y1="8.9583"
          x2="17.8321"
          y2="22.2852"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07004D" />
          <stop offset="1" stopColor="#ADA0FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="7.25493"
          y1="7.37736"
          x2="17.2502"
          y2="22.0213"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07004D" />
          <stop offset="1" stopColor="#ADA0FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="12.9371"
          y1="3.97788"
          x2="21.6597"
          y2="14.5329"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07004D" />
          <stop offset="1" stopColor="#ADA0FF" />
        </linearGradient>
      </defs>
    </motion.svg>
  )
}

export const StarIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6'

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={combinedClasses}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5137 8.0625C13.6348 7.54894 14.3652 7.54894 14.4863 8.0625L15.3145 11.5703C15.445 12.1233 15.8767 12.555 16.4297 12.6855L19.9375 13.5137C20.4511 13.6348 20.4511 14.3652 19.9375 14.4863L16.4297 15.3145C15.8767 15.445 15.445 15.8767 15.3145 16.4297L14.4863 19.9375C14.3652 20.4511 13.6348 20.4511 13.5137 19.9375L12.6855 16.4297C12.555 15.8767 12.1233 15.445 11.5703 15.3145L8.0625 14.4863C7.54894 14.3652 7.54894 13.6348 8.0625 13.5137L11.5703 12.6855C12.1233 12.555 12.555 12.1233 12.6855 11.5703L13.5137 8.0625ZM6.30566 3.8252C6.35413 3.61978 6.64587 3.61978 6.69434 3.8252L7.2168 6.03906C7.3038 6.40777 7.59223 6.6962 7.96094 6.7832L10.1748 7.30566C10.3802 7.35413 10.3802 7.64587 10.1748 7.69434L7.96094 8.2168C7.59223 8.3038 7.3038 8.59223 7.2168 8.96094L6.69434 11.1748C6.64587 11.3802 6.35413 11.3802 6.30566 11.1748L5.7832 8.96094C5.6962 8.59223 5.40777 8.3038 5.03906 8.2168L2.8252 7.69434C2.61978 7.64587 2.61978 7.35413 2.8252 7.30566L5.03906 6.7832C5.40777 6.6962 5.6962 6.40777 5.7832 6.03906L6.30566 3.8252ZM13 2C13.5523 2 14 2.44772 14 3C14 3.55228 13.5523 4 13 4C12.4477 3.99997 12 3.55227 12 3C12 2.44773 12.4477 2.00003 13 2Z"
        fill="#07004D"
      />
    </svg>
  )
}

export const EditBoardIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6'

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={combinedClasses}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7348 4.15295C17.3233 3.94902 16.8401 3.94902 16.4286 4.15295C16.2494 4.24176 16.0486 4.42381 15.3179 5.15453L14.7896 5.6829L18.3172 9.21049L18.8455 8.68212C19.5762 7.9514 19.7583 7.75065 19.8471 7.57143C20.051 7.1599 20.051 6.67674 19.8471 6.26522C19.7583 6.086 19.5762 5.88525 18.8455 5.15453C18.1148 4.42381 17.9141 4.24176 17.7348 4.15295ZM19.0292 11.3269L20.2597 10.0963C20.297 10.0591 20.3338 10.0224 20.3701 9.98612C20.9349 9.42239 21.3842 8.97384 21.6391 8.45946C22.1203 7.48838 22.1203 6.34827 21.6391 5.37719C21.3842 4.86281 20.9349 4.41426 20.3701 3.85053C20.3338 3.81428 20.297 3.77756 20.2597 3.74031C20.2225 3.70307 20.1858 3.66629 20.1495 3.62998C19.5858 3.0652 19.1372 2.61581 18.6229 2.36091C17.6518 1.8797 16.5117 1.8797 15.5406 2.36091C15.0262 2.6158 14.5777 3.06519 14.0139 3.62997C13.9777 3.66628 13.941 3.70307 13.9037 3.74031L4.68003 12.964C4.66739 12.9766 4.6549 12.9891 4.64254 13.0015C4.43267 13.2112 4.26255 13.3812 4.11598 13.5755C3.98667 13.7469 3.87354 13.9299 3.77805 14.1222C3.66982 14.3402 3.59386 14.5684 3.50015 14.8499C3.49463 14.8665 3.48905 14.8832 3.48339 14.9002L2.54318 17.7208C2.35448 18.2869 2.19145 18.7759 2.09822 19.1726C2.00607 19.5648 1.93114 20.056 2.10414 20.5412C2.32952 21.1732 2.82687 21.6705 3.45888 21.8959C3.94404 22.0689 4.43526 21.994 4.8274 21.9018C5.22418 21.8086 5.71321 21.6456 6.27926 21.4569L9.09985 20.5167C9.11681 20.511 9.13357 20.5054 9.15014 20.4999C9.43164 20.4062 9.65981 20.3302 9.8778 20.222C10.0701 20.1265 10.2532 20.0134 10.4246 19.8841C10.6189 19.7375 10.7889 19.5674 10.9986 19.3575C11.0109 19.3452 11.0234 19.3327 11.036 19.32L19.0193 11.3367C19.021 11.3351 19.0226 11.3335 19.0243 11.3318C19.0259 11.3302 19.0275 11.3285 19.0292 11.3269ZM16.9029 10.6247L13.3753 7.09711L6.09424 14.3782C5.82925 14.6432 5.76472 14.7109 5.71261 14.7799C5.65781 14.8526 5.60987 14.9301 5.5694 15.0117C5.53092 15.0892 5.49927 15.1771 5.38076 15.5326L4.45518 18.3094C4.24768 18.9319 4.11496 19.3332 4.04519 19.6301C4.00862 19.7858 4.00174 19.8665 4.00031 19.8979C4.02277 19.9417 4.05839 19.9773 4.1021 19.9997C4.13354 19.9983 4.21429 19.9914 4.3699 19.9549C4.66684 19.8851 5.06816 19.7524 5.69064 19.5449L8.4674 18.6193C8.82293 18.5008 8.91089 18.4691 8.9884 18.4306C9.0699 18.3902 9.14747 18.3422 9.22011 18.2874C9.28919 18.2353 9.35684 18.1708 9.62184 17.9058L16.9029 10.6247Z"
        fill="#07004D"
      />
    </svg>
  )
}

export const BoardPlusIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-[13px] h-[13px] fill-white'

  return (
    <svg viewBox="0 0 14 14" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 0C7.16421 0 7.5 0.335786 7.5 0.75V6H12.75C13.1642 6 13.5 6.33579 13.5 6.75C13.5 7.16421 13.1642 7.5 12.75 7.5H7.5V12.75C7.5 13.1642 7.16421 13.5 6.75 13.5C6.33579 13.5 6 13.1642 6 12.75V7.5H0.75C0.335786 7.5 0 7.16421 0 6.75C0 6.33579 0.335786 6 0.75 6H6V0.75C6 0.335786 6.33579 0 6.75 0Z"
        // fill="white"
      />
    </svg>
  )
}

export const MinusIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-2.5 h-[2px] fill-white'

  return (
    <svg className={combinedClasses} viewBox="0 0 11 2" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.75C0 0.335786 0.335786 0 0.75 0L9.75 2.68221e-07C10.1642 2.68221e-07 10.5 0.335787 10.5 0.75C10.5 1.16421 10.1642 1.5 9.75 1.5L0.75 1.5C0.335786 1.5 0 1.16421 0 0.75Z"
        // fill="white"
      />
    </svg>
  )
}

export const BoardDeleteIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6'

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.03583 5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7V18C4 20.7614 6.23857 23 9 23H14.8927C17.6367 23 19.868 20.7885 19.8925 18.0446L19.9911 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H16.9642C16.6596 2.66386 14.4568 1 12 1C9.54321 1 7.34037 2.66386 7.03583 5ZM9.07417 5H14.9258C14.6354 3.91763 13.5163 3 12 3C10.4837 3 9.36461 3.91763 9.07417 5ZM6 7V18C6 19.6569 7.34314 21 9 21H14.8927C16.5391 21 17.8779 19.6731 17.8926 18.0268L17.991 7H6Z"
        fill="#D32F2F"
      />
    </svg>
  )
}

export const BoardMinIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6'

  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 2"
      fill="none"
      className={combinedClasses}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.75C0 0.335786 0.335786 0 0.75 0L9.75 2.68221e-07C10.1642 2.68221e-07 10.5 0.335787 10.5 0.75C10.5 1.16421 10.1642 1.5 9.75 1.5L0.75 1.5C0.335786 1.5 0 1.16421 0 0.75Z"
        fill="white"
      />
    </svg>
  )
}

export const BoardDivIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-[13px] h-[13.5px] fill-white'

  return (
    <svg viewBox="0 0 8 14" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.08557 0.0793439C7.45606 0.264586 7.60623 0.715091 7.42099 1.08557L1.42098 13.0856C1.23574 13.4561 0.785238 13.6062 0.414754 13.421C0.0442702 13.2357 -0.105898 12.7852 0.0793439 12.4148L6.07934 0.414754C6.26459 0.0442702 6.71509 -0.105898 7.08557 0.0793439Z"
      />
    </svg>
  )
}

export const NewCheckIcon = ({ classes = 'fill-primary-main' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      className={classes}
      // fill="none"
      viewBox="0 0 16 12"
    >
      <path
        // fill="#03A9F4"
        d="M4.719 7.132l1.294 1.294 7.76-7.76 1.296 1.297-9.056 9.056L.179 5.185 1.476 3.89l1.947 1.948L4.72 7.132z"
      ></path>
    </svg>
  )
}

export const MsgIcon = ({ classes = 'h-4' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={classes} viewBox="0 0 24 25">
      <g clipPath="url(#clip0_2334_118788)">
        <path
          fill="#000"
          fillOpacity="0.54"
          d="M20.334 8.067v7.516c0 .917-.75 1.667-1.667 1.667H7l-3.333 3.333v-15c0-.916.75-1.666 1.667-1.666h8.416a4.168 4.168 0 004.083 5c.942 0 1.8-.325 2.5-.85zm-5-3.317c0 1.383 1.116 2.5 2.5 2.5 1.383 0 2.5-1.117 2.5-2.5s-1.117-2.5-2.5-2.5a2.497 2.497 0 00-2.5 2.5z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2334_118788">
          <path fill="#fff" d="M0 0H20V20H0z" transform="translate(2 2.25)"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export const ThreeDotIcon = ({ classes = 'h-4' }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      // className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 8.88281C13.6 8.88281 14.5 7.98281 14.5 6.88281C14.5 5.78281 13.6 4.88281 12.5 4.88281C11.4 4.88281 10.5 5.78281 10.5 6.88281C10.5 7.98281 11.4 8.88281 12.5 8.88281ZM12.5 10.8828C11.4 10.8828 10.5 11.7828 10.5 12.8828C10.5 13.9828 11.4 14.8828 12.5 14.8828C13.6 14.8828 14.5 13.9828 14.5 12.8828C14.5 11.7828 13.6 10.8828 12.5 10.8828ZM12.5 16.8828C11.4 16.8828 10.5 17.7828 10.5 18.8828C10.5 19.9828 11.4 20.8828 12.5 20.8828C13.6 20.8828 14.5 19.9828 14.5 18.8828C14.5 17.7828 13.6 16.8828 12.5 16.8828Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}

export const ErrorResult = ({}) => {
  return (
    <svg width="52" height="51" viewBox="0 0 52 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.0001 0.169922C12.0356 0.169922 0.702148 11.5034 0.702148 25.4679C0.702148 39.4324 12.0356 50.7658 26.0001 50.7658C39.9646 50.7658 51.2981 39.4324 51.2981 25.4679C51.2981 11.5034 39.9646 0.169922 26.0001 0.169922ZM28.5299 38.1169H23.4703V33.0573H28.5299V38.1169ZM28.5299 27.9977H23.4703V12.8189H28.5299V27.9977Z"
        fill="#D32F2F"
      />
    </svg>
  )
}

export const ThemeIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg" className={combinedClasses}>
      <path d="M9 0.226562C4.03 0.226562 0 4.25656 0 9.22656C0 14.1966 4.03 18.2266 9 18.2266C9.83 18.2266 10.5 17.5566 10.5 16.7266C10.5 16.3366 10.35 15.9866 10.11 15.7166C9.88 15.4566 9.73 15.1066 9.73 14.7266C9.73 13.8966 10.4 13.2266 11.23 13.2266H13C15.76 13.2266 18 10.9866 18 8.22656C18 3.80656 13.97 0.226562 9 0.226562ZM3.5 9.22656C2.67 9.22656 2 8.55656 2 7.72656C2 6.89656 2.67 6.22656 3.5 6.22656C4.33 6.22656 5 6.89656 5 7.72656C5 8.55656 4.33 9.22656 3.5 9.22656ZM6.5 5.22656C5.67 5.22656 5 4.55656 5 3.72656C5 2.89656 5.67 2.22656 6.5 2.22656C7.33 2.22656 8 2.89656 8 3.72656C8 4.55656 7.33 5.22656 6.5 5.22656ZM11.5 5.22656C10.67 5.22656 10 4.55656 10 3.72656C10 2.89656 10.67 2.22656 11.5 2.22656C12.33 2.22656 13 2.89656 13 3.72656C13 4.55656 12.33 5.22656 11.5 5.22656ZM14.5 9.22656C13.67 9.22656 13 8.55656 13 7.72656C13 6.89656 13.67 6.22656 14.5 6.22656C15.33 6.22656 16 6.89656 16 7.72656C16 8.55656 15.33 9.22656 14.5 9.22656Z" />
    </svg>
  )
}

export const CommentNotifyIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-none'
  return (
    <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" className={combinedClasses}>
      <rect width={40} height={40} rx={20} fill="#2E7D32" />
      <path d="M29 14H27V23H14V25C14 25.55 14.45 26 15 26H26L30 30V15C30 14.45 29.55 14 29 14ZM25 20V11C25 10.45 24.55 10 24 10H11C10.45 10 10 10.45 10 11V25L14 21H24C24.55 21 25 20.55 25 20Z" />
    </svg>
  )
}

export const SingleDotIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-3 h-3 fill-none'
  return (
    <svg className={combinedClasses} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
      <rect width={12} height={12} rx={6} fill="#0288D1" />
    </svg>
  )
}

export const DesktopNotificationIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-[1.563rem] fill-none'
  return (
    <svg className={combinedClasses} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      {' '}
      <path
        d="M12 22.5C13.1 22.5 14 21.6 14 20.5H10C10 21.6 10.9 22.5 12 22.5ZM18 16.5V11.5C18 8.43 16.37 5.86 13.5 5.18V4.5C13.5 3.67 12.83 3 12 3C11.17 3 10.5 3.67 10.5 4.5V5.18C7.64003 5.86 6.00003 8.42 6.00003 11.5V16.5L4.00003 18.5V19.5H20V18.5L18 16.5ZM16 17.5H8.00003V11.5C8.00003 9.02 9.51003 7 12 7C14.49 7 16 9.02 16 11.5V17.5ZM7.58003 4.58L6.15003 3.15C3.75003 4.98 2.17003 7.8 2.03003 11H4.03003C4.18003 8.35 5.54003 6.03 7.58003 4.58ZM19.97 11H21.97C21.82 7.8 20.24 4.98 17.85 3.15L16.43 4.58C18.45 6.03 19.82 8.35 19.97 11Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  )
}
export const InfoIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.49996 0.666992C3.89996 0.666992 0.166626 4.40033 0.166626 9.00033C0.166626 13.6003 3.89996 17.3337 8.49996 17.3337C13.1 17.3337 16.8333 13.6003 16.8333 9.00033C16.8333 4.40033 13.1 0.666992 8.49996 0.666992ZM9.33329 13.167H7.66663V8.16699H9.33329V13.167ZM9.33329 6.50033H7.66663V4.83366H9.33329V6.50033Z" />
    </svg>
  )
}

export const LeftButtonIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.70696 1.02287C6.09748 1.4134 6.09748 2.04656 5.70696 2.43709L3.41406 4.72998L11.9998 4.72998C14.209 4.72998 15.9998 6.52084 15.9998 8.72998V9.72998C15.9998 10.2823 15.5521 10.73 14.9998 10.73C14.4476 10.73 13.9998 10.2823 13.9998 9.72998V8.72998C13.9998 7.62541 13.1044 6.72998 11.9998 6.72998L3.41406 6.72998L5.70696 9.02287C6.09748 9.4134 6.09748 10.0466 5.70696 10.4371C5.31643 10.8276 4.68327 10.8276 4.29274 10.4371L0.999849 7.14419C0.218799 6.36314 0.218801 5.09681 0.999849 4.31577L4.29274 1.02287C4.68327 0.632349 5.31643 0.632349 5.70696 1.02287Z"
        fill="white"
      />
    </svg>
  )
}

export const RightButtonIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2929 1.02287C10.6834 0.632349 11.3166 0.632349 11.7071 1.02287L15 4.31577C15.781 5.09681 15.7811 6.36314 15 7.14419L11.7071 10.4371C11.3166 10.8276 10.6834 10.8276 10.2929 10.4371C9.90237 10.0466 9.90237 9.4134 10.2929 9.02287L12.5858 6.72998H4C2.89543 6.72998 2 7.62541 2 8.72998V9.72998C2 10.2823 1.55228 10.73 1 10.73C0.447715 10.73 0 10.2823 0 9.72998V8.72998C0 6.52084 1.79086 4.72998 4 4.72998H12.5858L10.2929 2.43709C9.90237 2.04656 9.90237 1.4134 10.2929 1.02287Z"
        fill="white"
        fillOpacity="0.3"
      />
    </svg>
  )
}

export const AiIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-white'
  return (
    <svg viewBox="0 0 19 20" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5134 6.79248C11.6345 6.27892 12.365 6.27892 12.4861 6.79248L13.3142 10.3003C13.4447 10.8533 13.8765 11.285 14.4295 11.4155L17.9373 12.2437C18.4509 12.3648 18.4509 13.0952 17.9373 13.2163L14.4295 14.0444C13.8765 14.175 13.4447 14.6067 13.3142 15.1597L12.4861 18.6675C12.365 19.1811 11.6345 19.1811 11.5134 18.6675L10.6853 15.1597C10.5548 14.6067 10.1231 14.1749 9.57008 14.0444L6.06227 13.2163C5.54871 13.0952 5.54871 12.3648 6.06227 12.2437L9.57008 11.4155C10.1231 11.285 10.5548 10.8533 10.6853 10.3003L11.5134 6.79248ZM4.30543 2.55518C4.3539 2.34976 4.64563 2.34976 4.6941 2.55518L5.21657 4.76904C5.30357 5.13775 5.592 5.42618 5.96071 5.51318L8.17457 6.03564C8.37997 6.08411 8.37997 6.37585 8.17457 6.42432L5.96071 6.94678C5.592 7.03378 5.30357 7.32221 5.21657 7.69092L4.6941 9.90479C4.64563 10.1102 4.3539 10.1102 4.30543 9.90479L3.78297 7.69092C3.69597 7.32221 3.40754 7.03378 3.03883 6.94678L0.824963 6.42432C0.619543 6.37585 0.619543 6.08411 0.824963 6.03564L3.03883 5.51318C3.40754 5.42618 3.69597 5.13775 3.78297 4.76904L4.30543 2.55518ZM10.9998 0.72998C11.5521 0.72998 11.9998 1.1777 11.9998 1.72998C11.9998 2.28227 11.5521 2.72998 10.9998 2.72998C10.4475 2.72995 9.99977 2.28225 9.99977 1.72998C9.99977 1.17771 10.4475 0.730009 10.9998 0.72998Z"
        // fill="white"
      />
    </svg>
  )
}

export const SendChatIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-white'
  return (
    <svg viewBox="0 0 20 21" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.15283 0.965176C1.24155 0.00981671 -0.759414 2.09625 0.279593 3.96591L3.19702 9.21573C3.37341 9.53314 3.70799 9.72998 4.07111 9.72998L10 9.72998C10.5523 9.72998 11 10.1777 11 10.73C11 11.2823 10.5523 11.73 10 11.73L4.07133 11.73C3.7082 11.73 3.37362 11.9268 3.19723 12.2442L0.279592 17.4944C-0.759414 19.3641 1.24154 21.4505 3.15283 20.4952L18.798 12.6749C20.4009 11.8737 20.4009 9.58666 18.798 8.78544L3.15283 0.965176Z"
        // fill="white"
      />
    </svg>
  )
}
export const InfoIconOutlined = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg viewBox="0 0 20 20" className={combinedClasses} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0002 2.50016C5.85803 2.50016 2.50016 5.85803 2.50016 10.0002C2.50016 14.1423 5.85803 17.5002 10.0002 17.5002C14.1423 17.5002 17.5002 14.1423 17.5002 10.0002C17.5002 5.85803 14.1423 2.50016 10.0002 2.50016ZM0.833496 10.0002C0.833496 4.93755 4.93755 0.833496 10.0002 0.833496C15.0628 0.833496 19.1668 4.93755 19.1668 10.0002C19.1668 15.0628 15.0628 19.1668 10.0002 19.1668C4.93755 19.1668 0.833496 15.0628 0.833496 10.0002ZM10.0002 5.8333C10.4604 5.8333 10.8335 6.2064 10.8335 6.66663V6.67497C10.8335 7.1352 10.4604 7.5083 10.0002 7.5083C9.53992 7.5083 9.16683 7.1352 9.16683 6.67497V6.66663C9.16683 6.2064 9.53992 5.8333 10.0002 5.8333ZM10.0002 8.34163C10.4604 8.34163 10.8335 8.71473 10.8335 9.17497V13.3416C10.8335 13.8019 10.4604 14.175 10.0002 14.175C9.53992 14.175 9.16683 13.8019 9.16683 13.3416V9.17497C9.16683 8.71473 9.53992 8.34163 10.0002 8.34163Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const UserIconOutlined = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#07004D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9998 2C8.1003 2 5.7498 4.3505 5.7498 7.25C5.7498 10.1495 8.1003 12.5 10.9998 12.5C13.8993 12.5 16.2498 10.1495 16.2498 7.25C16.2498 4.3505 13.8993 2 10.9998 2ZM15.2194 13.1462C17.0543 11.8307 18.2498 9.67998 18.2498 7.25C18.2498 3.24594 15.0039 0 10.9998 0C6.99573 0 3.7498 3.24594 3.7498 7.25C3.7498 9.67998 4.94528 11.8307 6.78018 13.1462C3.74582 14.1152 1.3365 16.1108 0.403891 18.7011C0.0794569 19.6022 0.33151 20.4723 0.872763 21.0767C1.39506 21.66 2.17871 22 2.9998 22H18.9998C19.8209 22 20.6045 21.66 21.1268 21.0767C21.6681 20.4723 21.9201 19.6022 21.5957 18.7011C20.6631 16.1108 18.2538 14.1152 15.2194 13.1462ZM10.9998 14.5C6.65581 14.5 3.24777 16.7064 2.28564 19.3786C2.2359 19.5168 2.25908 19.6268 2.36274 19.7426C2.48536 19.8795 2.71631 20 2.9998 20H18.9998C19.2833 20 19.5142 19.8795 19.6369 19.7426C19.7405 19.6268 19.7637 19.5168 19.714 19.3786C18.7518 16.7064 15.3438 14.5 10.9998 14.5Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const TicketIconOutlined = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1737 3C19.1737 2.44786 18.7257 2.00023 18.1737 2H10.9959C10.7306 2 10.4755 2.10529 10.2879 2.29297L2.2928 10.2939C1.90285 10.6841 1.90231 11.3165 2.29182 11.707L9.44807 18.8779C9.8382 19.2688 10.4712 19.269 10.8621 18.8789L18.8797 10.8779C19.0676 10.6904 19.1737 10.4354 19.1737 10.1699V3ZM15.1737 4C16.2781 4.0002 17.1737 4.89556 17.1737 6C17.1737 7.10444 16.2781 7.9998 15.1737 8C14.0691 8 13.1737 7.10457 13.1737 6C13.1737 4.89543 14.0691 4 15.1737 4ZM21.1737 10.1699C21.1737 10.9666 20.8566 11.7312 20.2928 12.2939L12.2752 20.2949C11.1026 21.4652 9.20345 21.4635 8.03303 20.291L0.87678 13.1201C-0.292517 11.9485 -0.292328 10.0507 0.877756 8.87988L8.87385 0.878906C9.43648 0.316133 10.2001 0 10.9959 0H18.1737C19.8303 0.000226754 21.1736 1.34329 21.1737 3V10.1699Z"
        fill="#07004D"
      />
    </svg>
  )
}

export const AddProfileIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 28 21" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5999 10.4994C20.2519 10.4994 22.3999 8.35141 22.3999 5.69941C22.3999 3.04741 20.2519 0.899414 17.5999 0.899414C14.9479 0.899414 12.7999 3.04741 12.7999 5.69941C12.7999 8.35141 14.9479 10.4994 17.5999 10.4994ZM6.79993 8.09941V4.49941H4.39993V8.09941H0.799927L0.799927 10.4994H4.39993L4.39993 14.0994H6.79993V10.4994H10.3999V8.09941H6.79993ZM17.5999 12.8994C14.3959 12.8994 7.99993 14.5074 7.99993 17.6994V20.0994H27.1999V17.6994C27.1999 14.5074 20.8039 12.8994 17.5999 12.8994Z" />
    </svg>
  )
}
export const OfferIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 27 26" xmlns="http://www.w3.org/2000/svg">
      <path d="M26.6 12.9006L23.672 9.56463L24.08 5.14863L19.748 4.16463L17.48 0.348633L13.4 2.10063L9.31995 0.348633L7.05195 4.16463L2.71995 5.13663L3.12795 9.55263L0.199951 12.9006L3.12795 16.2366L2.71995 20.6646L7.05195 21.6486L9.31995 25.4646L13.4 23.7006L17.48 25.4526L19.748 21.6366L24.08 20.6526L23.672 16.2366L26.6 12.9006ZM14.6 18.9006H12.2V16.5006H14.6V18.9006ZM14.6 14.1006H12.2V6.90063H14.6V14.1006Z" />
    </svg>
  )
}
export const StopIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0.5C5.376 0.5 0 5.876 0 12.5C0 19.124 5.376 24.5 12 24.5C18.624 24.5 24 19.124 24 12.5C24 5.876 18.624 0.5 12 0.5ZM18 13.7L6 13.7V11.3L18 11.3V13.7Z" />
    </svg>
  )
}
export const ChatIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.5 4.99967H20.1667V15.4997L5.00004 15.4997V17.833C5.00004 18.4747 5.52504 18.9997 6.16671 18.9997H19L23.6667 23.6663V6.16634C23.6667 5.52467 23.1417 4.99967 22.5 4.99967ZM17.8334 11.9997V1.49967C17.8334 0.858008 17.3084 0.333008 16.6667 0.333008L1.50004 0.333008C0.858374 0.333008 0.333374 0.858008 0.333374 1.49967L0.333374 17.833L5.00004 13.1663L16.6667 13.1663C17.3084 13.1663 17.8334 12.6413 17.8334 11.9997Z" />
    </svg>
  )
}
export const LikeIconFilled = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 27 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.833374 23.4994H5.50004V9.49935H0.833374L0.833374 23.4994ZM26.5 10.666C26.5 9.38268 25.45 8.33268 24.1667 8.33268L16.805 8.33268L17.9134 3.00102L17.9484 2.62768C17.9484 2.14935 17.75 1.70602 17.435 1.39102L16.1984 0.166016L8.52171 7.85435C8.09004 8.27435 7.83337 8.85768 7.83337 9.49935V21.166C7.83337 22.4494 8.88337 23.4994 10.1667 23.4994H20.6667C21.635 23.4994 22.4634 22.916 22.8134 22.076L26.3367 13.851C26.4417 13.5827 26.5 13.3027 26.5 12.9993V10.666Z" />
    </svg>
  )
}

export const NewLikeIconFilled = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-primary-main'
  return (
    <svg className={combinedClasses} viewBox="0 0 27 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.833374 23.4994H5.50004V9.49935H0.833374L0.833374 23.4994ZM26.5 10.666C26.5 9.38268 25.45 8.33268 24.1667 8.33268L16.805 8.33268L17.9134 3.00102L17.9484 2.62768C17.9484 2.14935 17.75 1.70602 17.435 1.39102L16.1984 0.166016L8.52171 7.85435C8.09004 8.27435 7.83337 8.85768 7.83337 9.49935V21.166C7.83337 22.4494 8.88337 23.4994 10.1667 23.4994H20.6667C21.635 23.4994 22.4634 22.916 22.8134 22.076L26.3367 13.851C26.4417 13.5827 26.5 13.3027 26.5 12.9993V10.666Z" />
    </svg>
  )
}

export const ShareIconNew = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg
      className={combinedClasses}
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.9166 6.87467V0.708008L28.7083 11.4997L17.9166 22.2913V15.9705C10.2083 15.9705 4.81242 18.4372 0.958248 23.833C2.49992 16.1247 7.12492 8.41634 17.9166 6.87467Z" />
    </svg>
  )
}

export const CalenderIcon = ({ className, onClick }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg
      onClick={onClick}
      className={combinedClasses}
      viewBox="0 0 25 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22 3.1002H20.8V0.700195L18.4 0.700195V3.1002L6.40002 3.1002V0.700195L4.00002 0.700195V3.1002H2.80002C1.48002 3.1002 0.400024 4.1802 0.400024 5.5002L0.400024 24.7002C0.400024 26.0202 1.48002 27.1002 2.80002 27.1002H22C23.32 27.1002 24.4 26.0202 24.4 24.7002V5.5002C24.4 4.1802 23.32 3.1002 22 3.1002ZM22 24.7002H2.80002L2.80002 9.1002L22 9.1002V24.7002Z" />
    </svg>
  )
}

export const CopyEmailIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 24 23" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.196 6H17.076L10.2 2.4L2.4 6.48L2.4 18C1.08 18 0 16.92 0 15.6L0 6.204C0 5.568 0.384 4.896 0.96 4.596L10.2 0L19.248 4.596C19.764 4.872 20.124 5.436 20.196 6ZM21.6 7.2L6 7.2C4.68 7.2 3.6 8.28 3.6 9.6L3.6 20.4C3.6 21.72 4.68 22.8 6 22.8H21.6C22.92 22.8 24 21.72 24 20.4V9.6C24 8.28 22.92 7.2 21.6 7.2ZM21.6 11.604L13.8 15.6L6 11.604V9.6L13.8 13.596L21.6 9.6V11.604Z" />
    </svg>
  )
}

export const MouseIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 20 28" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.2 0.883789V10.3998L19.6 10.3998C19.6 5.50379 15.94 1.47179 11.2 0.883789ZM0.400024 17.5998C0.400024 22.9038 4.69602 27.1998 10 27.1998C15.304 27.1998 19.6 22.9038 19.6 17.5998V12.7998L0.400024 12.7998L0.400024 17.5998ZM8.80002 0.883789C4.06002 1.47179 0.400024 5.50379 0.400024 10.3998H8.80002V0.883789Z" />
    </svg>
  )
}
export const MultiUserIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 23 14" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.6666 6C17.3266 6 18.6566 4.66 18.6566 3C18.6566 1.34 17.3266 0 15.6666 0C14.0066 0 12.6666 1.34 12.6666 3C12.6666 4.66 14.0066 6 15.6666 6ZM7.66663 6C9.32663 6 10.6566 4.66 10.6566 3C10.6566 1.34 9.32663 0 7.66663 0C6.00663 0 4.66663 1.34 4.66663 3C4.66663 4.66 6.00663 6 7.66663 6ZM7.66663 8C5.33663 8 0.666626 9.17 0.666626 11.5V14H14.6666V11.5C14.6666 9.17 9.99663 8 7.66663 8ZM15.6666 8C15.3766 8 15.0466 8.02 14.6966 8.05C15.8566 8.89 16.6666 10.02 16.6666 11.5V14H22.6666V11.5C22.6666 9.17 17.9966 8 15.6666 8Z" />
    </svg>
  )
}
export const SyncIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.66 7.53078L8.59 14.6008L4.35 10.3608L5.76 8.95078L8.59 11.7808L14.25 6.12078L15.66 7.53078ZM2 10.0008C2 7.67078 3.02 5.58078 4.62 4.12078L7 6.50078V0.500781H1L3.2 2.70078C1.24 4.52078 0 7.11078 0 10.0008C0 15.1908 3.95 19.4508 9 19.9508V17.9308C5.06 17.4408 2 14.0708 2 10.0008ZM20 10.0008C20 4.81078 16.05 0.550781 11 0.0507812V2.07078C14.94 2.56078 18 5.93078 18 10.0008C18 12.3308 16.98 14.4208 15.38 15.8808L13 13.5008V19.5008H19L16.8 17.3008C18.76 15.4808 20 12.8908 20 10.0008Z" />
    </svg>
  )
}
export const TicketIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg className={combinedClasses} viewBox="0 0 19 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.3333 15H3.33325V13H15.3333V15ZM15.3333 11H3.33325V9H15.3333V11ZM15.3333 7H3.33325V5H15.3333V7ZM0.333252 20L1.83325 18.5L3.33325 20L4.83325 18.5L6.33325 20L7.83325 18.5L9.33325 20L10.8333 18.5L12.3333 20L13.8333 18.5L15.3333 20L16.8333 18.5L18.3333 20V0L16.8333 1.5L15.3333 0L13.8333 1.5L12.3333 0L10.8333 1.5L9.33325 0L7.83325 1.5L6.33325 0L4.83325 1.5L3.33325 0L1.83325 1.5L0.333252 0V20Z" />
    </svg>
  )
}

export const DostNotifyIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#565E6D]'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 21.75C13.1 21.75 14 20.85 14 19.75H10C10 20.85 10.89 21.75 12 21.75ZM18 15.75V10.75C18 7.68 16.36 5.11 13.5 4.43V3.75C13.5 2.92 12.83 2.25 12 2.25C11.17 2.25 10.5 2.92 10.5 3.75V4.43C7.63 5.11 6 7.67 6 10.75V15.75L4 17.75V18.75H20V17.75L18 15.75Z"
        fill="white"
      />
    </svg>
  )
}

export const CopyToClipboardIcon = ({ className = 'h-6 w-6 fill-primary-main' }: IconProps) => {
  return (
    <svg
      className={className}
      viewBox="0 0 18 22"
      // fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.16146 8.6011e-07H13.8385C14.3657 -1.70213e-05 14.8205 -3.25181e-05 15.195 0.0305712C15.5904 0.0628723 15.9836 0.134188 16.362 0.326982C16.9265 0.614602 17.3854 1.07354 17.673 1.63803C17.8658 2.01641 17.9371 2.40963 17.9694 2.80497C18 3.17954 18 3.6343 18 4.16144V13.8386C18 14.3657 18 14.8205 17.9694 15.195C17.9371 15.5904 17.8658 15.9836 17.673 16.362C17.3854 16.9265 16.9265 17.3854 16.362 17.673C15.9836 17.8658 15.5904 17.9371 15.195 17.9694C14.8592 17.9969 14.459 17.9997 14 18C13.9997 18.459 13.9969 18.8592 13.9694 19.195C13.9371 19.5904 13.8658 19.9836 13.673 20.362C13.3854 20.9265 12.9265 21.3854 12.362 21.673C11.9836 21.8658 11.5904 21.9371 11.195 21.9694C10.8205 22 10.3657 22 9.83857 22H4.16144C3.6343 22 3.17954 22 2.80497 21.9694C2.40963 21.9371 2.01641 21.8658 1.63803 21.673C1.07354 21.3854 0.614603 20.9265 0.326982 20.362C0.134188 19.9836 0.0628722 19.5904 0.0305712 19.195C-3.25181e-05 18.8205 -1.70213e-05 18.3657 8.6011e-07 17.8385V8.16146C-1.70213e-05 7.63431 -3.25181e-05 7.17955 0.0305712 6.80497C0.0628723 6.40963 0.134188 6.01641 0.326982 5.63803C0.614602 5.07354 1.07354 4.6146 1.63803 4.32698C2.01641 4.13419 2.40963 4.06287 2.80497 4.03057C3.14076 4.00314 3.54098 4.00031 4.00003 4.00003C4.00031 3.54098 4.00314 3.14076 4.03057 2.80497C4.06287 2.40963 4.13419 2.01641 4.32698 1.63803C4.6146 1.07354 5.07354 0.614602 5.63803 0.326982C6.01641 0.134188 6.40963 0.0628723 6.80497 0.0305712C7.17955 -3.25181e-05 7.63431 -1.70213e-05 8.16146 8.6011e-07ZM6.00007 4L9.83855 4C10.3657 3.99998 10.8205 3.99997 11.195 4.03057C11.5904 4.06287 11.9836 4.13419 12.362 4.32698C12.9265 4.6146 13.3854 5.07354 13.673 5.63803C13.8658 6.01641 13.9371 6.40963 13.9694 6.80497C14 7.17955 14 7.63432 14 8.16148V15.9999C14.4651 15.9995 14.783 15.9964 15.0322 15.9761C15.3038 15.9539 15.4045 15.9162 15.454 15.891C15.6422 15.7951 15.7951 15.6422 15.891 15.454C15.9162 15.4045 15.9539 15.3038 15.9761 15.0322C15.9992 14.7488 16 14.3766 16 13.8V4.2C16 3.62345 15.9992 3.25118 15.9761 2.96784C15.9539 2.69617 15.9162 2.59546 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.109C15.4045 2.0838 15.3038 2.04612 15.0322 2.02393C14.7488 2.00078 14.3766 2 13.8 2H8.2C7.62345 2 7.25118 2.00078 6.96784 2.02393C6.69617 2.04612 6.59546 2.0838 6.54601 2.109C6.35785 2.20487 6.20487 2.35785 6.109 2.54601C6.0838 2.59546 6.04612 2.69617 6.02393 2.96784C6.00357 3.21698 6.00052 3.5349 6.00007 4ZM2.96784 6.02393C2.69617 6.04612 2.59546 6.0838 2.54601 6.109C2.35785 6.20487 2.20487 6.35785 2.109 6.54601C2.0838 6.59546 2.04612 6.69617 2.02393 6.96784C2.00078 7.25117 2 7.62345 2 8.2V17.8C2 18.3766 2.00078 18.7488 2.02393 19.0322C2.04612 19.3038 2.0838 19.4046 2.109 19.454C2.20487 19.6422 2.35785 19.7951 2.54601 19.891C2.59546 19.9162 2.69617 19.9539 2.96784 19.9761C3.25117 19.9992 3.62345 20 4.2 20H9.8C10.3766 20 10.7488 19.9992 11.0322 19.9761C11.3038 19.9539 11.4045 19.9162 11.454 19.891C11.6422 19.7951 11.7951 19.6422 11.891 19.454C11.9162 19.4046 11.9539 19.3038 11.9761 19.0322C11.9992 18.7488 12 18.3766 12 17.8V8.2C12 7.62345 11.9992 7.25117 11.9761 6.96784C11.9539 6.69617 11.9162 6.59546 11.891 6.54601C11.7951 6.35785 11.6422 6.20487 11.454 6.109C11.4045 6.0838 11.3038 6.04612 11.0322 6.02393C10.7488 6.00078 10.3766 6 9.8 6H4.2C3.62345 6 3.25118 6.00078 2.96784 6.02393Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const EmptyCheckIcon = ({
  className = 'h-[1.563rem] w-[1.5rem] fill-[#2E7D32]'
}: IconProps) => {
  return (
    <svg className={className} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.79508 15.9843L4.62508 11.8143L3.20508 13.2243L8.79508 18.8143L20.7951 6.8143L19.3851 5.4043L8.79508 15.9843Z" />
    </svg>
  )
}

export const EmptyCrossIcon = ({
  className = 'h-[1.563rem] w-[1.5rem] fill-[#D32F2F]'
}: IconProps) => {
  return (
    <svg className={className} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 6.51937L17.59 5.10938L12 10.6994L6.41 5.10938L5 6.51937L10.59 12.1094L5 17.6994L6.41 19.1094L12 13.5194L17.59 19.1094L19 17.6994L13.41 12.1094L19 6.51937Z" />
    </svg>
  )
}

export const BluePenIcon = ({
  className = 'h-[1.313rem] w-[1.25rem] fill-[#4729FF]'
}: IconProps) => {
  return (
    <svg className={className} viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 14.4845V17.6095H5.625L14.8417 8.39284L11.7167 5.26784L2.5 14.4845ZM17.2583 5.97617C17.5833 5.65117 17.5833 5.12617 17.2583 4.80117L15.3083 2.85117C14.9833 2.52617 14.4583 2.52617 14.1333 2.85117L12.6083 4.37617L15.7333 7.50117L17.2583 5.97617Z" />
    </svg>
  )
}

export const BluePenIconOutlined = ({
  className = 'h-[16.67px] w-[16.67px] ',
  fill = '#07004D'
}: IconProps) => {
  return (
    <svg viewBox="0 0 18 17" className={className} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7792 2.13445C13.4363 1.96451 13.0337 1.96451 12.6907 2.13445C12.5414 2.20846 12.3741 2.36017 11.7652 2.9691L11.3249 3.40941L14.2645 6.34907L14.7048 5.90877C15.3138 5.29983 15.4655 5.13254 15.5395 4.98319C15.7094 4.64025 15.7094 4.23762 15.5395 3.89468C15.4655 3.74533 15.3138 3.57804 14.7048 2.96911C14.0959 2.36017 13.9286 2.20847 13.7792 2.13445ZM14.8579 8.11274L15.8833 7.08728C15.9144 7.05624 15.945 7.02564 15.9753 6.99543C16.4459 6.52566 16.8204 6.15186 17.0328 5.72322C17.4338 4.91398 17.4338 3.96389 17.0328 3.15466C16.8204 2.72601 16.4459 2.35222 15.9753 1.88244C15.945 1.85223 15.9144 1.82163 15.8833 1.79059C15.8523 1.75956 15.8217 1.72891 15.7915 1.69865C15.3217 1.22799 14.9479 0.853505 14.5193 0.641089C13.71 0.24008 12.7599 0.24008 11.9507 0.641089C11.5221 0.853503 11.1483 1.22799 10.6785 1.69864C10.6483 1.7289 10.6177 1.75956 10.5867 1.79059L2.90025 9.477C2.88972 9.48753 2.8793 9.49793 2.869 9.50822C2.69411 9.68298 2.55235 9.82463 2.43021 9.98654C2.32245 10.1294 2.22817 10.2819 2.1486 10.4422C2.0584 10.6239 1.99511 10.814 1.91702 11.0486C1.91242 11.0624 1.90776 11.0764 1.90305 11.0905L1.11954 13.441C0.962291 13.9127 0.826433 14.3202 0.748738 14.6509C0.671949 14.9777 0.609504 15.387 0.753675 15.7913C0.941487 16.318 1.35595 16.7324 1.88263 16.9203C2.28693 17.0644 2.69627 17.002 3.02306 16.9252C3.3537 16.8475 3.76123 16.7116 4.23294 16.5544L6.58344 15.7709C6.59756 15.7662 6.61153 15.7615 6.62534 15.7569C6.85993 15.6788 7.05007 15.6155 7.23173 15.5253C7.392 15.4458 7.54454 15.3515 7.68739 15.2437C7.84929 15.1216 7.99094 14.9798 8.16569 14.8049C8.17599 14.7946 8.1864 14.7842 8.19693 14.7737L14.8497 8.12094C14.851 8.11958 14.8524 8.11822 14.8538 8.11685C14.8552 8.11549 14.8565 8.11412 14.8579 8.11274ZM13.086 7.52758L10.1463 4.58792L4.07876 10.6555C3.85794 10.8763 3.80416 10.9327 3.76073 10.9903C3.71507 11.0508 3.67511 11.1155 3.64139 11.1834C3.60933 11.248 3.58295 11.3213 3.48419 11.6175L2.71287 13.9315C2.53996 14.4502 2.42936 14.7847 2.37121 15.0321C2.34074 15.1618 2.33501 15.2291 2.33381 15.2553C2.35253 15.2917 2.38221 15.3214 2.41864 15.3401C2.44484 15.3389 2.51213 15.3332 2.64181 15.3027C2.88926 15.2446 3.22369 15.134 3.74243 14.9611L6.05639 14.1897C6.35266 14.091 6.42597 14.0646 6.49055 14.0325C6.55847 13.9988 6.62312 13.9589 6.68365 13.9132C6.74122 13.8698 6.79759 13.816 7.01842 13.5952L13.086 7.52758Z"
        fill={fill}
      />
    </svg>
  )
}

export const ShareButtonIcon = ({
  className = 'h-[16.67px] w-[16.67px] fill-[#4729FF]'
}: IconProps) => {
  return (
    <svg viewBox="0 0 18 18" className={className} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33423 2.13838C2.33169 2.15419 2.33031 2.18137 2.356 2.2276L5.44939 7.79407C5.45799 7.80953 5.46634 7.82509 5.47444 7.84073L8.90027 7.84073C9.36051 7.84073 9.7336 8.21383 9.7336 8.67407C9.7336 9.13431 9.36051 9.5074 8.90027 9.5074L5.47444 9.5074C5.46634 9.52305 5.45799 9.53861 5.44939 9.55407L2.356 15.1205C2.33031 15.1668 2.33168 15.1939 2.33423 15.2098C2.33785 15.2323 2.35073 15.2627 2.37806 15.2913C2.40538 15.3198 2.43531 15.3341 2.45782 15.3387C2.47369 15.3419 2.50094 15.3445 2.54835 15.3208L15.586 8.80388C15.6931 8.75034 15.6931 8.59779 15.586 8.54426L2.54836 2.02737C2.50094 2.00367 2.47369 2.0062 2.45782 2.00946C2.43531 2.01409 2.40538 2.02834 2.37806 2.05687C2.35073 2.0854 2.33785 2.11584 2.33423 2.13838ZM0.899173 3.03719C0.0333338 1.47913 1.7008 -0.25956 3.29354 0.536572L16.3311 7.05346C17.6669 7.72114 17.6669 9.627 16.3311 10.2947L3.29353 16.8116C1.7008 17.6077 0.0333332 15.869 0.899172 14.311L3.99256 8.74448C4.01691 8.70068 4.01691 8.64745 3.99256 8.60365L0.899173 3.03719Z"
        // fill="#07004D"
      />
    </svg>
  )
}
export const TimeIcon = ({ className = 'h-[1.313rem] w-[1.25rem] fill-[#4729FF]' }: IconProps) => {
  return (
    <svg className={className} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM13.29 14.71L9 10.41V5H11V9.59L14.71 13.3L13.29 14.71Z" />
    </svg>
  )
}

export const KeyIcon = ({ className = 'h-[1.25rem] w-[1.25rem] fill-none' }: IconProps) => {
  return (
    <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 10H12.65C11.83 7.67 9.61 6 7 6C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18C9.61 18 11.83 16.33 12.65 14H13L15 16L17 14L19 16L23 11.96L21 10ZM7 15C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9C8.65 9 10 10.35 10 12C10 13.65 8.65 15 7 15Z" />
    </svg>
  )
}

export const EmptyQuestionImage = ({
  className = 'h-[1.25rem] w-[1.25rem] fill-none'
}: IconProps) => {
  return (
    <svg
      width="170"
      height="138"
      viewBox="0 0 170 138"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_5233_8548)">
        <path
          d="M145.573 49.5083C145.573 44.7632 141.726 40.9165 136.981 40.9165H74.2605C69.5154 40.9165 65.6687 44.7632 65.6687 49.5083V96.7634C65.6687 101.509 69.5154 105.355 74.2605 105.355H107.49C107.671 105.355 107.848 105.413 107.994 105.519L126.95 119.271C128.086 120.096 129.678 119.284 129.678 117.881V106.214C129.678 105.74 130.063 105.355 130.537 105.355H136.981C141.726 105.355 145.573 101.509 145.573 96.7634V49.5083Z"
          fill="#46586B"
          fillOpacity="0.02"
        />
      </g>
      <g filter="url(#filter1_b_5233_8548)">
        <path
          d="M24.4277 24.5918C24.4277 19.8467 28.2744 16 33.0196 16H112.924C117.669 16 121.515 19.8467 121.515 24.5918V80.4388C121.515 85.1839 117.669 89.0306 112.924 89.0306H62.5107C62.3294 89.0306 62.1528 89.0879 62.0061 89.1944L43.0501 102.947C41.9141 103.771 40.3226 102.959 40.3226 101.556V89.8898C40.3226 89.4153 39.938 89.0306 39.4634 89.0306H33.0196C28.2744 89.0306 24.4277 85.1839 24.4277 80.4388V24.5918Z"
          fill="#4729FF"
          fillOpacity="0.3"
        />
      </g>
      <circle cx="54.9289" cy="52.5154" r="5.58469" fill="white" fillOpacity="0.7" />
      <circle cx="72.9714" cy="52.5154" r="5.58469" fill="white" fillOpacity="0.7" />
      <circle cx="91.0144" cy="52.5154" r="5.58469" fill="white" fillOpacity="0.7" />
      <defs>
        <filter
          id="filter0_b_5233_8548"
          x="58.795"
          y="34.043"
          width="93.6512"
          height="92.4325"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3.43673" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_5233_8548" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_5233_8548"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_b_5233_8548"
          x="17.5543"
          y="9.12653"
          width="110.835"
          height="101.024"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3.43673" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_5233_8548" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_5233_8548"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export const ZoomInIcon = ({ className = 'h-[1.25rem] w-[1.25rem] fill-none' }: IconProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z"
        fill="white"
      />
    </svg>
  )
}
export const DownloadIcon = ({ className = 'h-[1.25rem] w-[1.25rem] fill-none' }: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      // fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 20H19V18H5V20ZM19 9H15V3H9V9H5L12 16L19 9Z" fill="white" />
    </svg>
  )
}
export const FacebookNewIcon = ({ className = 'h-[1.25rem] w-[1.25rem] fill-none' }: IconProps) => {
  return (
    <svg width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_17_24)">
        <path
          d="M48 24C48 10.7453 37.2547 0 24 0C10.7453 0 0 10.7453 0 24C0 35.255 7.74912 44.6995 18.2026 47.2934V31.3344H13.2538V24H18.2026V20.8397C18.2026 12.671 21.8995 8.8848 29.9194 8.8848C31.44 8.8848 34.0637 9.18336 35.137 9.48096V16.129C34.5706 16.0694 33.5866 16.0397 32.3645 16.0397C28.4294 16.0397 26.9088 17.5306 26.9088 21.4061V24H34.7482L33.4013 31.3344H26.9088V47.8243C38.7926 46.3891 48.001 36.2707 48.001 24H48Z"
          fill="#0866FF"
        />
        <path
          d="M33.4003 31.3344L34.7472 24H26.9078V21.4061C26.9078 17.5306 28.4285 16.0397 32.3635 16.0397C33.5856 16.0397 34.5696 16.0694 35.136 16.129V9.48096C34.0627 9.1824 31.439 8.8848 29.9184 8.8848C21.8986 8.8848 18.2016 12.671 18.2016 20.8397V24H13.2528V31.3344H18.2016V47.2934C20.0582 47.7542 22.0003 48 23.999 48C24.983 48 25.9536 47.9395 26.9069 47.8243V31.3344H33.4003Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_24">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const TwitterNewIcon = ({ className = 'h-[1.25rem] w-[1.25rem] fill-none' }: IconProps) => {
  return (
    <svg width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36.6526 3.80782H43.3995L28.6594 20.6548L46 43.5798H32.4225L21.7881 29.6759L9.61989 43.5798H2.86886L18.6349 25.56L2 3.80782H15.9222L25.5348 16.5165L36.6526 3.80782ZM34.2846 39.5414H38.0232L13.8908 7.63408H9.87892L34.2846 39.5414Z"
        fill="black"
      />
    </svg>
  )
}
export const WhatsAppIcon = ({ className = 'h-[1.25rem] w-[1.25rem] fill-none' }: IconProps) => {
  return (
    <svg width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 48L3.374 35.674C1.292 32.066 0.198 27.976 0.2 23.782C0.206 10.67 10.876 0 23.986 0C30.348 0.002 36.32 2.48 40.812 6.976C45.302 11.472 47.774 17.448 47.772 23.804C47.766 36.918 37.096 47.588 23.986 47.588C20.006 47.586 16.084 46.588 12.61 44.692L0 48ZM13.194 40.386C16.546 42.376 19.746 43.568 23.978 43.57C34.874 43.57 43.75 34.702 43.756 23.8C43.76 12.876 34.926 4.02 23.994 4.016C13.09 4.016 4.22 12.884 4.216 23.784C4.214 28.234 5.518 31.566 7.708 35.052L5.71 42.348L13.194 40.386ZM35.968 29.458C35.82 29.21 35.424 29.062 34.828 28.764C34.234 28.466 31.312 27.028 30.766 26.83C30.222 26.632 29.826 26.532 29.428 27.128C29.032 27.722 27.892 29.062 27.546 29.458C27.2 29.854 26.852 29.904 26.258 29.606C25.664 29.308 23.748 28.682 21.478 26.656C19.712 25.08 18.518 23.134 18.172 22.538C17.826 21.944 18.136 21.622 18.432 21.326C18.7 21.06 19.026 20.632 19.324 20.284C19.626 19.94 19.724 19.692 19.924 19.294C20.122 18.898 20.024 18.55 19.874 18.252C19.724 17.956 18.536 15.03 18.042 13.84C17.558 12.682 17.068 12.838 16.704 12.82L15.564 12.8C15.168 12.8 14.524 12.948 13.98 13.544C13.436 14.14 11.9 15.576 11.9 18.502C11.9 21.428 14.03 24.254 14.326 24.65C14.624 25.046 18.516 31.05 24.478 33.624C25.896 34.236 27.004 34.602 27.866 34.876C29.29 35.328 30.586 35.264 31.61 35.112C32.752 34.942 35.126 33.674 35.622 32.286C36.118 30.896 36.118 29.706 35.968 29.458Z"
        fill="#25D366"
      />
    </svg>
  )
}
export const LinkedIn = ({ className = 'h-[1.25rem] w-[1.25rem] fill-none' }: IconProps) => {
  return (
    <svg width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_17_32)">
        <path
          d="M44.4567 0H3.54333C2.60358 0 1.70232 0.373315 1.03782 1.03782C0.373315 1.70232 0 2.60358 0 3.54333V44.4567C0 45.3964 0.373315 46.2977 1.03782 46.9622C1.70232 47.6267 2.60358 48 3.54333 48H44.4567C45.3964 48 46.2977 47.6267 46.9622 46.9622C47.6267 46.2977 48 45.3964 48 44.4567V3.54333C48 2.60358 47.6267 1.70232 46.9622 1.03782C46.2977 0.373315 45.3964 0 44.4567 0ZM14.3067 40.89H7.09V17.9667H14.3067V40.89ZM10.6933 14.79C9.87473 14.7854 9.07583 14.5384 8.39747 14.0802C7.71911 13.622 7.19168 12.9731 6.88175 12.2154C6.57183 11.4577 6.4933 10.6252 6.65606 9.82291C6.81883 9.02063 7.2156 8.28455 7.79631 7.70756C8.37702 7.13057 9.11563 6.73853 9.91893 6.58092C10.7222 6.42331 11.5542 6.50719 12.3099 6.82197C13.0656 7.13675 13.7111 7.66833 14.1649 8.34962C14.6188 9.03092 14.8606 9.83138 14.86 10.65C14.8677 11.1981 14.765 11.7421 14.558 12.2496C14.351 12.7571 14.044 13.2178 13.6551 13.6041C13.2663 13.9905 12.8037 14.2946 12.2948 14.4983C11.786 14.702 11.2413 14.8012 10.6933 14.79ZM40.9067 40.91H33.6933V28.3867C33.6933 24.6933 32.1233 23.5533 30.0967 23.5533C27.9567 23.5533 25.8567 25.1667 25.8567 28.48V40.91H18.64V17.9833H25.58V21.16H25.6733C26.37 19.75 28.81 17.34 32.5333 17.34C36.56 17.34 40.91 19.73 40.91 26.73L40.9067 40.91Z"
          fill="#0A66C2"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_32">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const CopyLinkIcon = ({
  className = 'h-[1.25rem] w-[1.25rem] fill-none',
  fill = '#fff'
}: IconProps) => {
  return (
    <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 3.25C5.82436 3.25 3.25 5.82436 3.25 9V16.1069C3.25 16.5211 3.58579 16.8569 4 16.8569C4.41421 16.8569 4.75 16.5211 4.75 16.1069V9C4.75 6.65279 6.65279 4.75 9 4.75H16.0129C16.4271 4.75 16.7629 4.41421 16.7629 4C16.7629 3.58579 16.4271 3.25 16.0129 3.25H9Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4026 6.79326C15.1616 6.43104 11.8384 6.43104 8.59748 6.79326C7.6742 6.89645 6.93227 7.62304 6.82344 8.55348C6.43906 11.84 6.43906 15.16 6.82344 18.4465C6.93227 19.377 7.6742 20.1035 8.59748 20.2067C11.8384 20.569 15.1616 20.569 18.4026 20.2067C19.3258 20.1035 20.0678 19.377 20.1766 18.4465C20.561 15.16 20.561 11.84 20.1766 8.55348C20.0678 7.62304 19.3258 6.89645 18.4026 6.79326ZM8.76409 8.28398C11.8943 7.93413 15.1057 7.93413 18.2359 8.28398C18.4733 8.3105 18.6599 8.49821 18.6867 8.72773C19.0576 11.8984 19.0576 15.1016 18.6867 18.2723C18.6599 18.5018 18.4733 18.6895 18.2359 18.716C15.1057 19.0659 11.8943 19.0659 8.76409 18.716C8.52674 18.6895 8.34013 18.5018 8.31329 18.2723C7.94245 15.1016 7.94245 11.8984 8.31329 8.72773C8.34013 8.49821 8.52674 8.3105 8.76409 8.28398Z"
        fill={fill}
      />
    </svg>
  )
}

export const TickIcon = ({ className = 'h-[1.25rem] w-[1.25rem] fill-none' }: IconProps) => {
  return (
    <svg className={className} viewBox="0 0 251 251" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.11441 141.182L22.214 119.082L78.3226 175.175L228.19 25.3076L250.29 47.4072L78.307 219.375L0.11441 141.182Z" />
    </svg>
  )
}
export const NewsGreyIcon = ({ className = 'h-[2rem] w-[2 rem] fill-none' }: IconProps) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.9332 7.6665H26.1999V26.9998C28.7036 26.9998 30.7332 24.9702 30.7332 22.4665V8.4665C30.7332 8.02468 30.3751 7.6665 29.9332 7.6665Z"
        fill="#46586B"
      />
      <path
        d="M25.4001 5H2.06678C1.62496 5 1.26678 5.35817 1.26678 5.8V22.4667C1.26678 24.9704 3.29595 27 5.79964 27H26.2001C27.2668 27 28.0668 26.6 28.0668 26.6C27.6668 26.7578 26.2001 26.3333 26.2001 23.8V5.79558C26.2001 5.35375 25.8419 5 25.4001 5Z"
        fill="#A2ABB5"
      />
      <rect x="4.60028" y="11.2666" width="9.06667" height="9.33333" rx="0.266667" fill="white" />
      <rect x="4.60028" y="11.2666" width="9.06667" height="9.33333" rx="0.266667" fill="#46586B" />
      <rect x="4.60028" y="21.9331" width="9.06667" height="1.33333" rx="0.266667" fill="white" />
      <rect x="4.60028" y="21.9331" width="9.06667" height="1.33333" rx="0.266667" fill="#46586B" />
      <rect x="14.7336" y="21.9331" width="6.66667" height="1.33333" rx="0.266667" fill="white" />
      <rect x="14.7336" y="21.9331" width="6.66667" height="1.33333" rx="0.266667" fill="#46586B" />
      <rect x="14.7336" y="19.2666" width="9.06667" height="1.33333" rx="0.266667" fill="white" />
      <rect x="14.7336" y="19.2666" width="9.06667" height="1.33333" rx="0.266667" fill="#46586B" />
      <rect x="14.7336" y="16.6001" width="9.06667" height="1.33333" rx="0.266667" fill="white" />
      <rect x="14.7336" y="16.6001" width="9.06667" height="1.33333" rx="0.266667" fill="#46586B" />
      <rect x="14.7336" y="13.9331" width="9.06667" height="1.33333" rx="0.266667" fill="white" />
      <rect x="14.7336" y="13.9331" width="9.06667" height="1.33333" rx="0.266667" fill="#46586B" />
      <rect x="14.7336" y="11.2666" width="9.06667" height="1.33333" rx="0.266667" fill="white" />
      <rect x="14.7336" y="11.2666" width="9.06667" height="1.33333" rx="0.266667" fill="#46586B" />
      <rect x="4.60028" y="8.6001" width="19.2" height="1.33333" rx="0.266667" fill="white" />
      <rect x="4.60028" y="8.6001" width="19.2" height="1.33333" rx="0.266667" fill="#46586B" />
    </svg>
  )
}

export const AnnouncementGreyIcon = ({ className = 'h-[2rem] w-[2 rem] fill-none' }: IconProps) => {
  return (
    <svg
      className={className}
      // width="32"
      // height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.39609 21.8216L0.732727 17.188L2.27728 16.4751L3.94065 21.4652L2.39609 21.8216Z"
        fill="white"
      />
      <path
        d="M2.39609 21.8216L0.732727 17.188L2.27728 16.4751L3.94065 21.4652L2.39609 21.8216Z"
        fill="#46586B"
      />
      <path d="M12.0196 21.5839L11.1879 22.0592L9.99982 20.1582L12.0196 21.5839Z" fill="white" />
      <path d="M12.0196 21.5839L11.1879 22.0592L9.99982 20.1582L12.0196 21.5839Z" fill="#46586B" />
      <path
        d="M9.28704 12.7919L20.5742 4.4751C21.5247 5.22757 23.7346 7.61173 24.9702 11.1286C26.2059 14.6454 25.9603 17.98 25.6831 19.2078H11.5445L3.46526 21.8216L1.56427 16.3563L9.28704 12.7919Z"
        fill="#46586B"
      />
      <path
        d="M13.8022 25.8613L10.4755 27.9999L6.43585 21.4653L9.8814 19.6831L13.8022 25.8613Z"
        fill="#46586B"
      />
      <path d="M7.38632 23.0098L5.36652 21.4653L11.1883 19.3267L7.38632 23.0098Z" fill="white" />
      <path d="M7.38632 23.0098L5.36652 21.4653L11.1883 19.3267L7.38632 23.0098Z" fill="#46586B" />
      <path
        d="M5.12881 21.8219L2.51495 15.1684L8.69317 12.6733L11.307 19.6832L5.12881 21.8219Z"
        fill="white"
      />
      <path
        d="M5.12881 21.8219L2.51495 15.1684L8.69317 12.6733L11.307 19.6832L5.12881 21.8219Z"
        fill="#A2ABB5"
      />
      <path
        opacity="0.8"
        d="M25.9207 7.20792L27.8217 4M27.5841 10.6535L31.2672 9.70297M27.9405 14.5743L31.2672 16.3564"
        stroke="#A2ABB5"
        strokeWidth="0.712871"
        stroke-linecap="round"
      />
    </svg>
  )
}

export const ArchiveIcon = ({ className = '' }: IconProps) => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.405 2.4225L12.3625 1.1625C12.16 0.9075 11.8525 0.75 11.5 0.75H2.5C2.1475 0.75 1.84 0.9075 1.63 1.1625L0.595 2.4225C0.3775 2.6775 0.25 3.015 0.25 3.375V12.75C0.25 13.575 0.925 14.25 1.75 14.25H12.25C13.075 14.25 13.75 13.575 13.75 12.75V3.375C13.75 3.015 13.6225 2.6775 13.405 2.4225ZM7 11.625L2.875 7.5H5.5V6H8.5V7.5H11.125L7 11.625ZM1.84 2.25L2.4475 1.5H11.4475L12.1525 2.25H1.84Z"
        fill="#D32F2F"
      />
    </svg>
  )
}

export const UnArchiveIcon = ({ className = '' }: IconProps) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.405 2.4225L12.3625 1.1625C12.16 0.9075 11.8525 0.75 11.5 0.75H2.5C2.1475 0.75 1.84 0.9075 1.63 1.1625L0.595 2.4225C0.3775 2.6775 0.25 3.015 0.25 3.375V12.75C0.25 13.575 0.925 14.25 1.75 14.25H12.25C13.075 14.25 13.75 13.575 13.75 12.75V3.375C13.75 3.015 13.6225 2.6775 13.405 2.4225ZM7 11.625L2.875 7.5H5.5V6H8.5V7.5H11.125L7 11.625ZM1.84 2.25L2.4475 1.5H11.4475L12.1525 2.25H1.84Z"
        // fill="#D32F2F"
      />
    </svg>
  )
}

export const AddUserIcon = ({ className = '' }: IconProps) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C12.79 4 11 5.79 11 8C11 10.21 12.79 12 15 12ZM6 10V7H4V10H1V12H4V15H6V12H9V10H6ZM15 14C12.33 14 7 15.34 7 18V20H23V18C23 15.34 17.67 14 15 14Z"
        fill="white"
      />
    </svg>
  )
}

export const RemoveContactIcon = ({ className = '' }: IconProps) => {
  return (
    <>
      <svg
        width={12}
        height={2}
        viewBox="0 0 12 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mr-3"
      >
        <path d="M11.8334 1.83268H0.166748V0.166016H11.8334V1.83268Z" fill="white" />
      </svg>
    </>
  )
}

export const CloseIcon = ({ className = '' }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-black'
  return (
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CancelIcon"
      className={combinedClasses}
    >
      <g opacity="0.5">
        <path
          d="M12.6668 4.27398L11.7268 3.33398L8.00016 7.06065L4.2735 3.33398L3.3335 4.27398L7.06016 8.00065L3.3335 11.7273L4.2735 12.6673L8.00016 8.94065L11.7268 12.6673L12.6668 11.7273L8.94016 8.00065L12.6668 4.27398Z"
          // fill="black"
        />
      </g>
    </svg>
  )
}

export const DesclaimerIcon = ({ className = '' }: IconProps) => {
  const combinedClasses = className || 'w-4 h-4 icon-lightGrey'
  return (
    <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" className={combinedClasses}>
      <path
        d="M9.2002 1.73047C5.0602 1.73047 1.7002 5.09047 1.7002 9.23047C1.7002 13.3705 5.0602 16.7305 9.2002 16.7305C13.3402 16.7305 16.7002 13.3705 16.7002 9.23047C16.7002 5.09047 13.3402 1.73047 9.2002 1.73047ZM9.9502 14.4805H8.4502V12.9805H9.9502V14.4805ZM11.5027 8.66797L10.8277 9.35797C10.2877 9.90547 9.9502 10.3555 9.9502 11.4805H8.4502V11.1055C8.4502 10.2805 8.7877 9.53047 9.3277 8.98297L10.2577 8.03797C10.5352 7.76797 10.7002 7.39297 10.7002 6.98047C10.7002 6.15547 10.0252 5.48047 9.2002 5.48047C8.3752 5.48047 7.7002 6.15547 7.7002 6.98047H6.2002C6.2002 5.32297 7.5427 3.98047 9.2002 3.98047C10.8577 3.98047 12.2002 5.32297 12.2002 6.98047C12.2002 7.64047 11.9302 8.24047 11.5027 8.66797Z"
        // fill="black"
        // fillOpacity="0.54"
      />
    </svg>
  )
}

export const ContentPresenceIcon = ({ className = 'fill-black', opacity = '0.56' }: IconProps) => {
  return (
    <svg
      width={16}
      height={17}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.6667 2.10938H3.33333C2.6 2.10938 2 2.70938 2 3.44271V12.776C2 13.5094 2.6 14.1094 3.33333 14.1094H12.6667C13.4 14.1094 14 13.5094 14 12.776V3.44271C14 2.70938 13.4 2.10938 12.6667 2.10938ZM9.33333 11.4427H4.66667V10.1094H9.33333V11.4427ZM11.3333 8.77604H4.66667V7.44271H11.3333V8.77604ZM11.3333 6.10938H4.66667V4.77604H11.3333V6.10938Z"
        // fill="black"
        fillOpacity={opacity}
      />
    </svg>
  )
}

export const DeleteAccountIcon = ({ className = '', fill = '#D32F2F' }: IconProps) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M4.99996 15.8333C4.99996 16.75 5.74996 17.5 6.66663 17.5H13.3333C14.25 17.5 15 16.75 15 15.8333V5.83333H4.99996V15.8333ZM15.8333 3.33333H12.9166L12.0833 2.5H7.91663L7.08329 3.33333H4.16663V5H15.8333V3.33333Z"
          fill={fill}
        />
      </svg>
    </>
  )
}

export const BlockedIcon = ({ className = '' }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#D32F2F]'
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={combinedClasses}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M9.99996 1.66663C5.39996 1.66663 1.66663 5.39996 1.66663 9.99996C1.66663 14.6 5.39996 18.3333 9.99996 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99996C18.3333 5.39996 14.6 1.66663 9.99996 1.66663ZM3.33329 9.99996C3.33329 6.31663 6.31663 3.33329 9.99996 3.33329C11.5416 3.33329 12.9583 3.85829 14.0833 4.74163L4.74163 14.0833C3.85829 12.9583 3.33329 11.5416 3.33329 9.99996ZM9.99996 16.6666C8.45829 16.6666 7.04163 16.1416 5.91663 15.2583L15.2583 5.91663C16.1416 7.04163 16.6666 8.45829 16.6666 9.99996C16.6666 13.6833 13.6833 16.6666 9.99996 16.6666Z"
          // fill="#D32F2F"
        />
      </svg>
    </>
  )
}

export const ErrorOutlined = ({ className = '' }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#D32F2F]'
  return (
    <>
      <svg
        className={combinedClasses}
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
      >
        <path d="M10.0835 13.7499H11.9168V15.5833H10.0835V13.7499ZM10.0835 6.41658H11.9168V11.9166H10.0835V6.41658ZM10.991 1.83325C5.931 1.83325 1.8335 5.93992 1.8335 10.9999C1.8335 16.0599 5.931 20.1666 10.991 20.1666C16.0602 20.1666 20.1668 16.0599 20.1668 10.9999C20.1668 5.93992 16.0602 1.83325 10.991 1.83325ZM11.0002 18.3333C6.9485 18.3333 3.66683 15.0516 3.66683 10.9999C3.66683 6.94825 6.9485 3.66659 11.0002 3.66659C15.0518 3.66659 18.3335 6.94825 18.3335 10.9999C18.3335 15.0516 15.0518 18.3333 11.0002 18.3333Z" />
      </svg>
    </>
  )
}

export const UserIcon = ({ className = '' }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#D32F2F]'
  return (
    <>
      <svg
        className={combinedClasses}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path d="M10.0002 9.99992C11.8418 9.99992 13.3335 8.50825 13.3335 6.66659C13.3335 4.82492 11.8418 3.33325 10.0002 3.33325C8.1585 3.33325 6.66683 4.82492 6.66683 6.66659C6.66683 8.50825 8.1585 9.99992 10.0002 9.99992ZM10.0002 11.6666C7.77516 11.6666 3.3335 12.7833 3.3335 14.9999V16.6666H16.6668V14.9999C16.6668 12.7833 12.2252 11.6666 10.0002 11.6666Z" />
      </svg>
    </>
  )
}

export const NewArrowIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-6 w-6 fill-[#4729FF]'
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        className={combinedClasses}
      >
        <path
          d="M15.7049 8.285L14.2949 6.875L8.29492 12.875L14.2949 18.875L15.7049 17.465L11.1249 12.875L15.7049 8.285Z"
          // fill="#4729FF"
        />
      </svg>
    </>
  )
}

export const ConnectIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="27" fill="none" viewBox="0 0 52 27">
      <path
        fill="#4729FF"
        fillOpacity="0.3"
        d="M5.509 13.592c0-4.326 3.516-7.842 7.842-7.842h10.12V.943H13.35C6.37.943.702 6.61.702 13.593c0 6.982 5.667 12.648 12.65 12.648H23.47v-4.806H13.351c-4.326 0-7.842-3.517-7.842-7.843zm10.372 2.53h20.238v-5.06H15.881v5.06zM38.649.943H28.53V5.75h10.12c4.326 0 7.843 3.516 7.843 7.842s-3.517 7.843-7.843 7.843H28.53v4.806h10.12c6.982 0 12.65-5.666 12.65-12.649C51.298 6.61 45.63.943 38.648.943z"
      ></path>
    </svg>
  )
}
export const ApproveIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="51" fill="none" viewBox="0 0 52 51">
      <path
        fill="#4729FF"
        fillOpacity="0.3"
        d="M26 .06C12.036.06.702 11.393.702 25.357.702 39.323 12.036 50.657 26 50.657c13.965 0 25.298-11.334 25.298-25.298C51.298 11.393 39.965.06 26 .06zM13.351 29.152a3.79 3.79 0 01-3.795-3.794 3.79 3.79 0 013.795-3.795 3.79 3.79 0 013.795 3.795 3.79 3.79 0 01-3.795 3.794zm12.65 0a3.79 3.79 0 01-3.796-3.794A3.79 3.79 0 0126 21.563a3.79 3.79 0 013.795 3.795A3.79 3.79 0 0126 29.152zm12.648 0a3.79 3.79 0 01-3.795-3.794 3.79 3.79 0 013.795-3.795 3.79 3.79 0 013.795 3.795 3.79 3.79 0 01-3.795 3.794z"
      ></path>
    </svg>
  )
}

export const WaringIcon = ({ fill }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill={fill ?? '#0288D1'}
        d="M9 13h2v2H9v-2zm0-8h2v6H9V5zm.99-5C4.47 0 0 4.48 0 10s4.47 10 9.99 10C15.52 20 20 15.52 20 10S15.52 0 9.99 0zM10 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
      ></path>
    </svg>
  )
}
export const WaringIconFilled = ({ fill, className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className ?? ''}
      fill="none"
      viewBox="0 0 72 71"
    >
      <path
        fill={fill ?? '#D32F2F'}
        d="M36 .085C16.447.085.577 15.955.577 35.508.577 55.06 16.447 70.93 36 70.93c19.554 0 35.423-15.87 35.423-35.423C71.423 15.954 55.553.085 36 .085zm3.542 53.134h-7.084v-7.084h7.084v7.084zm0-14.169h-7.084V17.796h7.084V39.05z"
      ></path>
    </svg>
  )
}

export const ExclaimIcon = () => {
  return (
    <svg width={20} height={21} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 0.5C4.48 0.5 0 4.98 0 10.5C0 16.02 4.48 20.5 10 20.5C15.52 20.5 20 16.02 20 10.5C20 4.98 15.52 0.5 10 0.5ZM11 15.5H9V13.5H11V15.5ZM11 11.5H9V5.5H11V11.5Z"
        fill="#D32F2F"
      />
    </svg>
  )
}

export const LinkedInPostIcon = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className ?? 'h-8 w-8'}
      fill="none"
      viewBox="0 0 30 31"
    >
      <g clipPath="url(#clip0_15902_79440)">
        <path
          fill="#0A66C2"
          d="M27.785.578H2.215A2.215 2.215 0 000 2.793v25.57a2.215 2.215 0 002.215 2.215h25.57A2.215 2.215 0 0030 28.363V2.793A2.215 2.215 0 0027.785.578zM8.942 26.134h-4.51V11.807h4.51v14.327zM6.683 9.822a2.59 2.59 0 112.604-2.588 2.552 2.552 0 01-2.604 2.588zm18.884 16.325h-4.509V18.32c0-2.308-.98-3.021-2.248-3.021-1.337 0-2.65 1.008-2.65 3.08v7.768h-4.51v-14.33h4.338v1.986h.058c.435-.881 1.96-2.387 4.287-2.387 2.517 0 5.236 1.493 5.236 5.868l-.002 8.863z"
        ></path>
        <path
          fill="#fff"
          d="M8.942 26.134h-4.51V11.807h4.51v14.327zM25.567 26.147h-4.509V18.32c0-2.308-.98-3.021-2.248-3.021-1.337 0-2.65 1.008-2.65 3.08v7.768h-4.51v-14.33h4.338v1.986h.058c.435-.881 1.96-2.387 4.287-2.387 2.517 0 5.236 1.493 5.236 5.868l-.002 8.863zM6.683 9.822a2.59 2.59 0 112.604-2.588 2.552 2.552 0 01-2.604 2.588z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_15902_79440">
          <path fill="#fff" d="M0 0H30V30H0z" transform="translate(0 .578)"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export const LinkedInBoardIcon = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      fill="none"
      viewBox="0 0 30 31"
    >
      <g clipPath="url(#clip0_15902_79440)">
        <path
          fill="#0A66C2"
          d="M27.785.578H2.215A2.215 2.215 0 000 2.793v25.57a2.215 2.215 0 002.215 2.215h25.57A2.215 2.215 0 0030 28.363V2.793A2.215 2.215 0 0027.785.578zM8.942 26.134h-4.51V11.807h4.51v14.327zM6.683 9.822a2.59 2.59 0 112.604-2.588 2.552 2.552 0 01-2.604 2.588zm18.884 16.325h-4.509V18.32c0-2.308-.98-3.021-2.248-3.021-1.337 0-2.65 1.008-2.65 3.08v7.768h-4.51v-14.33h4.338v1.986h.058c.435-.881 1.96-2.387 4.287-2.387 2.517 0 5.236 1.493 5.236 5.868l-.002 8.863z"
        ></path>
        <path
          fill="#fff"
          d="M8.942 26.134h-4.51V11.807h4.51v14.327zM25.567 26.147h-4.509V18.32c0-2.308-.98-3.021-2.248-3.021-1.337 0-2.65 1.008-2.65 3.08v7.768h-4.51v-14.33h4.338v1.986h.058c.435-.881 1.96-2.387 4.287-2.387 2.517 0 5.236 1.493 5.236 5.868l-.002 8.863zM6.683 9.822a2.59 2.59 0 112.604-2.588 2.552 2.552 0 01-2.604 2.588z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_15902_79440">
          <path fill="#fff" d="M0 0H30V30H0z" transform="translate(0 .578)"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export const TwitterPostIcon = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="30"
      // height="31"
      className={className ?? 'h-8 w-8'}
      fill="none"
      viewBox="0 0 30 31"
    >
      <path
        fill="#000"
        d="M22.908 2.958h4.217l-9.213 10.53L28.75 27.815h-8.486l-6.646-8.69-7.606 8.69H1.793l9.854-11.263L1.25 2.958h8.701l6.008 7.943 6.949-7.943zm-1.48 22.333h2.337L8.682 5.35H6.174l15.254 19.942z"
      ></path>
    </svg>
  )
}

export const TwitterBoardIcon = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      fill="none"
      viewBox="0 0 30 31"
    >
      <path
        fill="#000"
        d="M22.908 2.958h4.217l-9.213 10.53L28.75 27.815h-8.486l-6.646-8.69-7.606 8.69H1.793l9.854-11.263L1.25 2.958h8.701l6.008 7.943 6.949-7.943zm-1.48 22.333h2.337L8.682 5.35H6.174l15.254 19.942z"
      ></path>
    </svg>
  )
}

export const BroadcastIcon = ({ className }: any) => {
  return (
    <svg
      viewBox="0 0 50 43"
      className={className ?? 'h-8 w-8 fill-primary-main'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.3502 33.8502C39.2044 32.9959 40.5555 32.9432 41.4719 33.6907L41.6497 33.8502L46.3163 38.5169L46.4758 38.6946C47.2233 39.6111 47.1706 40.9621 46.3163 41.8163C45.4621 42.6706 44.111 42.7233 43.1946 41.9758L43.0168 41.8163L38.3502 37.1497L38.1907 36.9719C37.4432 36.0555 37.4959 34.7045 38.3502 33.8502ZM14.3333 13.609V29.3909L28.3333 36.3909V6.60899L14.3333 13.609ZM46.9999 19.1666C48.2886 19.1666 49.3333 20.2113 49.3333 21.4999C49.3333 22.7886 48.2886 23.8333 46.9999 23.8333H39.9999C38.7113 23.8333 37.6666 22.7886 37.6666 21.4999C37.6666 20.2113 38.7113 19.1666 39.9999 19.1666H46.9999ZM43.1946 1.02403C44.111 0.276546 45.4621 0.329265 46.3163 1.18354C47.1706 2.03781 47.2233 3.38881 46.4758 4.30528L46.3163 4.48301L41.6497 9.14968C40.7384 10.0609 39.2614 10.0609 38.3502 9.14968C37.439 8.23846 37.439 6.76143 38.3502 5.8502L43.0168 1.18354L43.1946 1.02403ZM4.99992 26.1666C4.99992 27.4553 6.04459 28.4999 7.33325 28.4999H9.66658V14.4999H7.33325C6.04459 14.4999 4.99992 15.5446 4.99992 16.8333V26.1666ZM32.9999 36.3909C32.9999 39.7519 29.573 41.9753 26.5377 40.6998L26.246 40.5654L12.246 33.5654C11.8786 33.3817 11.545 33.1507 11.2457 32.8863C10.7519 33.0641 10.2216 33.1666 9.66658 33.1666H7.33325C3.46726 33.1666 0.333252 30.0326 0.333252 26.1666V16.8333C0.333252 12.9673 3.46726 9.83327 7.33325 9.83327H9.66658C10.2213 9.83327 10.7521 9.93366 11.2457 10.1113C11.5447 9.8473 11.8791 9.61798 12.246 9.43451L26.246 2.43451L26.5377 2.30007C29.573 1.02456 32.9999 3.24802 32.9999 6.60899V36.3909Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const HomepageSettingsIcon = ({ className }: any) => {
  return (
    <svg viewBox="0 0 57 57" className={className ?? 'h-8 w-8'} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3979 0.5H35.6021C38.7825 0.499981 41.3119 0.499966 43.3526 0.666699C45.4424 0.837437 47.2243 1.19458 48.8559 2.02591C51.4901 3.36814 53.6319 5.50987 54.9741 8.14413C55.8054 9.77571 56.1626 11.5576 56.3333 13.6473C56.4567 15.1582 56.4888 16.9368 56.4971 19.0492C56.499 19.0881 56.5 19.1273 56.5 19.1667C56.5 19.2004 56.4993 19.234 56.4979 19.2673C56.5 19.9432 56.5 20.6526 56.5 21.3978V35.6022C56.5 38.7826 56.5 41.312 56.3333 43.3526C56.1626 45.4424 55.8054 47.2243 54.9741 48.8559C53.6319 51.4901 51.4901 53.6319 48.8559 54.9741C47.2243 55.8054 45.4424 56.1626 43.3526 56.3333C41.312 56.5 38.7826 56.5 35.6022 56.5H21.3978C18.2174 56.5 15.688 56.5 13.6473 56.3333C11.5576 56.1626 9.77571 55.8054 8.14413 54.9741C5.50987 53.6319 3.36814 51.4901 2.02591 48.8559C1.19458 47.2243 0.837437 45.4424 0.666699 43.3526C0.499966 41.3119 0.499981 38.7825 0.5 35.6021V21.3979C0.499996 20.6527 0.499992 19.9432 0.502133 19.2673C0.500716 19.2339 0.500001 19.2004 0.500001 19.1667C0.500001 19.1273 0.500977 19.0881 0.502906 19.0492C0.511217 16.9368 0.543261 15.1582 0.666699 13.6474C0.837437 11.5576 1.19458 9.77571 2.02591 8.14413C3.36814 5.50986 5.50986 3.36814 8.14413 2.02591C9.77571 1.19458 11.5576 0.837437 13.6474 0.666699C15.6881 0.499966 18.2175 0.499981 21.3979 0.5ZM5.16667 21.5V35.5C5.16667 38.8055 5.16848 41.1442 5.31787 42.9726C5.46503 44.7738 5.74368 45.8732 6.18394 46.7372C7.07876 48.4934 8.50658 49.9212 10.2628 50.8161C11.1268 51.2563 12.2262 51.535 14.0274 51.6821C15.8557 51.8315 18.1945 51.8333 21.5 51.8333H35.5C38.8055 51.8333 41.1442 51.8315 42.9726 51.6821C44.7738 51.535 45.8732 51.2563 46.7372 50.8161C48.4934 49.9212 49.9212 48.4934 50.8161 46.7372C51.2563 45.8732 51.535 44.7738 51.6821 42.9726C51.8315 41.1442 51.8333 38.8055 51.8333 35.5V21.5H5.16667ZM51.8072 16.8333H5.19284C5.21363 15.7682 5.25094 14.8466 5.31787 14.0274C5.46503 12.2262 5.74368 11.1268 6.18394 10.2628C7.07876 8.50658 8.50658 7.07876 10.2628 6.18394C11.1268 5.74368 12.2262 5.46503 14.0274 5.31787C15.8557 5.16848 18.1945 5.16667 21.5 5.16667H35.5C38.8055 5.16667 41.1442 5.16848 42.9726 5.31787C44.7738 5.46503 45.8732 5.74368 46.7372 6.18394C48.4934 7.07876 49.9212 8.50658 50.8161 10.2628C51.2563 11.1268 51.535 12.2262 51.6821 14.0274C51.7491 14.8466 51.7864 15.7682 51.8072 16.8333ZM12.1667 9.83333C13.4553 9.83333 14.5 10.878 14.5 12.1667V12.19C14.5 13.4787 13.4553 14.5233 12.1667 14.5233C10.878 14.5233 9.83333 13.4787 9.83333 12.19V12.1667C9.83333 10.878 10.878 9.83333 12.1667 9.83333ZM19.1667 9.83333C20.4553 9.83333 21.5 10.878 21.5 12.1667V12.19C21.5 13.4787 20.4553 14.5233 19.1667 14.5233C17.878 14.5233 16.8333 13.4787 16.8333 12.19V12.1667C16.8333 10.878 17.878 9.83333 19.1667 9.83333ZM26.1667 9.83333C27.4553 9.83333 28.5 10.878 28.5 12.1667V12.19C28.5 13.4787 27.4553 14.5233 26.1667 14.5233C24.878 14.5233 23.8333 13.4787 23.8333 12.19V12.1667C23.8333 10.878 24.878 9.83333 26.1667 9.83333ZM46.4832 26.8501C47.3945 27.7613 47.3945 29.2387 46.4832 30.1499L35.5321 41.1011C34.3004 42.3327 32.3506 42.4713 30.9572 41.4262L23.8794 36.1179L13.6243 44.322C12.618 45.127 11.1497 44.9639 10.3446 43.9576C9.53962 42.9513 9.70277 41.483 10.709 40.678L21.67 31.9092C22.9163 30.9121 24.6795 30.8846 25.9564 31.8423L32.9477 37.0858L43.1834 26.8501C44.0946 25.9389 45.572 25.9389 46.4832 26.8501Z"
        // fill="#07004D"
      />
    </svg>
  )
}

export const PostEmailIcon = ({ className }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className ?? 'h-8 w-8'}
    fill="none"
    viewBox="0 0 30 31"
  >
    <path d="M15.7646 15H7.76465V17H15.7646V15Z" fill="black" fillOpacity="0.56" />
    <path d="M7.76465 12V14H15.7646V12H7.76465Z" fill="black" fillOpacity="0.56" />
    <path d="M15.7646 9H7.76465V11H15.7646V9Z" fill="black" fillOpacity="0.56" />
    <path
      d="M19.7646 2H17.7646V5H14.7646C14.7746 5.01 14.7646 7 14.7646 7H17.7646V9.99C17.7746 10 19.7646 9.99 19.7646 9.99V7H22.7646V5H19.7646V2Z"
      fill="black"
      fillOpacity="0.56"
    />
    <path
      d="M17.7646 19.22H5.76465V7H12.7646V5H5.76465C4.66465 5 3.76465 5.9 3.76465 7V19C3.76465 20.1 4.66465 21 5.76465 21H17.7646C18.8646 21 19.7646 20.1 19.7646 19V12H17.7646V19.22Z"
      fill="black"
      fillOpacity="0.56"
    />
  </svg>
)

export const ReplyEmailIcon = ({ className, onClick }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className ?? 'h-8 w-8'}
    fill="none"
    onClick={onClick}
    viewBox="0 0 30 31"
  >
    <path
      d="M3.76465 11L9.76465 5V10H16.7646C19.5246 10 21.7646 12.24 21.7646 15V19H19.7646V15C19.7646 13.35 18.4146 12 16.7646 12H9.76465V17L3.76465 11Z"
      fill="black"
      fillOpacity="0.56"
    />
  </svg>
)

export const RegenrateIcon = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="30"
      // height="31"
      className={className ?? 'h-8 w-8'}
      // fill="none"
      viewBox="0 0 22 15"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4312 1.50008C9.4312 1.96032 9.0581 2.33341 8.59786 2.33341C8.13763 2.33341 7.76453 1.96032 7.76453 1.50008C7.76453 1.03984 8.13763 0.666748 8.59786 0.666748C9.0581 0.666748 9.4312 1.03984 9.4312 1.50008ZM3.01899 2.1875C3.05938 2.01632 3.30301 2.01632 3.34341 2.1875L3.77884 4.03277C3.85134 4.34002 4.09125 4.57993 4.39851 4.65243L6.24378 5.08787C6.41495 5.12826 6.41495 5.37189 6.24378 5.41228L4.39851 5.84772C4.09125 5.92022 3.85134 6.16012 3.77884 6.46738L3.34341 8.31266C3.30301 8.48383 3.05938 8.48383 3.01899 8.31266L2.58356 6.46738C2.51106 6.16012 2.27115 5.92022 1.96389 5.84772L0.118622 5.41228C-0.0525615 5.37189 -0.0525615 5.12826 0.118622 5.08787L1.96389 4.65243C2.27115 4.57993 2.51106 4.34002 2.58356 4.03277L3.01899 2.1875ZM9.0257 5.71866C9.12661 5.29069 9.73578 5.29069 9.8367 5.71866L10.5265 8.64193C10.6353 9.10284 10.9951 9.46268 11.456 9.57143L14.3793 10.2613C14.8073 10.3622 14.8073 10.9713 14.3793 11.0723L11.456 11.7621C10.9951 11.8708 10.6353 12.2307 10.5265 12.6916L9.8367 15.6148C9.73578 16.0428 9.12661 16.0428 9.0257 15.6148L8.33586 12.6916C8.22711 12.2307 7.86728 11.8708 7.40636 11.7621L4.4831 11.0723C4.05513 10.9713 4.05513 10.3622 4.4831 10.2613L7.40636 9.57143C7.86728 9.46268 8.22711 9.10284 8.33586 8.64193L9.0257 5.71866Z"
      />
    </svg>
  )
}

export const AttachmentIcon = ({ className }: any) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main cursor-pointer'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="22"
      viewBox="0 0 12 22"
      className={combinedClasses}
    >
      <path
        // fillOpacity="0.56"
        d="M10.265 5v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V4a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V5h-1.5v9.5a2.5 2.5 0 0 0 5 0V4c0-2.21-1.79-4-4-4s-4 1.79-4 4v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V5z"
      ></path>
    </svg>
  )
}

export const AnnouncementHeadingIcon = ({ className }: any) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main cursor-pointer'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      className={combinedClasses}
    >
      <path d="M13.196 2.5H3.863c-.733 0-1.333.6-1.333 1.333v9.334c0 .733.6 1.333 1.333 1.333h9.333c.734 0 1.334-.6 1.334-1.333V3.833c0-.733-.6-1.333-1.334-1.333m-3.333 9.333H5.196V10.5h4.667zm2-2.666H5.196V7.833h6.667zm0-2.667H5.196V5.167h6.667z"></path>
    </svg>
  )
}

export const StopGenerateIcon = ({ className }: any) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main cursor-pointer'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="10"
      // fill="#FFFFFF"
      viewBox="0 0 11 10"
      className={combinedClasses}
    >
      <path d="M.53 0h10v10h-10z"></path>
    </svg>
  )
}

export const RedirectIcon = ({ className }: any) => {
  const combinedClasses = className || 'w-5 h-5 fill-primary-main cursor-pointer'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      fill="none"
      viewBox="0 0 19 18"
      className={combinedClasses}
    >
      <path
        fill="#fff"
        fillOpacity="0.87"
        d="M16.294 16h-14V2h7V0h-7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V9h-2zm-5-16v2h3.59l-9.83 9.83 1.41 1.41 9.83-9.83V7h2V0z"
      ></path>
    </svg>
  )
}

export const NewHomeIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_22518_3906)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9187 6.99921L14.0958 2.68671C12.8596 1.7711 11.1403 1.7711 9.90404 2.68671L4.08114 6.99922C4.07505 7.00363 4.06901 7.00811 4.06302 7.01265L0.40478 9.72199C-0.0390397 10.0507 -0.132363 10.6769 0.196336 11.1208C0.525035 11.5646 1.15128 11.6579 1.5951 11.3292L3.66661 9.79502V18.6724C3.66661 20.5557 5.25544 22 7.11105 22H16.8888C18.7444 22 20.3333 20.5557 20.3333 18.6724V9.79502L22.4048 11.3292C22.8486 11.6579 23.4748 11.5646 23.8035 11.1208C24.1322 10.6769 24.0389 10.0507 23.5951 9.72199L19.9369 7.01267C19.9309 7.00811 19.9248 7.00363 19.9187 6.99921Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_22518_3906">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ContentCommsIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8 22H7.2C6.0799 22 5.51984 22 5.09202 21.782C4.7157 21.5903 4.40974 21.2843 4.21799 20.908C4 20.4802 4 19.9201 4 18.8L4 9L9 9C10.1046 9 11 8.10457 11 7L11 2L16.8 2C17.9201 2 18.4802 2 18.908 2.21798C19.2843 2.40973 19.5903 2.71569 19.782 3.09202C20 3.51984 20 4.07989 20 5.2V18.8C20 19.9201 20 20.4802 19.782 20.908C19.5903 21.2843 19.2843 21.5903 18.908 21.782C18.4802 22 17.9201 22 16.8 22ZM17 13C17 12.4477 16.5523 12 16 12L8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14L16 14C16.5523 14 17 13.5523 17 13ZM16 8C16.5523 8 17 8.44771 17 9C17 9.55229 16.5523 10 16 10H14C13.4477 10 13 9.55229 13 9C13 8.44772 13.4477 8 14 8L16 8ZM17 17C17 16.4477 16.5523 16 16 16L8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H16C16.5523 18 17 17.5523 17 17Z"
        fill="white"
      />
      <path d="M9 3L9 7L5 7L9 3Z" fill="white" />
    </svg>
  )
}

export const SideBarNew1 = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.7696 8.12783L6.06047 6.99741L11.6972 8.27121L17.6281 3.43989L18.5189 4.3054L12.0756 9.53008L5.7696 8.12783Z"
        fill="white"
      />
      <path
        d="M7.73363 7.73651C7.73363 8.69583 6.95594 9.47351 5.99663 9.47351C5.03731 9.47351 4.25963 8.69583 4.25963 7.73651C4.25963 6.77719 5.03731 5.99951 5.99663 5.99951C6.95594 5.99951 7.73363 6.77719 7.73363 7.73651Z"
        fill="white"
      />
      <path
        d="M3.28442 12.6707C3.28442 11.6617 4.10239 10.8438 5.11141 10.8438H6.88184C7.89086 10.8438 8.70883 11.6617 8.70883 12.6707V20.0178C8.70883 21.0268 7.89086 21.8448 6.88184 21.8448H5.11141C4.1024 21.8448 3.28442 21.0268 3.28442 20.0178V12.6707Z"
        fill="#BBBCD8"
      />
      <path
        d="M6.48071 13.0728V19.6157H5.51294V13.0728H6.48071ZM6.48853 7.73682C6.48836 8.00816 6.26772 8.22803 5.99634 8.22803C5.75886 8.22789 5.56065 8.05943 5.51489 7.83545L5.50513 7.73682C5.50513 7.46543 5.72499 7.24478 5.99634 7.24463C6.26782 7.24463 6.48853 7.46534 6.48853 7.73682Z"
        stroke="white"
        strokeWidth="4.45712"
      />
      <path
        d="M13.737 8.89423C13.737 9.85355 12.9594 10.6312 12 10.6312C11.0407 10.6312 10.263 9.85355 10.263 8.89423C10.263 7.93491 11.0407 7.15723 12 7.15723C12.9594 7.15723 13.737 7.93491 13.737 8.89423Z"
        fill="white"
      />
      <path
        d="M9.28784 13.8285C9.28784 12.8194 10.1058 12.0015 11.1148 12.0015H12.8853C13.8943 12.0015 14.7122 12.8194 14.7122 13.8285V20.0175C14.7122 21.0265 13.8943 21.8445 12.8853 21.8445H11.1148C10.1058 21.8445 9.28784 21.0265 9.28784 20.0175V13.8285Z"
        fill="#BBBCD8"
      />
      <path
        d="M12.4841 14.2305V19.6162H11.5164V14.2305H12.4841ZM12.4919 8.89453C12.4918 9.16587 12.2711 9.38574 11.9998 9.38574C11.7623 9.38561 11.5641 9.21715 11.5183 8.99316L11.5085 8.89453C11.5085 8.62315 11.7284 8.4025 11.9998 8.40234C12.2712 8.40234 12.4919 8.62305 12.4919 8.89453Z"
        stroke="white"
        strokeWidth="4.45712"
      />
      <path
        d="M19.7405 4.03436C19.7405 4.99368 18.9628 5.77136 18.0035 5.77136C17.0441 5.77136 16.2665 4.99368 16.2665 4.03436C16.2665 3.07504 17.0441 2.29736 18.0035 2.29736C18.9628 2.29736 19.7405 3.07504 19.7405 4.03436Z"
        fill="white"
      />
      <path
        d="M15.2913 9.19678C15.2913 8.18776 16.1092 7.36979 17.1182 7.36979H18.8887C19.8977 7.36979 20.7157 8.18776 20.7157 9.19678V20.0178C20.7157 21.0268 19.8977 21.8448 18.8887 21.8448H17.1182C16.1092 21.8448 15.2913 21.0268 15.2913 20.0178V9.19678Z"
        fill="#1419AB"
      />
      <path
        d="M18.4875 9.59814V19.6167H17.5198V9.59814H18.4875ZM18.4954 4.03467C18.4952 4.30601 18.2746 4.52588 18.0032 4.52588C17.7657 4.52574 17.5675 4.35728 17.5217 4.1333L17.512 4.03467C17.512 3.76328 17.7318 3.54264 18.0032 3.54248C18.2747 3.54248 18.4954 3.76319 18.4954 4.03467Z"
        stroke="white"
        strokeWidth="4.45712"
      />
    </svg>
  )
}

export const SideBarNew2 = ({ className }: IconProps) => {
  const combinedClasses = className || 'h-9 w-[6.6rem] fill-none'
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5ZM7 8.5C7 7.67157 7.67157 7 8.5 7C9.32843 7 10 7.67157 10 8.5C10 9.32843 9.32843 10 8.5 10C7.67157 10 7 9.32843 7 8.5ZM7.54994 15.3945C8.12973 16.6004 9.26787 18 12 18C14.7321 18 15.8703 16.6004 16.4501 15.3945C16.7593 14.7514 16.2136 14 15.5 14H8.5C7.78642 14 7.24074 14.7514 7.54994 15.3945Z"
        fill="white"
      />
    </svg>
  )
}

export const SideBarNew3 = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.05884 5.61461L10.1709 11.8546C11.2492 12.6841 12.7508 12.6841 13.8291 11.8546L21.9412 5.61461C22 5.98615 22 6.47612 22 7.2V16.8C22 17.9201 22 18.4802 21.782 18.908C21.5903 19.2843 21.2843 19.5903 20.908 19.782C20.4802 20 19.9201 20 18.8 20H5.2C4.0799 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V7.2C2 6.47612 2 5.98615 2.05884 5.61461Z"
      fill="white"
    />
    <path
      d="M3.38065 4.10812C3.77764 4 4.31336 4 5.2 4H18.8C19.6866 4 20.2224 4 20.6194 4.10812L12.6097 10.2694C12.2503 10.5459 11.7497 10.5459 11.3903 10.2694L3.38065 4.10812Z"
      fill="white"
    />
  </svg>
)

export const SideBarNew4 = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L18.7071 6.70711C18.3166 7.09763 17.6834 7.09763 17.2929 6.70711C16.9024 6.31658 16.9024 5.68342 17.2929 5.29289L19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289ZM12.1056 3.82918C13.4354 3.16428 15 4.13127 15 5.61803V18.382C15 19.8687 13.4354 20.8357 12.1056 20.1708L6.10557 17.1708C5.94876 17.0924 5.80533 16.9951 5.67746 16.8823C5.4659 16.9585 5.2378 17 5 17H4C2.34315 17 1 15.6569 1 14V10C1 8.34315 2.34315 7 4 7H5C5.23779 7 5.4659 7.0415 5.67746 7.11765C5.80532 7.00493 5.94876 6.90758 6.10557 6.82918L12.1056 3.82918ZM17 12C17 11.4477 17.4477 11 18 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H18C17.4477 13 17 12.5523 17 12ZM17.2929 18.7071C16.9024 18.3166 16.9024 17.6834 17.2929 17.2929C17.6834 16.9024 18.3166 16.9024 18.7071 17.2929L20.7071 19.2929C21.0976 19.6834 21.0976 20.3166 20.7071 20.7071C20.3166 21.0976 19.6834 21.0976 19.2929 20.7071L17.2929 18.7071Z"
      fill="white"
    />
  </svg>
)

export const CapitalEventsIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L2.5 6.75C2.19 6.9 2 7.22 2 7.56V8.1C2 8.6 2.4 9 2.9 9H21.1C21.6 9 22 8.6 22 8.1V7.56C22 7.22 21.81 6.9 21.5 6.75L12 2Z"
      fill="white"
    />
    <path d="M4.5 10.5H7.5V17.5H4.5V10.5Z" fill="white" />
    <path d="M10.5 10.5H13.5V17.5H10.5V10.5Z" fill="white" />
    <path d="M16.5 10.5H19.5V17.5H16.5V10.5Z" fill="white" />
    <path
      d="M21 19H3C2.44772 19 2 19.4477 2 20V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V20C22 19.4477 21.5523 19 21 19Z"
      fill="white"
    />
  </svg>
)

export const BoardReportsIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z"
      fill="white"
    />
  </svg>
)

export const WeeklyReportsIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM6 17V12H7.6V17H6ZM8.6 17V9H10.2V17H8.6ZM11.2 17V13H12.8V17H11.2ZM13.8 17V8H15.4V17H13.8ZM16.4 17V11H18V17H16.4Z"
      fill="white"
    />
  </svg>
)

export const InvestorQuestionIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 17C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19.0001 12 19.0001C11.4477 19.0001 11 18.5524 11 18.0001C11 17.4478 11.4477 17 12 17ZM9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.3993 14.0411 12.5771 12.7432 12.9075C11.9146 13.1184 11 13.8523 11 15C11 15.5523 11.4477 16 12 16C12.5519 16 12.9994 15.5529 13 15.0012L13.0004 15.0001C13.0022 14.9959 13.009 14.9821 13.0276 14.9621C13.0684 14.9181 13.1427 14.8696 13.2366 14.8457C15.3994 14.2951 17 12.3357 17 10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10Z"
      fill="white"
    />
  </svg>
)

export const NewManageInvestorIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5909 6.59091C16.5909 8.79916 15.5049 10.7538 13.8379 11.9498C15.0085 12.3239 16.0714 12.8658 16.9737 13.5425C18.791 14.9055 20 16.8578 20 19.0909C20 19.593 19.593 20 19.0909 20H0.909091C0.407014 20 0 19.593 0 19.0909C0 16.8578 1.20897 14.9055 3.0263 13.5425C3.92856 12.8658 4.99147 12.3239 6.16212 11.9498C4.49508 10.7538 3.40909 8.79916 3.40909 6.59091C3.40909 2.95085 6.35994 0 10 0C13.6401 0 16.5909 2.95085 16.5909 6.59091Z"
      fill="white"
    />
  </svg>
)

export const NewSettingIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-6 w-6 fill-white'}
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.7588 0C8.23543 0 7.0005 1.23493 7.0005 2.7583C7.0005 3.34202 6.36858 3.70688 5.86303 3.415C4.54375 2.65331 2.85677 3.10531 2.09508 4.4246L0.853406 6.57525C0.091714 7.89454 0.543736 9.58151 1.86303 10.3432C2.36858 10.6351 2.36858 11.3648 1.86302 11.6567C0.543736 12.4184 0.0917129 14.1053 0.853405 15.4246L2.09508 17.5753C2.85677 18.8945 4.54373 19.3466 5.86302 18.5849C6.36853 18.293 7.0005 18.6578 7.0005 19.2416C7.0005 20.765 8.23544 22 9.75885 22H12.2421C13.7655 22 15.0005 20.765 15.0005 19.2416C15.0005 18.6578 15.6325 18.293 16.138 18.5849C17.4573 19.3466 19.1443 18.8945 19.906 17.5752L21.1476 15.4246C21.9093 14.1053 21.4573 12.4184 20.138 11.6567C19.6325 11.3648 19.6325 10.6351 20.138 10.3432C21.4573 9.58151 21.9093 7.89454 21.1476 6.57525L19.906 4.42462C19.1443 3.10532 17.4573 2.65332 16.138 3.41501C15.6324 3.7069 15.0005 3.34203 15.0005 2.75831C15.0005 1.23494 13.7656 0 12.2422 0H9.7588ZM11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7Z"
      // fill="white"
    />
  </svg>
)

export const WebLinkIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9476 4.46919C21.2391 2.76065 18.469 2.76065 16.7604 4.46919L14.698 6.53159C14.1285 7.1011 13.2052 7.1011 12.6356 6.53159C12.0661 5.96207 12.0661 5.03871 12.6356 4.46919L14.698 2.4068C17.5456 -0.440775 22.1624 -0.440775 25.01 2.4068C27.8576 5.25437 27.8576 9.8712 25.01 12.7188L22.9476 14.7812C22.3781 15.3507 21.4547 15.3507 20.8852 14.7812C20.3157 14.2117 20.3157 13.2883 20.8852 12.7188L22.9476 10.6564C24.6562 8.94783 24.6562 6.17774 22.9476 4.46919ZM18.8231 8.59426C19.3926 9.16377 19.3926 10.0871 18.8231 10.6567L10.5735 18.9062C10.004 19.4757 9.08066 19.4757 8.51115 18.9062C7.94163 18.3367 7.94163 17.4134 8.51115 16.8438L16.7607 8.59426C17.3302 8.02474 18.2536 8.02474 18.8231 8.59426ZM6.44846 12.7188C7.01797 13.2883 7.01797 14.2117 6.44846 14.7812L4.38606 16.8436C2.67752 18.5521 2.67752 21.3222 4.38606 23.0307C6.09461 24.7393 8.8647 24.7393 10.5732 23.0307L12.6356 20.9684C13.2052 20.3988 14.1285 20.3988 14.698 20.9684C15.2676 21.5379 15.2676 22.4612 14.698 23.0307L12.6356 25.0931C9.78807 27.9407 5.17124 27.9407 2.32367 25.0931C-0.523905 22.2456 -0.523905 17.6287 2.32367 14.7812L4.38606 12.7188C4.95558 12.1493 5.87894 12.1493 6.44846 12.7188Z"
      fill="#07004D"
    />
  </svg>
)

export const VideoIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="34"
    height="27"
    viewBox="0 0 34 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.1252 11.4172C30.1252 9.75994 30.1246 8.60397 30.0511 7.70447C29.979 6.82193 29.8438 6.31403 29.6481 5.92997C29.2287 5.10715 28.5597 4.43814 27.7369 4.01876C27.3528 3.82307 26.8449 3.68783 25.9624 3.61572C25.0629 3.54226 23.9069 3.54167 22.2496 3.54167H11.7507C10.0934 3.54167 8.93747 3.54226 8.03797 3.61572C7.15543 3.68783 6.64753 3.82307 6.26347 4.01876C5.44064 4.43814 4.77164 5.10715 4.35226 5.92997C4.15657 6.31403 4.02133 6.82193 3.94922 7.70447C3.87576 8.60397 3.87516 9.75994 3.87516 11.4172V16.0828C3.87516 17.7401 3.87576 18.896 3.94922 19.7955C4.02133 20.6781 4.15657 21.186 4.35226 21.57C4.77164 22.3929 5.44064 23.0619 6.26347 23.4812C6.64753 23.6769 7.15543 23.8122 8.03797 23.8843C8.93747 23.9577 10.0934 23.9583 11.7507 23.9583H22.2496C23.9069 23.9583 25.0629 23.9577 25.9624 23.8843C26.8449 23.8122 27.3528 23.6769 27.7369 23.4812C28.5597 23.0619 29.2287 22.3929 29.6481 21.57C29.8438 21.186 29.979 20.6781 30.0511 19.7955C30.1246 18.896 30.1252 17.7401 30.1252 16.0828V11.4172ZM11.896 9.38782C11.8964 6.91949 14.7323 5.61827 16.6384 7.06075L22.402 11.4229C23.9496 12.5945 23.9497 14.9055 22.402 16.0771L16.6384 20.4393C14.7323 21.8817 11.8964 20.5805 11.896 18.1122V9.38782ZM14.8241 9.38355C14.8193 9.38584 14.8153 9.38736 14.8127 9.38924V18.1093C14.8154 18.1113 14.8189 18.114 14.8241 18.1165C14.8394 18.1239 14.8522 18.1254 14.8568 18.125L14.8597 18.1236C14.8605 18.1233 14.8671 18.122 14.8782 18.1136L20.6417 13.7514L20.6432 13.75L20.6417 13.7486L14.8782 9.38639C14.8671 9.378 14.8605 9.37675 14.8597 9.37643L14.8568 9.375C14.8522 9.37465 14.8394 9.37613 14.8241 9.38355ZM33.0418 16.0828C33.0418 17.6922 33.0433 18.9875 32.9578 20.0334C32.871 21.0961 32.6871 22.0295 32.2472 22.8931C31.5481 24.2651 30.4319 25.3812 29.0599 26.0803C28.1963 26.5202 27.2629 26.7042 26.2002 26.791C25.1543 26.8764 23.859 26.875 22.2496 26.875H11.7507C10.1413 26.875 8.846 26.8764 7.80013 26.791C6.73744 26.7042 5.80405 26.5202 4.94043 26.0803C3.56842 25.3812 2.45225 24.2651 1.75318 22.8931C1.31326 22.0295 1.12935 21.0961 1.04252 20.0334C0.957076 18.9875 0.958498 17.6922 0.958498 16.0828V11.4172C0.958498 9.80785 0.957076 8.5125 1.04252 7.46664C1.12935 6.40394 1.31326 5.47055 1.75318 4.60694C2.45225 3.23492 3.56842 2.11876 4.94043 1.41968C5.80405 0.979762 6.73744 0.795852 7.80013 0.709027C8.846 0.62358 10.1413 0.625001 11.7507 0.625001H22.2496C23.859 0.625001 25.1543 0.62358 26.2002 0.709027C27.2629 0.795852 28.1963 0.979762 29.0599 1.41968C30.4319 2.11876 31.5481 3.23492 32.2472 4.60694C32.6871 5.47055 32.871 6.40394 32.9578 7.46664C33.0433 8.5125 33.0418 9.80785 33.0418 11.4172V16.0828Z"
      fill="#07004D"
    />
  </svg>
)

export const AnalyticsIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9478 12.7821H11.2161V3.05036C11.2161 2.77287 10.9929 2.55359 10.7193 2.55359C8.21601 2.55359 5.86027 3.44236 3.99747 4.93849C2.13457 6.4385 0.77426 8.54978 0.242565 10.9946C0.0795637 11.7398 0 12.5102 0 13.2747C0 19.1913 4.80861 24 10.7253 24C16.6324 24 21.4407 19.1914 21.4447 13.2807C21.4447 13.1468 21.3903 13.0226 21.2952 12.9275C21.2002 12.8324 21.0759 12.7821 20.9478 12.7821Z"
      fill="white"
    />
    <path
      d="M20.7948 3.13975C18.7689 1.11774 16.0754 0 13.2091 0C13.079 0 12.951 0.0543376 12.8617 0.14942C12.7666 0.238685 12.7123 0.3687 12.7123 0.496772V10.7253C12.7123 10.9989 12.9354 11.2221 13.2091 11.2221H23.4376C23.7112 11.2221 23.9344 10.9989 23.9344 10.7253C23.9324 7.85919 22.8207 5.16609 20.7948 3.13975Z"
      fill="white"
    />
  </svg>
)

export const AddPdfIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="27"
    height="30"
    viewBox="0 0 27 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.30501 0.708375H17.4443C18.226 0.708348 18.9004 0.708325 19.4555 0.754427C20.0416 0.803098 20.6242 0.910602 21.1831 1.20094C21.9822 1.61602 22.6337 2.26755 23.0488 3.06661C23.3391 3.62554 23.4466 4.20811 23.4953 4.79419C23.5414 5.34932 23.5414 6.02366 23.5413 6.80535V13.8334C23.5413 14.6388 22.8884 15.2917 22.083 15.2917C21.2776 15.2917 20.6247 14.6388 20.6247 13.8334V6.86254C20.6247 6.00756 20.6235 5.45549 20.5886 5.03558C20.5552 4.63311 20.4985 4.48435 20.4605 4.41112C20.3221 4.14477 20.105 3.92759 19.8386 3.78923C19.7654 3.7512 19.6166 3.69451 19.2141 3.66109C18.7942 3.62622 18.2422 3.62504 17.3872 3.62504H6.36218C5.50719 3.62504 4.95513 3.62622 4.53521 3.66109C4.13275 3.69451 3.98398 3.7512 3.91076 3.78923C3.6444 3.92759 3.42723 4.14477 3.28887 4.41112C3.25083 4.48435 3.19414 4.63311 3.16072 5.03558C3.12585 5.45549 3.12468 6.00756 3.12468 6.86254V23.7209C3.12468 24.5759 3.12585 25.1279 3.16072 25.5478C3.19414 25.9503 3.25083 26.0991 3.28887 26.1723C3.42723 26.4387 3.6444 26.6558 3.91076 26.7942C3.98398 26.8322 4.13275 26.8889 4.53521 26.9223C4.95513 26.9572 5.50719 26.9584 6.36218 26.9584H10.4163C11.2218 26.9584 11.8747 27.6113 11.8747 28.4167C11.8747 29.2221 11.2218 29.875 10.4163 29.875H6.30505C5.52333 29.8751 4.84897 29.8751 4.29382 29.829C3.70774 29.7803 3.12518 29.6728 2.56625 29.3825C1.76718 28.9674 1.11566 28.3159 0.700577 27.5168C0.410236 26.9579 0.302732 26.3753 0.254061 25.7892C0.207959 25.2341 0.207982 24.5597 0.208009 23.778V6.80537C0.207982 6.02367 0.207959 5.34933 0.254061 4.79419C0.302732 4.20811 0.410236 3.62554 0.700577 3.06661C1.11566 2.26755 1.76718 1.61602 2.56625 1.20094C3.12518 0.910602 3.70774 0.803098 4.29382 0.754427C4.84896 0.708325 5.52331 0.708348 6.30501 0.708375ZM6.04134 8.00004C6.04134 7.19463 6.69426 6.54171 7.49968 6.54171H16.2497C17.0551 6.54171 17.708 7.19463 17.708 8.00004C17.708 8.80546 17.0551 9.45838 16.2497 9.45838H7.49968C6.69426 9.45838 6.04134 8.80546 6.04134 8.00004ZM6.04134 13.8334C6.04134 13.028 6.69426 12.375 7.49968 12.375H16.2497C17.0551 12.375 17.708 13.028 17.708 13.8334C17.708 14.6388 17.0551 15.2917 16.2497 15.2917H7.49968C6.69426 15.2917 6.04134 14.6388 6.04134 13.8334ZM20.6247 18.2084C21.4301 18.2084 22.083 18.8613 22.083 19.6667V22.5834H24.9998C25.8052 22.5834 26.4582 23.2364 26.4582 24.0418C26.4582 24.8472 25.8052 25.5001 24.9998 25.5001H22.083V28.4166C22.083 29.222 21.4301 29.8749 20.6247 29.8749C19.8193 29.8749 19.1664 29.222 19.1664 28.4166V25.5001H16.2498C15.4444 25.5001 14.7915 24.8472 14.7915 24.0418C14.7915 23.2364 15.4444 22.5834 16.2498 22.5834H19.1664V19.6667C19.1664 18.8613 19.8193 18.2084 20.6247 18.2084ZM6.04134 19.6667C6.04134 18.8613 6.69426 18.2084 7.49968 18.2084H10.4163C11.2218 18.2084 11.8747 18.8613 11.8747 19.6667C11.8747 20.4721 11.2218 21.125 10.4163 21.125H7.49968C6.69426 21.125 6.04134 20.4721 6.04134 19.6667Z"
      fill="#07004D"
    />
  </svg>
)

export const RelaitIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'w-5 h-[22px] fill-none'}
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.72065 6.53818L3.03907 5.30071L9.20964 6.69514L15.7021 1.40631L16.6773 2.35377L9.62387 8.07323L2.72065 6.53818Z"
      fill="#07004D"
    />
    <path
      d="M4.87053 6.1095C4.87053 7.15966 4.01921 8.01099 2.96904 8.01099C1.91888 8.01099 1.06755 7.15966 1.06755 6.1095C1.06755 5.05933 1.91888 4.20801 2.96904 4.20801C4.01921 4.20801 4.87053 5.05933 4.87053 6.1095Z"
      fill="#07004D"
    />
    <path
      d="M0 11.511C0 10.4064 0.89543 9.51099 2 9.51099H3.93808C5.04265 9.51099 5.93808 10.4064 5.93808 11.511V19.5538C5.93808 20.6583 5.04265 21.5538 3.93808 21.5538H2C0.895431 21.5538 0 20.6583 0 19.5538V11.511Z"
      fill="url(#paint0_linear_relait)"
    />
    <path
      d="M11.4424 7.3772C11.4424 8.42736 10.5911 9.27869 9.54094 9.27869C8.49078 9.27869 7.63945 8.42736 7.63945 7.3772C7.63945 6.32703 8.49078 5.47571 9.54094 5.47571C10.5911 5.47571 11.4424 6.32703 11.4424 7.3772Z"
      fill="#07004D"
    />
    <path
      d="M6.5719 12.7787C6.5719 11.6741 7.46733 10.7787 8.5719 10.7787H10.51C11.6146 10.7787 12.51 11.6741 12.51 12.7787V19.5538C12.51 20.6584 11.6146 21.5538 10.51 21.5538H8.5719C7.46733 21.5538 6.5719 20.6584 6.5719 19.5538V12.7787Z"
      fill="url(#paint1_linear_relait)"
    />
    <path
      d="M18.0143 2.05676C18.0143 3.10693 17.163 3.95825 16.1128 3.95825C15.0627 3.95825 14.2114 3.10693 14.2114 2.05676C14.2114 1.0066 15.0627 0.155273 16.1128 0.155273C17.163 0.155273 18.0143 1.0066 18.0143 2.05676Z"
      fill="#07004D"
    />
    <path
      d="M13.1438 7.70805C13.1438 6.60348 14.0392 5.70805 15.1438 5.70805H17.0819C18.1865 5.70805 19.0819 6.60348 19.0819 7.70805V19.5538C19.0819 20.6584 18.1865 21.5538 17.0819 21.5538H15.1438C14.0392 21.5538 13.1438 20.6584 13.1438 19.5538V7.70805Z"
      fill="url(#paint2_linear_relait)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_relait"
        x1="0.371131"
        y1="8.68778"
        x2="13.2195"
        y2="20.6363"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.32" stopColor="#07004D" />
        <stop offset="0.8" stopColor="#ADA0FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_relait"
        x1="6.94303"
        y1="10.0421"
        x2="18.4607"
        y2="22.0133"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.32" stopColor="#07004D" />
        <stop offset="0.8" stopColor="#ADA0FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_relait"
        x1="13.5149"
        y1="4.6249"
        x2="29.4934"
        y2="15.9181"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.32" stopColor="#07004D" />
        <stop offset="0.8" stopColor="#ADA0FF" />
      </linearGradient>
    </defs>
  </svg>
)

export const WriteOwnIcon = ({ className }: IconProps) => (
  <svg
    className={className || 'h-9 w-[6.6rem] fill-none'}
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83301 2.12496C8.83301 1.31954 9.48593 0.666626 10.2913 0.666626H11.7497C12.8702 0.666626 13.8923 1.08787 14.6663 1.78064C15.4404 1.08787 16.4625 0.666626 17.583 0.666626H19.0413C19.8468 0.666626 20.4997 1.31954 20.4997 2.12496C20.4997 2.93037 19.8468 3.58329 19.0413 3.58329H17.583C16.7776 3.58329 16.1247 4.23621 16.1247 5.04163V25.4583C16.1247 26.2637 16.7776 26.9166 17.583 26.9166H19.0413C19.8468 26.9166 20.4997 27.5695 20.4997 28.375C20.4997 29.1804 19.8468 29.8333 19.0413 29.8333H17.583C16.4625 29.8333 15.4404 29.412 14.6663 28.7193C13.8923 29.412 12.8702 29.8333 11.7497 29.8333H10.2913C9.48593 29.8333 8.83301 29.1804 8.83301 28.375C8.83301 27.5695 9.48593 26.9166 10.2913 26.9166H11.7497C12.5551 26.9166 13.208 26.2637 13.208 25.4583V5.04163C13.208 4.23621 12.5551 3.58329 11.7497 3.58329H10.2913C9.48593 3.58329 8.83301 2.93037 8.83301 2.12496ZM6.1518 6.49996L8.83301 6.49996C9.63842 6.49996 10.2913 7.15288 10.2913 7.95829C10.2913 8.76371 9.63842 9.41663 8.83301 9.41663H6.20801C5.3672 9.41663 4.8243 9.41776 4.4111 9.45152C4.01493 9.48389 3.86805 9.53883 3.79594 9.57557C3.52154 9.71539 3.29844 9.93849 3.15863 10.2129C3.12189 10.285 3.06694 10.4319 3.03457 10.8281C3.00081 11.2413 2.99968 11.7842 2.99968 12.625V17.875C2.99968 18.7158 3.00081 19.2587 3.03457 19.6719C3.06694 20.068 3.12189 20.2149 3.15863 20.287C3.29844 20.5614 3.52154 20.7845 3.79594 20.9243C3.86805 20.9611 4.01493 21.016 4.4111 21.0484C4.8243 21.0822 5.3672 21.0833 6.20801 21.0833H8.83301C9.63842 21.0833 10.2913 21.7362 10.2913 22.5416C10.2913 23.347 9.63842 24 8.83301 24H6.15183C5.38306 24 4.71985 24 4.17359 23.9554C3.59705 23.9083 3.02361 23.8043 2.4718 23.5231C1.64859 23.1037 0.979303 22.4344 0.559857 21.6112C0.278699 21.0594 0.174697 20.4859 0.127591 19.9094C0.0829604 19.3631 0.082983 18.6999 0.0830091 17.9312V12.5687C0.082983 11.8 0.0829604 11.1368 0.127591 10.5905C0.174697 10.014 0.278699 9.44055 0.559857 8.88875C0.979303 8.06554 1.64859 7.39625 2.4718 6.97681C3.02361 6.69565 3.59705 6.59165 4.17359 6.54454C4.71985 6.49991 5.38304 6.49993 6.1518 6.49996ZM24.9216 9.45152C24.5084 9.41776 23.9655 9.41663 23.1247 9.41663H20.4997C19.6943 9.41663 19.0413 8.76371 19.0413 7.95829C19.0413 7.15288 19.6943 6.49996 20.4997 6.49996L23.1809 6.49996C23.9496 6.49993 24.6128 6.49991 25.1591 6.54454C25.7356 6.59165 26.3091 6.69565 26.8609 6.97681C27.6841 7.39625 28.3534 8.06554 28.7728 8.88875C29.054 9.44055 29.158 10.014 29.2051 10.5905C29.2497 11.1368 29.2497 11.8 29.2497 12.5687V17.9312C29.2497 18.6999 29.2497 19.3631 29.2051 19.9094C29.158 20.4859 29.054 21.0594 28.7728 21.6112C28.3534 22.4344 27.6841 23.1037 26.8609 23.5231C26.3091 23.8043 25.7356 23.9083 25.1591 23.9554C24.6128 24 23.9496 24 23.1809 24H20.4997C19.6943 24 19.0413 23.347 19.0413 22.5416C19.0413 21.7362 19.6943 21.0833 20.4997 21.0833H23.1247C23.9655 21.0833 24.5084 21.0822 24.9216 21.0484C25.3178 21.016 25.4646 20.9611 25.5367 20.9243C25.8111 20.7845 26.0342 20.5614 26.1741 20.287C26.2108 20.2149 26.2657 20.068 26.2981 19.6719C26.3319 19.2587 26.333 18.7158 26.333 17.875V12.625C26.333 11.7842 26.3319 11.2413 26.2981 10.8281C26.2657 10.4319 26.2108 10.285 26.1741 10.2129C26.0342 9.93848 25.8111 9.71539 25.5367 9.57557C25.4646 9.53883 25.3178 9.48389 24.9216 9.45152Z"
      fill="#07004D"
    />
  </svg>
)

export const SharesHeldIcon = ({ className }: IconProps) => (
  <svg className={className} viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.09935 3C2.27937 3.13922 2.59686 3.30662 3.07359 3.46553C4.03245 3.78515 5.42072 4 7 4C8.57928 4 9.96755 3.78515 10.9264 3.46553C11.4031 3.30662 11.7206 3.13922 11.9006 3C11.7206 2.86078 11.4031 2.69338 10.9264 2.53447C9.96755 2.21485 8.57928 2 7 2C5.42072 2 4.03245 2.21485 3.07359 2.53447C2.59686 2.69338 2.27937 2.86078 2.09935 3ZM12 5.2012C11.8565 5.25904 11.709 5.31285 11.5589 5.3629C10.3462 5.76713 8.73443 6 7 6C5.26557 6 3.65384 5.76713 2.44113 5.3629C2.29098 5.31285 2.14348 5.25904 2 5.2012V6.91233C2.01773 6.93121 2.04625 6.95822 2.09048 6.99308C2.26885 7.13365 2.58893 7.30398 3.07359 7.46553C4.03245 7.78515 5.42072 8 7 8C8.57928 8 9.96755 7.78515 10.9264 7.46553C11.4111 7.30398 11.7311 7.13365 11.9095 6.99308C11.9537 6.95822 11.9823 6.93121 12 6.91233V5.2012ZM12.0259 6.8799C12.0261 6.87991 12.025 6.88214 12.0218 6.88654C12.0241 6.88209 12.0257 6.87988 12.0259 6.8799ZM1.97412 6.8799C1.97434 6.87988 1.97591 6.88209 1.9782 6.88654C1.97504 6.88214 1.9739 6.87991 1.97412 6.8799ZM14 3V6.13673C14.8753 6.29269 15.663 6.51967 16.2943 6.81217C16.711 7.00525 17.1086 7.24924 17.4157 7.56156C17.7267 7.87781 18 8.32522 18 8.8862V12.8862C18 13.6001 17.5651 14.121 17.1475 14.4501C16.7186 14.7881 16.16 15.0488 15.5589 15.2491C15.0929 15.4044 14.5681 15.5345 14 15.6357V18.7725C14 19.4863 13.5651 20.0073 13.1475 20.3364C12.7186 20.6743 12.16 20.935 11.5589 21.1354C10.3462 21.5396 8.73443 21.7725 7 21.7725C5.26557 21.7725 3.65384 21.5396 2.44113 21.1354C1.84 20.935 1.2814 20.6743 0.852536 20.3364C0.434946 20.0073 0 19.4863 0 18.7725V14.7724C0 14.2114 0.273288 13.764 0.584281 13.4478C0.891411 13.1355 1.28899 12.8915 1.70569 12.6984C2.33696 12.4059 3.12472 12.1789 4 12.023V9.74946C3.43192 9.64823 2.90707 9.51821 2.44113 9.3629C1.84 9.16252 1.2814 8.90188 0.852536 8.5639C0.434946 8.2348 0 7.71387 0 7V3C0 2.28613 0.434946 1.7652 0.852536 1.4361C1.2814 1.09812 1.84 0.837479 2.44113 0.637103C3.65384 0.232867 5.26557 0 7 0C8.73443 0 10.3462 0.232867 11.5589 0.637103C12.16 0.837479 12.7186 1.09812 13.1475 1.4361C13.5651 1.7652 14 2.28613 14 3ZM6 11.0874V12.7986C6.01773 12.8174 6.04625 12.8445 6.09048 12.8793C6.26885 13.0199 6.58893 13.1902 7.07359 13.3518C8.03245 13.6714 9.42072 13.8862 11 13.8862C12.5793 13.8862 13.9675 13.6714 14.9264 13.3518C15.4111 13.1902 15.7311 13.0199 15.9095 12.8793C15.9537 12.8445 15.9823 12.8174 16 12.7986V11.0874C15.8565 11.1452 15.709 11.199 15.5589 11.2491C14.3462 11.6533 12.7344 11.8862 11 11.8862C9.26557 11.8862 7.65384 11.6533 6.44113 11.2491C6.29098 11.199 6.14348 11.1452 6 11.0874ZM16.0218 8.77274C16.0241 8.76828 16.0257 8.76608 16.0259 8.76609C16.0261 8.7661 16.025 8.76833 16.0218 8.77274ZM15.9007 8.88618C15.7206 9.02541 15.4032 9.19281 14.9264 9.35173C13.9675 9.67135 12.5793 9.8862 11 9.8862C10.4922 9.8862 10.0041 9.86398 9.54367 9.82321C10.2883 9.71479 10.9705 9.55901 11.5589 9.3629C12.16 9.16252 12.7186 8.90188 13.1475 8.5639C13.3081 8.43734 13.4712 8.2824 13.6112 8.09903C14.3794 8.23337 15.0073 8.42011 15.4535 8.62683C15.6625 8.72369 15.8067 8.81356 15.9007 8.88618ZM5.97411 8.76609C5.97433 8.76608 5.97591 8.76828 5.9782 8.77274C5.97504 8.76833 5.9739 8.76611 5.97411 8.76609ZM16.0259 12.7661C16.0261 12.7661 16.025 12.7684 16.0218 12.7728C16.0241 12.7683 16.0257 12.7661 16.0259 12.7661ZM5.97412 12.7661C5.97434 12.7661 5.97592 12.7683 5.9782 12.7728C5.97504 12.7684 5.9739 12.7661 5.97412 12.7661ZM4.38878 13.9853C3.62059 14.1196 2.99267 14.3063 2.54652 14.5131C2.33748 14.6099 2.19329 14.6998 2.09934 14.7724C2.27935 14.9116 2.59685 15.079 3.07359 15.238C4.03245 15.5576 5.42072 15.7724 7 15.7724C7.50784 15.7724 7.99592 15.7502 8.45633 15.7094C7.71172 15.601 7.02947 15.4452 6.44113 15.2491C5.84 15.0488 5.2814 14.7881 4.85254 14.4501C4.69194 14.3236 4.52878 14.1686 4.38878 13.9853ZM12 16.9736C11.8565 17.0315 11.709 17.0853 11.5589 17.1353C10.3462 17.5396 8.73443 17.7724 7 17.7724C5.26557 17.7724 3.65384 17.5396 2.44113 17.1353C2.29098 17.0853 2.14348 17.0315 2 16.9736V18.6848C2.01773 18.7037 2.04625 18.7307 2.09048 18.7655C2.26885 18.9061 2.58893 19.0764 3.07359 19.238C4.03245 19.5576 5.42072 19.7725 7 19.7725C8.57928 19.7725 9.96755 19.5576 10.9264 19.238C11.4111 19.0764 11.7311 18.9061 11.9095 18.7655C11.9537 18.7307 11.9823 18.7037 12 18.6848V16.9736ZM12.0259 18.6524C12.0261 18.6524 12.025 18.6546 12.0218 18.659C12.0241 18.6545 12.0257 18.6523 12.0259 18.6524ZM1.97412 18.6524C1.97433 18.6523 1.97591 18.6545 1.97819 18.659C1.97504 18.6546 1.9739 18.6524 1.97412 18.6524ZM1.97412 14.6523C1.97434 14.6523 1.97591 14.6545 1.9782 14.659C1.97504 14.6546 1.9739 14.6523 1.97412 14.6523ZM12.0218 14.659C12.0241 14.6545 12.0257 14.6523 12.0259 14.6523C12.0261 14.6523 12.025 14.6546 12.0218 14.659ZM12.0218 2.88654C12.0241 2.88209 12.0257 2.87988 12.0259 2.8799C12.0261 2.87991 12.025 2.88214 12.0218 2.88654ZM1.9782 2.88654C1.97504 2.88214 1.9739 2.87991 1.97412 2.8799C1.97433 2.87988 1.97591 2.88209 1.9782 2.88654Z"
      fill="currentColor"
    />
  </svg>
)

export const CurrentValueIcon = ({ className }: IconProps) => (
  <svg className={className} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 18.9C15.1392 18.9 18.9 15.1392 18.9 10.5C18.9 5.86081 15.1392 2.1 10.5 2.1C5.86081 2.1 2.1 5.86081 2.1 10.5C2.1 15.1392 5.86081 18.9 10.5 18.9ZM10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4998 3.89234C11.0521 3.89234 11.4998 4.34005 11.4998 4.89234V5.03559C13.1484 5.21805 14.5295 6.53031 14.5295 8.2569C14.5295 8.80918 14.0817 9.2569 13.5295 9.2569C12.9772 9.2569 12.5295 8.80918 12.5295 8.2569C12.5295 7.74164 12.1342 7.21721 11.4998 7.06067V9.52168C13.1484 9.70413 14.5295 11.0164 14.5295 12.743C14.5295 14.4696 13.1484 15.7818 11.4998 15.9643V16.1075C11.4998 16.6598 11.0521 17.1075 10.4998 17.1075C9.94756 17.1075 9.49984 16.6598 9.49984 16.1075V15.9643C7.85124 15.7818 6.47022 14.4696 6.47022 12.743C6.47022 12.1907 6.91793 11.743 7.47022 11.743C8.0225 11.743 8.47022 12.1907 8.47022 12.743C8.47022 13.2582 8.86547 13.7827 9.49984 13.9392V11.4782C7.85124 11.2957 6.47022 9.98349 6.47022 8.2569C6.47022 6.53031 7.85124 5.21805 9.49984 5.03559V4.89234C9.49984 4.34005 9.94756 3.89234 10.4998 3.89234ZM9.49984 7.06067C8.86547 7.21721 8.47022 7.74164 8.47022 8.2569C8.47022 8.77216 8.86547 9.29659 9.49984 9.45313V7.06067ZM11.4998 11.5468V13.9392C12.1342 13.7827 12.5295 13.2582 12.5295 12.743C12.5295 12.2277 12.1342 11.7033 11.4998 11.5468Z"
      fill="currentColor"
    />
  </svg>
)

export const FilterIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-6 h-6 fill-none'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 24 24">
      <g>
        <path
          fill="#000"
          fillOpacity="0.6"
          d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
        ></path>
      </g>
    </svg>
  )
}

export const StatsIcon = ({ className }: IconProps) => {
  const combinedClasses = className || 'w-5 h-5 fill-none'
  return (
    <svg className={combinedClasses} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.91658 9.16667L3.33325 7.5L4.99992 7.08333L3.33325 6.66667L2.91658 5L2.49992 6.66667L0.833252 7.08333L2.49992 7.5L2.91658 9.16667Z"
        fill="black"
        fillOpacity="0.56"
      />
      <path
        d="M12.4999 7.5L13.2833 5.775L14.9999 5L13.2833 4.225L12.4999 2.5L11.7333 4.225L9.99992 5L11.7333 5.775L12.4999 7.5Z"
        fill="black"
        fillOpacity="0.56"
      />
      <path
        d="M17.4999 6.66667C16.2916 6.66667 15.6166 7.86667 15.8916 8.75833L12.9333 11.725C12.6833 11.65 12.3166 11.65 12.0666 11.725L9.94158 9.6C10.2249 8.70833 9.54992 7.5 8.33325 7.5C7.12492 7.5 6.44158 8.7 6.72492 9.6L2.92492 13.3917C2.03325 13.1167 0.833252 13.7917 0.833252 15C0.833252 15.9167 1.58325 16.6667 2.49992 16.6667C3.70825 16.6667 4.38325 15.4667 4.10825 14.575L7.89992 10.775C8.14992 10.85 8.51658 10.85 8.76658 10.775L10.8916 12.9C10.6083 13.7917 11.2833 15 12.4999 15C13.7083 15 14.3916 13.8 14.1083 12.9L17.0749 9.94167C17.9666 10.2167 19.1666 9.54167 19.1666 8.33333C19.1666 7.41667 18.4166 6.66667 17.4999 6.66667Z"
        fill="black"
        fillOpacity="0.56"
      />
    </svg>
  )
}
